<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [{
            "num_cand": "U2FsdGVkX18biSgSS4LeNBmg2fGpE5RMPh3ij0ExkEE=",
            "cpf": "U2FsdGVkX19dBvAzuH/1+lzM2rBq0eOkMUKjsvF0f6A="
          }, {
            "num_cand": "U2FsdGVkX1+UnGR4fmyUTHXBtaEaWNpvWPXkqQ9Bk20=",
            "cpf": "U2FsdGVkX18A91QbMjVKOxXT8rZhXLIurEx12rLcx0U="
          }, {
            "num_cand": "U2FsdGVkX18axKbnZgx8oM1V7BaCH1oLjbmTQdhUqu4=",
            "cpf": "U2FsdGVkX1+YDyBcMKXrbD5uNQMYtV197Zqp5E3eJSM="
          }, {
            "num_cand": "U2FsdGVkX180ySJitVZ2krtcqLWdiybNkyXo2RiOP9s=",
            "cpf": "U2FsdGVkX1/IVLVHZjBV3M7uUxh8jWLimTbVjkzsFKI="
          }, {
            "num_cand": "U2FsdGVkX1/YlqmFGvVz9komZCq5pWltxFB0rTBof7k=",
            "cpf": "U2FsdGVkX1/zvY/5gQA7VOW+oOyyBf8OpASD+RS6iEM="
          }, {
            "num_cand": "U2FsdGVkX19H9KriaAv7J521DTiAm7fZUf/OpdUgkoY=",
            "cpf": "U2FsdGVkX1/bQo5C4KTRKTVvVYlhLg83oNGFsCSHojg="
          }, {
            "num_cand": "U2FsdGVkX19tb4oLc56MVz4aC+BK4wgTcmb1Sz9BRnc=",
            "cpf": "U2FsdGVkX19lyi9wPBC67TPdTmCVhV2nuAIGnSiPogo="
          }, {
            "num_cand": "U2FsdGVkX18Qx5PZXZZE3O8JVmXu9ae/2UDXmPmOTOc=",
            "cpf": "U2FsdGVkX19w4H7JU03u3kzl1R9u1e8WOzJG7Bi2xME="
          }, {
            "num_cand": "U2FsdGVkX1/taeA9XLdqVlXGRZnO/gaAam0l1JGJNFA=",
            "cpf": "U2FsdGVkX18mQCMGHWEqmhAN0BYCmCjR2MFRwCwxWzs="
          }, {
            "num_cand": "U2FsdGVkX18nkqzSzVLvtVJ0133DJkb6sKLq4WyWh7Y=",
            "cpf": "U2FsdGVkX1+OoKMC9Q24r+m+GZ3BRBaO++SvGCCiarQ="
          }, {
            "num_cand": "U2FsdGVkX19UiCcON/PK3QQJ2Y1T1iYLvhZN7i3hl6I=",
            "cpf": "U2FsdGVkX19ayeEGbWvOLCxZbnljHYA7mcr19o765I4="
          }, {
            "num_cand": "U2FsdGVkX18K62SeIwu4XsTw26STF7neKh8In/ja9IQ=",
            "cpf": "U2FsdGVkX1+5X6UTiqkooDpJnjsPkTchd5tT5vUDdBk="
          }, {
            "num_cand": "U2FsdGVkX1/Ji4J6M4NyZuUKVO3IowxsH2bChmNRiUc=",
            "cpf": "U2FsdGVkX1+m+XI710Hno8Kbp7ASH70Zq3hII9VuKBU="
          }, {
            "num_cand": "U2FsdGVkX1/5Ah+RRxLu8bcv3ClCkZjU7gz/hIzdNjU=",
            "cpf": "U2FsdGVkX19qASqZhNbBvBqBDfDpTr5l+nEEFZOE9N4="
          }, {
            "num_cand": "U2FsdGVkX18trwdh6NG3b7NedqqK0Jr52fG1NtevCUI=",
            "cpf": "U2FsdGVkX1+9ZQPH5hVyYM90itlAtAfRPM8Km0oYrc8="
          }, {
            "num_cand": "U2FsdGVkX19XkAnaWXf7m6x9e2c/U3krLfBengYWi74=",
            "cpf": "U2FsdGVkX1/6tmfHgismsjNekOrhJHHFbppgSvFKZRA="
          }, {
            "num_cand": "U2FsdGVkX185X7ITCLlJy8cM9NlJbtV2SdHlE1E9/x4=",
            "cpf": "U2FsdGVkX196RGcJk5a0B8QVkG3OzX6XIhnum4+pENM="
          }, {
            "num_cand": "U2FsdGVkX19ju+/PDLGdXjrCU6i+D6Ml0yfycGcmW8I=",
            "cpf": "U2FsdGVkX1/JSY/W0ZUaJLC+XmcoLgDe+rknjFbHAjc="
          }, {
            "num_cand": "U2FsdGVkX18uEmj95AXeVSFwlxwZ3Nz2/EGajABnpPk=",
            "cpf": "U2FsdGVkX19/+8HCiN57NT+51yEyI1SC0+enEekryGI="
          }, {
            "num_cand": "U2FsdGVkX1+HyjzDeDxE8+oOK55UWXNGwyNzr7/Iet0=",
            "cpf": "U2FsdGVkX19Q1hhcj7HOhGPSZt6zI+DdvMsW3RNZSfI="
          }, {
            "num_cand": "U2FsdGVkX1/jjC5R/TuZ8tGVLd8T+9bof0PXfM8MTFM=",
            "cpf": "U2FsdGVkX18DwCXzxPYB+fzTLxDAqomB7j/pNRNueVY="
          }, {
            "num_cand": "U2FsdGVkX18mgG7avx8dtqBpzePR4JwQCMu2RYa5se0=",
            "cpf": "U2FsdGVkX18E8CnDieLZYPmmrYFBEZTp7bHQFobczhU="
          }, {
            "num_cand": "U2FsdGVkX19fC9TgX+PlLmLAoLXdDuC1oH3KPcD7FWM=",
            "cpf": "U2FsdGVkX19G5nHZLwFUsGgorki7LX9ae5mGCgYhrjg="
          }, {
            "num_cand": "U2FsdGVkX1+ReiDcYLk+WsKs9quhOdNJwLT39fEqD3g=",
            "cpf": "U2FsdGVkX18b19ECjxklgU3evK/D2w89wZkHcgtrJ0I="
          }, {
            "num_cand": "U2FsdGVkX1/tbQyPxzXUZNZImo5vCR4WOA4SA343MJI=",
            "cpf": "U2FsdGVkX1/moBY54PVNw10UQ5S6T5sU97ysG3W7L+0="
          }, {
            "num_cand": "U2FsdGVkX19Y+URKb6jXKhiGRffTMo9RXSMUj3BXWdw=",
            "cpf": "U2FsdGVkX1/nlbiGRY8/rC02cJEg4uLiF2Vi9/vr8LQ="
          }, {
            "num_cand": "U2FsdGVkX1+rv0hWIccutUgT1PlzbfYztL8WBjFWEY4=",
            "cpf": "U2FsdGVkX1+3uDUNYxASYG277vP/yFkx/iRGvF1MzeM="
          }, {
            "num_cand": "U2FsdGVkX1/0jpVx6uGmV2CSLuuVV8BKKOPaf+Fs9Dw=",
            "cpf": "U2FsdGVkX18TL+uLNdAMY/vhh11MU14nQ/qHUxK9VfE="
          }, {
            "num_cand": "U2FsdGVkX18otYuS2R/BlzwQywb/HRC6Lvz32oAfRYI=",
            "cpf": "U2FsdGVkX18SFPaq4wzStVyQFk2jtJklK5XjlZ2+mgY="
          }, {
            "num_cand": "U2FsdGVkX19jleUHzgDlxuKe8i3mws6S/2114h4LE9g=",
            "cpf": "U2FsdGVkX181dyBtBzwulZBiR9NRaP9nzioD1OjoOTQ="
          }, {
            "num_cand": "U2FsdGVkX1/Ly+7VBKBNACVXgFkSgFmdLuxajYpeKgo=",
            "cpf": "U2FsdGVkX1+G6YNFb6/4Q3pUHvPTCiaVXYFPQwf8wLs="
          }, {
            "num_cand": "U2FsdGVkX18FOxGWYJmNPYE4pmO8sNvsY3hkXckF2so=",
            "cpf": "U2FsdGVkX1+HHuIDC1EBACdccNDIALUyRX3vQ95SSM0="
          }, {
            "num_cand": "U2FsdGVkX18wJeVqwYhfq5oRVg14fMu9eUGGDQSAeNI=",
            "cpf": "U2FsdGVkX1+do7/wLqxtURaNw2ORL97/d4yMCyI0q5Q="
          }, {
            "num_cand": "U2FsdGVkX18gADcHWW9UORJWI+HdSRkZmHByZfW8ggw=",
            "cpf": "U2FsdGVkX1/sQIQZ7KgsLbUIVVbQmahvqortk6NuFyE="
          }, {
            "num_cand": "U2FsdGVkX1+S4cisnS8Y1Hh2hE51yjEyZBiy4SltLCQ=",
            "cpf": "U2FsdGVkX18UexvpuC6P/ey9zO8muNsSrqg1PKUapqM="
          }, {
            "num_cand": "U2FsdGVkX192QjWlog/ITZUeJ0E6NB2tJxWu9Tml//U=",
            "cpf": "U2FsdGVkX1/NTF+06LGEwbAnvkXtVRSGdSPS66Qy6rY="
          }, {
            "num_cand": "U2FsdGVkX19tqoEQqjSeimqeedJHWNnohUEVFGIJ4Ro=",
            "cpf": "U2FsdGVkX1/VGYN+nI4Ms3nUhBTSVaUbL0CHsdEz8+Y="
          }, {
            "num_cand": "U2FsdGVkX19N0NUlfptYuTAaq80pcbiOWK/zTjI/pX8=",
            "cpf": "U2FsdGVkX1+q/YHMinlc8DVOzTRC9I9ppY6fLvRV3jI="
          }, {
            "num_cand": "U2FsdGVkX189OAUqUpFFJpIx3tardndsRF8m+OpnOCQ=",
            "cpf": "U2FsdGVkX18L5Y/Dy1byC+jsH8zCGX6B9esMrXwiYus="
          }, {
            "num_cand": "U2FsdGVkX189gmF0j20N+lnMO+bV741MCD95RkX6a3s=",
            "cpf": "U2FsdGVkX18fr83FcHE/Gz4XET7SVA1xvxXKvwsD3cQ="
          }, {
            "num_cand": "U2FsdGVkX1/guQT7Kb72hvIi/X2Mr53J0nIeUOpeP2M=",
            "cpf": "U2FsdGVkX19DCILcCLaV6kdFrM2Yhh3SPwMoIi/kG4k="
          }, {
            "num_cand": "U2FsdGVkX1/Mkgs8z3KOppZteZd0fTYXKYs9gsFD53g=",
            "cpf": "U2FsdGVkX1+xuGx6hk2ZYVhgC8ilIbDPpQXyTWeMSFI="
          }, {
            "num_cand": "U2FsdGVkX1+OuHFEo3nVT5SNGGV3ICE0e0sGx4DRHZs=",
            "cpf": "U2FsdGVkX18c9tFo/f5h7gO6EDULl2SPo/fYD66iAc4="
          }, {
            "num_cand": "U2FsdGVkX19VHUG/Hi+OJa7GSXxJ4Nw+WqI21Tt6+aI=",
            "cpf": "U2FsdGVkX1/yYFw2blrY3PKPf1hQ9LWZKIU9pJFTD74="
          }, {
            "num_cand": "U2FsdGVkX1/bGF15w/KQvM17umYNBeKj+wJJrVo8WEk=",
            "cpf": "U2FsdGVkX19vTilTWu1mDV5qHsukW0bGN0c4FSXebqk="
          }, {
            "num_cand": "U2FsdGVkX18GF73/s+7F2h/bPaTw6A1JbNSMwY2MjX0=",
            "cpf": "U2FsdGVkX1+T025PQ4157OtYK8hgnJGMvX4O1Lt+e5k="
          }, {
            "num_cand": "U2FsdGVkX19s97cbvHbftC2zDnjXtpQArsbYvySfxEk=",
            "cpf": "U2FsdGVkX1+/CphTj0yS0kNxfeumkqfGPwhji5oxLY0="
          }, {
            "num_cand": "U2FsdGVkX1/JduY5KSN5bgPaqCiLpF9skU7LhrPuLRc=",
            "cpf": "U2FsdGVkX1+MmUKPrFDltrtYdDOYypeSGTtZi06cJp0="
          }, {
            "num_cand": "U2FsdGVkX1/JDW3GZgKa6QSo26VJpwj1TQNrxRSiY3I=",
            "cpf": "U2FsdGVkX18lvUkEkbFf4lc9tB+DOetwumUpfzp0k2A="
          }, {
            "num_cand": "U2FsdGVkX1/8pqFEP/BP8vlxjtZVuDxUm8vwuoU76D8=",
            "cpf": "U2FsdGVkX1/TFGCkfLJJrXzBO1I7x2mi3wzhxLIG0uA="
          }, {
            "num_cand": "U2FsdGVkX1/mmfywv4R+bUbHao27fg1A9ievUeHYPMU=",
            "cpf": "U2FsdGVkX19NfsMVcQYHKRY+C65/SdJzfe+EdPGZEwA="
          }, {
            "num_cand": "U2FsdGVkX18Ru1Tgx3cD5Uzzvkj28GfXXVpnm7U8eA0=",
            "cpf": "U2FsdGVkX1+JViHAVZzWnB9gXygRBmDy+X4JoLGZQBQ="
          }, {
            "num_cand": "U2FsdGVkX18d6turMdfb9goo0I6XFa6X74E8m5KNJmI=",
            "cpf": "U2FsdGVkX1+0KE7Lxjg/JYq4NHEKlR4eHtLo6qX9/BA="
          }, {
            "num_cand": "U2FsdGVkX1/ziuQlZLB79Brv3EKr7alyOgF2Q13oCsU=",
            "cpf": "U2FsdGVkX18lylzOs7d19+EmE+//N5Cp7TYk7+OTCs4="
          }, {
            "num_cand": "U2FsdGVkX1+T7C+oV1pMN9MGr8UbTN7qjKphNMVwmD4=",
            "cpf": "U2FsdGVkX18dD/hGoxvmI8Y++uwY0Utia6UZc8x59zA="
          }, {
            "num_cand": "U2FsdGVkX18OkpsTvJgDH9NveRVBEQC+LgT6cUm9Aac=",
            "cpf": "U2FsdGVkX1+Wc9KOtxmRbxTUUazRY/WljN3QRMwqHZ4="
          }, {
            "num_cand": "U2FsdGVkX1+g8U6VtLz1eEnopSx78IgOauaUkVEq770=",
            "cpf": "U2FsdGVkX18dFakEilXoF+GDYG6O9OTV7oRYyRXpg9o="
          }, {
            "num_cand": "U2FsdGVkX19ZIGDzhsLGsQ1viuDOtzsPfpgW7FHTWNQ=",
            "cpf": "U2FsdGVkX18cNWKb6rb7syEms6nd2Kdt5Xeb33smZ4A="
          }, {
            "num_cand": "U2FsdGVkX1+j1jT01FQDj1f8xTmnqKLaWzYEBMNy3ls=",
            "cpf": "U2FsdGVkX1/5PJU1x9+APfj6IxciQMWBKl9TbogarJM="
          }, {
            "num_cand": "U2FsdGVkX1+shJ+ubkg20T0rUNMU1xJiBrBM3AjB0QM=",
            "cpf": "U2FsdGVkX19x7pk9zfS+oM4gaS+BZ51ZL/0d1755ad8="
          }, {
            "num_cand": "U2FsdGVkX1/emGPkHo8QRFGAZhoiPUdwRCAzLc/t6uM=",
            "cpf": "U2FsdGVkX1/2U0LJc8I8ZafJHz8gD9v5SH01/WAzSCo="
          }, {
            "num_cand": "U2FsdGVkX1/6yfxjLO6/nq4BYW+ogrZlkNq5HFpazNE=",
            "cpf": "U2FsdGVkX1+3s4o70Tyf4ycBVD3I1c0JZllt62ELtjk="
          }, {
            "num_cand": "U2FsdGVkX1/DjoRw2NpIuYZZt9Vh4SFqrcNTckBK9mk=",
            "cpf": "U2FsdGVkX19tQ+giyhUmwXoM5yMKqQnPEo08yUE6K2U="
          }, {
            "num_cand": "U2FsdGVkX19IEJg3pz87Fqftu8czGaQFQmR2c4woCz4=",
            "cpf": "U2FsdGVkX19j5SLYVVUpIR0LFsDyoTywSf/Zm9O5OS8="
          }, {
            "num_cand": "U2FsdGVkX197Qd1VlW8n1nHEMaEwlRmxIhBCsKAeGKU=",
            "cpf": "U2FsdGVkX18WIgdpsB/Yrw0tKpLTWPTp1q8k6rn0zas="
          }, {
            "num_cand": "U2FsdGVkX19FP1PxbiVwexfT8dVqwwgmXzX/pGqzOJk=",
            "cpf": "U2FsdGVkX1+YWthkj9p33NAoRPeqdfJWWQ4u6pwub9s="
          }, {
            "num_cand": "U2FsdGVkX1+YeW8BasOPsbnraz/v1VZjECMVuwApds8=",
            "cpf": "U2FsdGVkX1++NY7MlGmFXa9MaWzsrvOazf0tjXOyfeQ="
          }, {
            "num_cand": "U2FsdGVkX1+zaxu8flTrKH+9g974F83vOitr0ZoccME=",
            "cpf": "U2FsdGVkX1+xJjkjeobwgonL9TZujMrafkxJAcEIDAU="
          }, {
            "num_cand": "U2FsdGVkX1/WSay4+DulGWZdi/BKqC9MSMXdJv32R2Q=",
            "cpf": "U2FsdGVkX19jsu0YajSO+MGuF30KBnQ/4tunVzgX4wI="
          }, {
            "num_cand": "U2FsdGVkX1/BQlg+H8w4ghl/08sjKl0c+iS4AH1fbqA=",
            "cpf": "U2FsdGVkX1/rpgBM11SXTAYa+noq+sb7dQedIQ9aphk="
          }, {
            "num_cand": "U2FsdGVkX18QY43KKo+T8fDd5fb26D2vUExE6xACuLk=",
            "cpf": "U2FsdGVkX19rwBEuh0WFN9E16Z+0CZmzf2UTtGffpGU="
          }, {
            "num_cand": "U2FsdGVkX1+5T0hzHE02lx7oulAxdPMByAGuNjaFQBs=",
            "cpf": "U2FsdGVkX1/mhKPUAXCf8nCF/Xvxrus5sy7inqGl5wg="
          }, {
            "num_cand": "U2FsdGVkX1/rJkmGKD6ifdqm94/L58ssB3sWe+eG8lM=",
            "cpf": "U2FsdGVkX18RoomWtt+Crk626LT+/YSfKkZPavxqNjo="
          }, {
            "num_cand": "U2FsdGVkX1+AfgRkM7+HivXuZozBe46C8E6Kj9XfqQY=",
            "cpf": "U2FsdGVkX1/WwCTxufvcchGSOiVtUpJ6vp3OXNT0gy0="
          }, {
            "num_cand": "U2FsdGVkX1+ez+PP6icCtPw3drdxsfmRMaU3+HicdoM=",
            "cpf": "U2FsdGVkX1/AcSHl6fmp3Y8QnDt3oPymwniaTzCxgno="
          }, {
            "num_cand": "U2FsdGVkX18r9SxsCQwVwqh+rtFtVwpjf9ocN6tHGsE=",
            "cpf": "U2FsdGVkX19H+ddMUl47Qi6EEJQRdn8Q8AYFngqe5GY="
          }, {
            "num_cand": "U2FsdGVkX18whN8nJX3Np4+YQ3cpo6xw0yWgLTEqqpM=",
            "cpf": "U2FsdGVkX18+yDZNmvOEcjot1brEuwTaB+u6TouS8Jw="
          }, {
            "num_cand": "U2FsdGVkX1+pxctLWD902SPMnLvD0zMB2bvs9x8gfM8=",
            "cpf": "U2FsdGVkX1/uCbdebX0okXwnzRdDmq1MwyUf4/w94S0="
          }, {
            "num_cand": "U2FsdGVkX1/k0aUmySiNZwhMNg9Am9cY8bD0RAiiYpQ=",
            "cpf": "U2FsdGVkX19bk/XXcD1bkbM4drBpOPvRC583yhvZeHY="
          }, {
            "num_cand": "U2FsdGVkX18M7wpuvy8c+diugtUaLeyFgXBOBx2CYfI=",
            "cpf": "U2FsdGVkX1+eFt9Pt6wePU6bZrDOyuODWwZHYuWcfJk="
          }, {
            "num_cand": "U2FsdGVkX19SGmX+Nhfe2qjCMx8X29yWCF1gNW8ggs0=",
            "cpf": "U2FsdGVkX1/41nc8w5PlA5oFqQAoeYjmD86lErRQSwQ="
          }, {
            "num_cand": "U2FsdGVkX1+qV6Ev1dmPGUxSUd+jC12fs2hzX56WFa0=",
            "cpf": "U2FsdGVkX1/pAtkEPT6okmpufULp8ZghuqPVPTr0LV4="
          }, {
            "num_cand": "U2FsdGVkX18mBnVmn5FuWKXNdMgCc5yHo09bWm9Sey0=",
            "cpf": "U2FsdGVkX19mw3s+MifJQbFHCOzG5XiGaQR1SBTgBW0="
          }, {
            "num_cand": "U2FsdGVkX1/rrdBRvssBo+At43d9hm8zTDkKgUV7wDI=",
            "cpf": "U2FsdGVkX19C90Ig/c78Nx42PJcIHE2BCKO/5LNA/BM="
          }, {
            "num_cand": "U2FsdGVkX186Qr1B4UN0S0ylnBaADpEhugstRgYKxFo=",
            "cpf": "U2FsdGVkX1/ZO3s93YM1PJY6Ai6q7c1qQcMYooCc7iQ="
          }, {
            "num_cand": "U2FsdGVkX18yRI0/OwMMq9m5/ldsUkYEa3PqCsZKWSc=",
            "cpf": "U2FsdGVkX1/ew+LqLSuvQAoAYDCkgk2cIAeqSuGv9M0="
          }, {
            "num_cand": "U2FsdGVkX18HeyFsaop8MH0vaVlj/ZVT+zrlaR+geWI=",
            "cpf": "U2FsdGVkX1+iPmvrNO51naC+Df2jo0h7voifHAVS6QU="
          }, {
            "num_cand": "U2FsdGVkX19MW0PzSws1xFQDFxxcT2fga4kOCMOzOYU=",
            "cpf": "U2FsdGVkX1/dIjFWFplMbhHW42q5sUTiUNtQZCBJRYc="
          }, {
            "num_cand": "U2FsdGVkX18j1e1B+MOU+s6S0B0T9vyE6H/ZAlUJOKs=",
            "cpf": "U2FsdGVkX1/oWXzVCWub+rjnv51KtG/IX7VtajJnmNc="
          }, {
            "num_cand": "U2FsdGVkX192rpLQkXXWfyID3CSQhuY1F/qen+GDHvQ=",
            "cpf": "U2FsdGVkX18w5WiHLctRibZX00opO4I0EimPqXtttEY="
          }, {
            "num_cand": "U2FsdGVkX1/uITEuQ7RXX8/KL4/FhcASC8oUnv8XEos=",
            "cpf": "U2FsdGVkX18B1x283fS6bcJJBEXey2vzY6/cYom9Eew="
          }, {
            "num_cand": "U2FsdGVkX18nFAL239bd9mDsAeWRsLTduVRFP0RPlSo=",
            "cpf": "U2FsdGVkX1/z104vmfsjfSYsp/k4qFfenIuxiSU9zM4="
          }, {
            "num_cand": "U2FsdGVkX198pLCVxv7caH5l5FlBAuIl2OEVi/CzobY=",
            "cpf": "U2FsdGVkX1+hBZqntqjrbaty+f7OhfNfmrvFRsTjzWk="
          }, {
            "num_cand": "U2FsdGVkX199y64HKn0oy37FXebdgmuu9Ng+C4q47Vw=",
            "cpf": "U2FsdGVkX18K+8XGMIQTM8LBgJ4vGiMMY3Gpwau32xw="
          }, {
            "num_cand": "U2FsdGVkX19IAXxXQbxTdJg8XSyoXFGdvf01Y7B5vYw=",
            "cpf": "U2FsdGVkX1/cNBzutzFEQuaLMQRQCuAn/rVKaWVrxdU="
          }, {
            "num_cand": "U2FsdGVkX1+rmNZ+FlnmuTNc1Y+5bImsCPq2qS4YFvE=",
            "cpf": "U2FsdGVkX19Jc1wYsWMmVXEMEsYw9D/O+hkI94GFfF4="
          }, {
            "num_cand": "U2FsdGVkX1+0jF26QyN9RvbDJRqxjaXi5ZxuL9ECwoo=",
            "cpf": "U2FsdGVkX1+Xrym2lNQ/KVxu67RRLX2l3owfOquLQXc="
          }, {
            "num_cand": "U2FsdGVkX1/+yvd9FhVzDbkazyPXM42MmGgHUUzWJrg=",
            "cpf": "U2FsdGVkX1/SjN8h/kcYLKpdQEmQ76P1wbmwoA7gW90="
          }, {
            "num_cand": "U2FsdGVkX1+5++FjPo+3hwr+GqQ3Q8FNziCg9wvey+A=",
            "cpf": "U2FsdGVkX199w29f4WZ5oqI6hNU3l5kVAiW7wEt1VPY="
          }, {
            "num_cand": "U2FsdGVkX1+2OLUoF3uBkjUmaMmCLJceLSssFFh/KEY=",
            "cpf": "U2FsdGVkX1+jr+TAQPZuDTvmD8QFF8RGDjqWOV17hLs="
          }, {
            "num_cand": "U2FsdGVkX1+0Sh9l820oWprMiGgKIEgF6mQVgGSjFK0=",
            "cpf": "U2FsdGVkX18SBoh8j2yJOQVN8boqz116yIn563DieO4="
          }, {
            "num_cand": "U2FsdGVkX1/hy6p6KFBVjLjenbVFtlWcgswPS3FO+2E=",
            "cpf": "U2FsdGVkX18MvB0BeObbVRREFPeF9ohessSiEukcPes="
          }, {
            "num_cand": "U2FsdGVkX18Kb0lULTCncG7HU2QowqjQGXOY0khWUik=",
            "cpf": "U2FsdGVkX1932gVckJZ+aBK0xxOXPRYxoR2wDQbEAlg="
          }, {
            "num_cand": "U2FsdGVkX1/LPSxGqIiHuV1nkDiOYSTtzAmcCdwnh6Y=",
            "cpf": "U2FsdGVkX18wQPB9FzyKzfRnla8xG/Z09tVC0gdyr6A="
          }, {
            "num_cand": "U2FsdGVkX1+gEIARtr+l9+SvdCfhQvU01QrnMMzBL/4=",
            "cpf": "U2FsdGVkX1+HZTelF4FwsGDb2RJ6XBVWt4RtZZkX45w="
          }, {
            "num_cand": "U2FsdGVkX18W8iVHJpPFF5biugLtV2ni70LlCxtPdTU=",
            "cpf": "U2FsdGVkX19ER/fip4bH59OlANYf5OM5Llntq8i+VRE="
          }, {
            "num_cand": "U2FsdGVkX18/k9WvdStKJ7OW16grwMbfF25zx5AF7+U=",
            "cpf": "U2FsdGVkX1+sOodsf0ujMe30JiVmxRRHNGbN0DuEsSk="
          }, {
            "num_cand": "U2FsdGVkX18+MVMje7Zc7PeeCuoNVH1H6pTpXNSed/E=",
            "cpf": "U2FsdGVkX1/DAJrpzXDqZln/thshfCBARKwXPfUT8gY="
          }, {
            "num_cand": "U2FsdGVkX18+10LI9N+DqMMlfyOWSFssZSDGkzVF4hY=",
            "cpf": "U2FsdGVkX1864kVmIgf4SVr4LiXZjzVE2MaZjDRAGgg="
          }, {
            "num_cand": "U2FsdGVkX18cVtLRBbTPdmSUHIdb2fikBGTOhKTvXtg=",
            "cpf": "U2FsdGVkX1+ep1o08HLNykkWYW98Y6HG1cOkOvDheJE="
          }, {
            "num_cand": "U2FsdGVkX19/MFsh2VLG5xJyNGrB6ggODn148nkmV68=",
            "cpf": "U2FsdGVkX19FRKWpYYmMzGgfEgfDTZDRcVRKaEcHxwc="
          }, {
            "num_cand": "U2FsdGVkX19ZwFPwfKkalJh7T4RoyBJ2POj6jQPhxj8=",
            "cpf": "U2FsdGVkX1+GyocxfPB6VnCPaJGqwpOIOQRVpeZAXvQ="
          }, {
            "num_cand": "U2FsdGVkX1//zVAjO+3l0a7hPajh8UxIcVrPDC6nWGU=",
            "cpf": "U2FsdGVkX180LGZl6vqcBqsW/OSz3cXgzmKNLbmVjzg="
          }, {
            "num_cand": "U2FsdGVkX1+oXwtSyPLRIn7S9yt7o+SNSnNeKpQqVjk=",
            "cpf": "U2FsdGVkX19lgRH7tgwt3/uy6Ti7v3ZuJRiaGmRkG9I="
          }, {
            "num_cand": "U2FsdGVkX1+p8QxW8IA4BlpATKpKMbPFlfS9vA8V4IE=",
            "cpf": "U2FsdGVkX1+l6Q6Sa2Za6RBRTAJuXNs2GwvBE5AO8gk="
          }, {
            "num_cand": "U2FsdGVkX18aisLetuNJm6F4tJBEGdMA8I5w1unuMXs=",
            "cpf": "U2FsdGVkX19mwLgGCCOkpsJO0n8SKZEPVsF7vC4McTQ="
          }, {
            "num_cand": "U2FsdGVkX1+ATlSIkheRoyI2ebk6B/Ta0htJNIHZ4NQ=",
            "cpf": "U2FsdGVkX1+MbB5NyByIVC019mdw9Gkma0ABpKHBNkM="
          }, {
            "num_cand": "U2FsdGVkX184KU5ZYzffRrkGp+YBEmhIRZANR25vR/o=",
            "cpf": "U2FsdGVkX1/jBQ8uB52znnmJbGwL8CnwnpOJX7bxbEI="
          }, {
            "num_cand": "U2FsdGVkX19ImRGHZ2kNpZR6wPmGSwt6mU1qceMhqVI=",
            "cpf": "U2FsdGVkX1+a5cdtBITi9VUPFQsl7AdoYZSrj1n4zlI="
          }, {
            "num_cand": "U2FsdGVkX1+idlsmH5CGTMTmkYwgNOuvmzhGKRS/Yu4=",
            "cpf": "U2FsdGVkX1+V0w/6PWEFbUvTPNfPiBLwaWr0KL8qKMs="
          }, {
            "num_cand": "U2FsdGVkX1+3K+NXlOY6e0HLrNR2jw2PkixESGCI73E=",
            "cpf": "U2FsdGVkX1/bQ1AfI39qC+ICvoQrmAXlYoQlBARiTHc="
          }, {
            "num_cand": "U2FsdGVkX19E7K0GwhmgfbYEFo9y0rKM31zrIora08A=",
            "cpf": "U2FsdGVkX18j6JSHJT5lyrZ11eQfi79ISfq4pX7FaW0="
          }, {
            "num_cand": "U2FsdGVkX18StaES4zU7G3ir5uhNTzlEsmRNknB5aog=",
            "cpf": "U2FsdGVkX184kZCN5Tk3EpkMXPe6x/lYtUl9ZjGjsUk="
          }, {
            "num_cand": "U2FsdGVkX1/2cjMEAcWKSH9d9/YTGE7reDgixgEw7VA=",
            "cpf": "U2FsdGVkX18rud+8gnY9wxKSN6Ubz6kqvcxm2XJ8lvs="
          }, {
            "num_cand": "U2FsdGVkX18qDj26p0fnm301Nz4DSlbyo69DIqNw0pw=",
            "cpf": "U2FsdGVkX1+HmWw/MsG08GYK0L0qdB65hOeAQpaNxHE="
          }, {
            "num_cand": "U2FsdGVkX1+2xaQ4vv6q8NhU90D0bxS3SU1L7QNmn+8=",
            "cpf": "U2FsdGVkX1+8hJGYPLLypMaLfgXc/GIXVabwtkSHZiQ="
          }, {
            "num_cand": "U2FsdGVkX1/JCx2KcdGnEroXRJG85tUsxlC/HgZYqGc=",
            "cpf": "U2FsdGVkX18tTnx+wjJXCRgkOLL0ZP09f+TfvstT6tY="
          }, {
            "num_cand": "U2FsdGVkX19uTgdM4aFKEPpWxkbs3PxOAfVIL9tVlro=",
            "cpf": "U2FsdGVkX19seF+XQm0HJrySpKzX3kPuwOeSlVf47Eg="
          }, {
            "num_cand": "U2FsdGVkX1+7K3S6yMzqIeuEqlg7C8fpIWUz6F08HvM=",
            "cpf": "U2FsdGVkX1/XnGp663MYqnlxIhgqxrEy8qgsPAgMYYw="
          }, {
            "num_cand": "U2FsdGVkX1+k15Ow4f7/Hloq2TxK75D1/qvGDeY0O+s=",
            "cpf": "U2FsdGVkX1/tYW+OsGQBPSe7jzmMPYwFHXC+pgstoCU="
          }, {
            "num_cand": "U2FsdGVkX1+fSF4slmZ1VxYTHvcYEFCAzY7moXkGOn8=",
            "cpf": "U2FsdGVkX1/6omjpLDBL9GdMv8KBbtL9A+qRl3AxrBk="
          }, {
            "num_cand": "U2FsdGVkX1+C8kDGi/2LG5XJBbyizR23t5jwR8aPgxY=",
            "cpf": "U2FsdGVkX1+sQP2aQt0NWUPntoJoRYQGTVN542b2q7M="
          }, {
            "num_cand": "U2FsdGVkX18+mxg95MOy0RWiBJ7lFXciV9kBAbix2gE=",
            "cpf": "U2FsdGVkX19CeXxwG0ZWNMiyGM/C2/RMsSevvT10xGc="
          }, {
            "num_cand": "U2FsdGVkX1+MEhVJwB34xJQ09tLKSK2o/P2ASsuYDko=",
            "cpf": "U2FsdGVkX180OlXCoxkIuPQ3+8S0PuaoM+NkUSjQbXg="
          }, {
            "num_cand": "U2FsdGVkX185R7yqGwUoDlqbEiU0sDZK77unrzMb/r0=",
            "cpf": "U2FsdGVkX18oTL9RPFNnHR3izlf8V8hBDJWhfT7WJdU="
          }, {
            "num_cand": "U2FsdGVkX1/4+ypUx88aaltHvwCMWvr/uk5AX3Jch5w=",
            "cpf": "U2FsdGVkX1/t/FcPEWzReEzqF8r2LY9FngHCw8adUOM="
          }, {
            "num_cand": "U2FsdGVkX1/EHbjPfKRKeIijUyDIaP8gMofA5omNi44=",
            "cpf": "U2FsdGVkX182iGTPORTjxLHwsQQOlyobCvmIqH0jSs8="
          }, {
            "num_cand": "U2FsdGVkX1/iZXjmY9SoD3yBb1IgEenEXGB7R11DgEI=",
            "cpf": "U2FsdGVkX1/Rr4eG81Y3RZX62VZVDVqRF/yw40I4HeA="
          }, {
            "num_cand": "U2FsdGVkX1/UfYmgSCxUHQYSuYf6J344hI5CHZaonjg=",
            "cpf": "U2FsdGVkX18Va/5P/zxIRNPVyO3upuHB3vw3pyBI+GI="
          }, {
            "num_cand": "U2FsdGVkX1/xFfRq1dHZ2h0QrhwzLT2V7b2dXpDj7G0=",
            "cpf": "U2FsdGVkX18uDANkvxHxBiUcOznimr907c0rULEKTBE="
          }, {
            "num_cand": "U2FsdGVkX18aircQtWjL7Vo954BaoR3zzYlGUBovrw0=",
            "cpf": "U2FsdGVkX18KuBQplx7Hp/LxprlZU5Ntmx5WFQqLloE="
          }, {
            "num_cand": "U2FsdGVkX18Hbrr1n5jGSQUQpgo0jGUscl6lEuCF4CU=",
            "cpf": "U2FsdGVkX1++ssq0VjpbkHIqbmYcwAhT+KgYJnyXCPA="
          }, {
            "num_cand": "U2FsdGVkX1+6qxx4ECDfMlY+x0otEat3g+sj1C9Dlg4=",
            "cpf": "U2FsdGVkX1976ShcLyRlpbbfexYFXKqva07Nuq8TdQw="
          }, {
            "num_cand": "U2FsdGVkX1/4UcRE1brBUFzbJMkwrWPs2Cb2EYDcABQ=",
            "cpf": "U2FsdGVkX1/gSiznNbBIzjfL0QCdhIXo5+xF0EZWGq0="
          }, {
            "num_cand": "U2FsdGVkX1+Snv9R0bwNLCVGKXYOQQXw9Id6OQ9xqyo=",
            "cpf": "U2FsdGVkX19bKPHLNsFLhMeDOjYVpwfFCiRU0oGPkV8="
          }, {
            "num_cand": "U2FsdGVkX19tiO6C98SEmxGXMxFbvWlBMaoTd/Pd1i8=",
            "cpf": "U2FsdGVkX18DQT47l3LLF0ra81ZnNhoU4tevKhowxnA="
          }, {
            "num_cand": "U2FsdGVkX1/7r/JJ68DhpMDwNEBeykf8xkpu5EmC0NQ=",
            "cpf": "U2FsdGVkX194cPUzDRP4NpPi+LyKGmYZ2Gwrx4VkCu8="
          }, {
            "num_cand": "U2FsdGVkX18n5g8h7l4Znu4ISWExyo3UTES/f7zlsXs=",
            "cpf": "U2FsdGVkX18m0jDcg3s+ByYgCEZdiRlThhe8SPgY+4w="
          }, {
            "num_cand": "U2FsdGVkX188tqQBovMrKOTxHpbnBcnyrblQjInc7qs=",
            "cpf": "U2FsdGVkX1/6Yh5wBBkdc2XoUB7WxApCTJmht3pXhPA="
          }, {
            "num_cand": "U2FsdGVkX197oCH+riudTP6M0VeBZpHG1DVEaiXC6Vo=",
            "cpf": "U2FsdGVkX1/CsYvPHIKPIzmGl6Mf1RIeOccDnhbNw9g="
          }, {
            "num_cand": "U2FsdGVkX18zNwHtSz7PnxGbc3creQQ/7e3kvZ6jx2w=",
            "cpf": "U2FsdGVkX184iCqSPHSj+bcn9qch5Io59hxzuH5qNuU="
          }, {
            "num_cand": "U2FsdGVkX1+1fGkz8wi+ZV0pPpXqKJtp6ZUUrTc8g4s=",
            "cpf": "U2FsdGVkX18wUYOLyuaMYrU/TimmFwk8R5+3KNMV2SQ="
          }, {
            "num_cand": "U2FsdGVkX18Gj2nIeT2pPA7FOPqyIWZQ2wHPb6/RKSQ=",
            "cpf": "U2FsdGVkX1840wguuj3ZC3wFRXaPq+QWwh5F5GL9Igo="
          }, {
            "num_cand": "U2FsdGVkX1/RuHmQEynndk1zyIAsvVhoIj8O8acAk8A=",
            "cpf": "U2FsdGVkX1/+il4XMWJJ+//i5mo7UMSvtM8fIW0wOZ4="
          }, {
            "num_cand": "U2FsdGVkX19ZQUo4d5fioAvfK1MgMG+YEmbHxqTszJM=",
            "cpf": "U2FsdGVkX1+8ECZM3MCSCMHX/I8p9gRjlnHOgUq/qvg="
          }, {
            "num_cand": "U2FsdGVkX1+LFfQHl8U8eEEvjU5AT97NA896G9TF4I0=",
            "cpf": "U2FsdGVkX186hpy+jd8wlL734uwrwV2zZvXDqy+bB/k="
          }, {
            "num_cand": "U2FsdGVkX19LB+Dg9OD5bky4WntPFHVIVP9oeuwe5ZU=",
            "cpf": "U2FsdGVkX1+iwqMTQybDr3Gat8CiKUMlbvqTY/9p/CU="
          }, {
            "num_cand": "U2FsdGVkX19lUSV8yKt7T4pYkMXfnTzqA8MLNAVtZ18=",
            "cpf": "U2FsdGVkX1/adAzWmewUXXk0vQiQQJGkhZY/aCzZsCk="
          }, {
            "num_cand": "U2FsdGVkX1+2ZNyv36e+sQjv7knuMKEGioQar7qaR48=",
            "cpf": "U2FsdGVkX1+R1p4sBFnEw6UoTRKH+0Acf+Z5jY4d1CQ="
          }, {
            "num_cand": "U2FsdGVkX1+w3HpK3lS5Y7W4cS3qjmJmfKIQtOzeb+o=",
            "cpf": "U2FsdGVkX19iMbTS3uqR9BIRmJsqRBtxgWtl4H5y3LM="
          }, {
            "num_cand": "U2FsdGVkX1+MmUknBBkFiTD24+qTTZuM/Pj94s0igUU=",
            "cpf": "U2FsdGVkX1/ISWdzIPSB5rsUiisr4YYGJhRw2tQr+fw="
          }, {
            "num_cand": "U2FsdGVkX1+03nIhdSpvtV2hQQ0YOD2HWJsBKFiBULk=",
            "cpf": "U2FsdGVkX19dVxCYLtDvrY1utRVOgKbluWr4qRNQmaA="
          }, {
            "num_cand": "U2FsdGVkX19U4BLjeqDFIN6YGdhvatqWyBkfkmRaIuI=",
            "cpf": "U2FsdGVkX18U4sr/C9bZq4nvqCxmP6xn8hscHOVMCn8="
          }, {
            "num_cand": "U2FsdGVkX1/jl8isANCjQxvQcC3iLHw9aYW69qWKn/o=",
            "cpf": "U2FsdGVkX1+6B0j2zi3wkJAwhaRso7W0RbO4dnp8T4Q="
          }, {
            "num_cand": "U2FsdGVkX1+Q55pQLrIsUOXrCD10/kpZ2StF2zIhmaY=",
            "cpf": "U2FsdGVkX18ht4C34hnYf89wqH7Ddg9MiVF9Go+z++w="
          }, {
            "num_cand": "U2FsdGVkX1+nNAPlGC8rL829fFD6upKiApOQBScOrAg=",
            "cpf": "U2FsdGVkX1/r39xwwjBeFi9QyeFBNUEr0QDJOuhyNrM="
          }, {
            "num_cand": "U2FsdGVkX19WBYSLuOe2chR3aDbUVenO08lHe8So2XY=",
            "cpf": "U2FsdGVkX1/G6JI4UnRjetITTmQUxGGNUT9AG5YG2K0="
          }, {
            "num_cand": "U2FsdGVkX18IEzxP277/dSXjEktPWhzJNLAchdzHwbM=",
            "cpf": "U2FsdGVkX1/qRyNgtUbtY7acwzg00xfnm4qsSaZqRtE="
          }, {
            "num_cand": "U2FsdGVkX1/Fn0LSzwtZ0hUYnp18FEJQwx8lxSmLEWI=",
            "cpf": "U2FsdGVkX1/+yGJ1WxWxDRnhMvRCUWmwfzfvC7/EKBo="
          }, {
            "num_cand": "U2FsdGVkX1+ZybJN8R/0yeQ/8+NRRu0VS030aGCm7dk=",
            "cpf": "U2FsdGVkX1+74D68IJ7Iab1NMzoTqGHaJAVQJy/B0+4="
          }, {
            "num_cand": "U2FsdGVkX19V1nMtwPubGVLrL0WraSMIU52M+GH/jJQ=",
            "cpf": "U2FsdGVkX1/GZ6Ef32s5ugDeVaEHsYtLcIoeh4XIW74="
          }, {
            "num_cand": "U2FsdGVkX19/jmb8uUeQCZ9Bvf1hgLm0yXUab0q/cQ0=",
            "cpf": "U2FsdGVkX180IEdS32GqBa0XjWdhqSBqpcgeQMlFIOo="
          }, {
            "num_cand": "U2FsdGVkX19pKmatRg6B9/4kWhiSy4dWeKo702EZs7c=",
            "cpf": "U2FsdGVkX19GcW9nmkUkGP2U1lJ4x6BfKK/8wc2CMpQ="
          }, {
            "num_cand": "U2FsdGVkX1+/rxnJLUH2Yi7O69n5WVly5VVk7jsxi0k=",
            "cpf": "U2FsdGVkX190zOZ7iEs+HUODMysRpivwJuQMRgOdjes="
          }, {
            "num_cand": "U2FsdGVkX19JRHJtopujgyZWeBrLl3X0c4u6g0mj7g4=",
            "cpf": "U2FsdGVkX1/WS+nuA9WEBKbocuMo7Y7LEkDfu7LBo6c="
          }, {
            "num_cand": "U2FsdGVkX19GqLr3YCjk6mh5Yz5aJ8NvBwblNMRVNs8=",
            "cpf": "U2FsdGVkX1+KejPODjwMsKFcCWFdWVREjrCc/VNhqbA="
          }, {
            "num_cand": "U2FsdGVkX1/S/8lV0aglySxYonarbHU798iyLcFja8A=",
            "cpf": "U2FsdGVkX1/EdxPaYB4OgL7cXCIgIHNpUSOC7C1natI="
          }, {
            "num_cand": "U2FsdGVkX1/TueZpYzW9gA7Uq8uaGxtG47G44nBWt7c=",
            "cpf": "U2FsdGVkX1/ohLYBmANjBEMJate8ASucGuCXTGDOKjk="
          }, {
            "num_cand": "U2FsdGVkX190U/1L/ROnrJqlFjWVRf8voWDGKrkNJhQ=",
            "cpf": "U2FsdGVkX1+G3tTdAMAHoetmii275htwVNpdxr1O6L0="
          }, {
            "num_cand": "U2FsdGVkX18LGy0WAotgUX3VfvboxkkI0oGV9V0K4fc=",
            "cpf": "U2FsdGVkX18BOPn7yFnU7WAQw8J6jRlUkDeHHMREe9k="
          }, {
            "num_cand": "U2FsdGVkX1+0GYvc1/nxJS/v7jYaYi7EZWmiV1O7rnA=",
            "cpf": "U2FsdGVkX1/xl0o/ZHBTQUCnwvx4DcrAdBbjUExHREo="
          }, {
            "num_cand": "U2FsdGVkX18uQftYT+y6d7shZFkxFEEq8vk6TXdnBg8=",
            "cpf": "U2FsdGVkX1/BHP7oowcNl8d5M+o/IHjjUqn+LOXaBLQ="
          }, {
            "num_cand": "U2FsdGVkX19nlYGtJukldtK/ccZaR99dwEFJqEU8HmE=",
            "cpf": "U2FsdGVkX1+gfGOK6UymD/0BqxytoTMJ1QxeKBg9Dco="
          }, {
            "num_cand": "U2FsdGVkX18a8dOd7SSUkLBbB2AZJ90OtECJWGdjxbM=",
            "cpf": "U2FsdGVkX1/F1gLzGNQ5U/o0Js7j7Y9vL7mzXmi2Zx4="
          }, {
            "num_cand": "U2FsdGVkX1+vJk6nYW/RHp/4UouYh2uRgCtT6wuc4yk=",
            "cpf": "U2FsdGVkX1+R2cVvskMXWQXgngyxPu9CFgKtwPp2KvM="
          }, {
            "num_cand": "U2FsdGVkX19jFbtKcXWG2IU9g214+NeRIkuYu7yHUZs=",
            "cpf": "U2FsdGVkX1/piCeDd74bM45SrJAykVKVOgWZPVhe0JU="
          }, {
            "num_cand": "U2FsdGVkX18MLGngmYaDjZrqdruHagxmihgAxjn+5NE=",
            "cpf": "U2FsdGVkX1/oJBvo+yLW3ZzXO7Nzr7VZkY1KbBHo9Qc="
          }, {
            "num_cand": "U2FsdGVkX1/+Vc8uYJ7a7hzWFT79PnSoOnqepUaujNY=",
            "cpf": "U2FsdGVkX1+SyLsruK9DhuYYFfrLLhseE8Q5C99bqNo="
          }, {
            "num_cand": "U2FsdGVkX19jQKVWPRnUIOXB9aiiAqjsIhTz7v3DO3E=",
            "cpf": "U2FsdGVkX1+ps0hgen/sDbRncT4YTYw+6r56XtnbFz0="
          }, {
            "num_cand": "U2FsdGVkX19pa3As3yvYWLjueZs4EcMnmCCtopLQVT0=",
            "cpf": "U2FsdGVkX18bNM4idTxfp6mmFmbO3/ZYED+BV/grZd4="
          }, {
            "num_cand": "U2FsdGVkX1+gfprexXtfXS27zF0/56rcPnpLS9S+mT0=",
            "cpf": "U2FsdGVkX18fTPT7FmZ/qgRNXVXSUkeijHgho1m4LnY="
          }, {
            "num_cand": "U2FsdGVkX19I55o+HrPpHejN1n3A1TapVvLolmdoCsM=",
            "cpf": "U2FsdGVkX19wJZ5/Om2zErRnVmq8Y5QNOG7G+Ec7svY="
          }, {
            "num_cand": "U2FsdGVkX1/AlOwSK+25Ft523zEvHjWIJYJtJ6fiM10=",
            "cpf": "U2FsdGVkX1/9EVAdPzhqkEN+nLnxjaw07nLrIgEPGlE="
          }, {
            "num_cand": "U2FsdGVkX1/UIiNv+4Fc0h4VMfceJUGdQcK75w+bpzg=",
            "cpf": "U2FsdGVkX1/0YJrsje6gBASu0GdQfep7oylog2K2tjI="
          }, {
            "num_cand": "U2FsdGVkX198YRt0axgAlMTGO70fgAo32QSQ074m4hA=",
            "cpf": "U2FsdGVkX19OLjA7KC8pzxj0zsRUmPPio0TKX7hHHsQ="
          }, {
            "num_cand": "U2FsdGVkX1+mg50/KTp7oDCak8DOo/kzM27HZ7AT6hc=",
            "cpf": "U2FsdGVkX1+kvbB6Nw4TxngoKh8nB4fCAJtPv2VQ49Y="
          }, {
            "num_cand": "U2FsdGVkX1/XzAZZAHoWO9kvVqp0FZAle3c4sIyGz6g=",
            "cpf": "U2FsdGVkX18kGmlnFkUHprVnlFAMDJTwFuzEj1xLQog="
          }, {
            "num_cand": "U2FsdGVkX18OBy7qCWyhupoEnOoxi8w6xl5tkzZAHxY=",
            "cpf": "U2FsdGVkX19GwSlDSRK4UhcJ828nXuz5cLcCs6iDPR4="
          }, {
            "num_cand": "U2FsdGVkX1+hi1hegTOTfFn34CUXH0vHNqe4Bj+wrDo=",
            "cpf": "U2FsdGVkX1/6zBZaeM6ioS7dNfBD+BK7fxS1k8bBvX4="
          }, {
            "num_cand": "U2FsdGVkX18SDROjm3ZhHEAFtMzqlL3diNOXdK+H22s=",
            "cpf": "U2FsdGVkX1+C4TYyadkkyDMrM1WLVe8mV5inl6oGFn0="
          }, {
            "num_cand": "U2FsdGVkX1+BKzn2/oHwqcxGGjDDdMTNPl0mQSzl5x0=",
            "cpf": "U2FsdGVkX18lrjBlxycbNNLQKlceFmC7KK8WRkyfm3A="
          }, {
            "num_cand": "U2FsdGVkX19Dy1sQVwqAzMG6DA5Aq5NIhE9Fek1HrbA=",
            "cpf": "U2FsdGVkX1/G+DVKMKlnS4stZ3ArHQgWZ2kNRc14lRA="
          }, {
            "num_cand": "U2FsdGVkX187Yr0/bW98X6VHepewOiV3LfBwS4QgWRs=",
            "cpf": "U2FsdGVkX19I9PIBiMipkk0NrH8fMrdpOUGHbHEex00="
          }, {
            "num_cand": "U2FsdGVkX1/bJmMQc+Ti/lzuLRSJCU9IeI1sTz/vao0=",
            "cpf": "U2FsdGVkX19QHVoXhDISjlS7tr76joRnrP9eV42jgRw="
          }, {
            "num_cand": "U2FsdGVkX1/ENygyul729VNN5Go/+F7I8fzienZzX14=",
            "cpf": "U2FsdGVkX1/APSah7YZOXhuQq2bMs2ZiU6Hyf10o6b4="
          }, {
            "num_cand": "U2FsdGVkX19js+67Br2eXYpD20fCJHiFnVkwbVRv2ck=",
            "cpf": "U2FsdGVkX18sRTUG4XBEH+6oH28l58E08j2gHWwmu+w="
          }, {
            "num_cand": "U2FsdGVkX19se1GgmLuK1qse/M1Y0EXLu1Y1PcHtkjU=",
            "cpf": "U2FsdGVkX19ZJjceMy+GgWciFS2XGhvOEj0j4ihfqG8="
          }, {
            "num_cand": "U2FsdGVkX19xqkpOpaEcMo1S4qKzntSSHIoMrYNQAGg=",
            "cpf": "U2FsdGVkX1+E/I3sOb/me3DPx18mnLIS7rcyPFgxJQ0="
          }, {
            "num_cand": "U2FsdGVkX19Otz+9O8i7YaNRI1Yn5VTVD5ScwzLbw+4=",
            "cpf": "U2FsdGVkX19qmtjFh6POuBJICwnTiBzMahutVHphHXk="
          }, {
            "num_cand": "U2FsdGVkX1/Euis8RGpm9xxEXqDzu4CfaY/gsQQ9HFg=",
            "cpf": "U2FsdGVkX18JYm4576eyf3ZvOCPVqw0LYbyENZonZWc="
          }, {
            "num_cand": "U2FsdGVkX1/sRVmrbdrVHGMi4IukVy3MwtC+R9Y9la8=",
            "cpf": "U2FsdGVkX18HUkVaTF0qxUvcgWZwPBhhvB+ManwYPzM="
          }, {
            "num_cand": "U2FsdGVkX1+GfhwkZ0SE+TaElmRtUuayf/0iMqn1tOw=",
            "cpf": "U2FsdGVkX18oGDWutP1x9vmGJ2LV1ozVPU6lCswR8uk="
          }, {
            "num_cand": "U2FsdGVkX1+2AGvw48t4/YqqD0ya0rNIJjpaZo29HW8=",
            "cpf": "U2FsdGVkX1/cmpql3+lR/A/qBTdp0RyXk/4dNiFqiYE="
          }, {
            "num_cand": "U2FsdGVkX1/T8u5clI+iKnG78k9vJEb2XjPtzzfKOww=",
            "cpf": "U2FsdGVkX1/h7djvYTyDPTFQs21/OdjVGJLnezH55lM="
          }, {
            "num_cand": "U2FsdGVkX19taSU/4auv2ybbXm4u9/tdALL5WRN4Jag=",
            "cpf": "U2FsdGVkX1+3BrQbHh2varLNcpxd7Kn6b2HfrKG5TEo="
          }, {
            "num_cand": "U2FsdGVkX19MfNYEXRvHPvlUE9kC8Kvs+kCiX6ZyKM4=",
            "cpf": "U2FsdGVkX19rR/z+asa4K9LxaGjY8AMGK6DcVBS0nLc="
          }, {
            "num_cand": "U2FsdGVkX1+HTWT3MB5OouEBz2SAhFuYQtxA+SCYFVo=",
            "cpf": "U2FsdGVkX1+qzZ389PXd0+jz1Sm1QRSOUaXSrQZMjGk="
          }, {
            "num_cand": "U2FsdGVkX1+JIU/S9f0zAGMMmBjbas0gHuel+LNHbNM=",
            "cpf": "U2FsdGVkX1/9pMZlsuObYvGuLwSM+Toay3gpSGcZGvg="
          }, {
            "num_cand": "U2FsdGVkX18OAWE+79fyb95Yg5XY8NNWGI3Yi/Y43Kw=",
            "cpf": "U2FsdGVkX1+ife1MS8kycjR2IF31ym1H41p2SL+5ayU="
          }, {
            "num_cand": "U2FsdGVkX1/Ec9lj9oAols9MK3bTP+wO4wlcB/rj1T8=",
            "cpf": "U2FsdGVkX1/ZeNFEjRmGCSD5MWyQGyZwj3kgM2/JFIM="
          }, {
            "num_cand": "U2FsdGVkX1+OBMi7bQ+gXtaFcAj2RWBLSTfvp2luCLk=",
            "cpf": "U2FsdGVkX1/DqMlscM8M2NMpUU0AZ3aGGgUr2FsV0ZQ="
          }, {
            "num_cand": "U2FsdGVkX19cKUiUyOYxJSBd0oR6t+B8II+LnmbAYXg=",
            "cpf": "U2FsdGVkX1+7QP4a0b3CrH0/wlszWy5m7Mm9x4tUb2o="
          }, {
            "num_cand": "U2FsdGVkX19BDhRgv8Mmwpe+fG/SuowYC/BCmsnFBoc=",
            "cpf": "U2FsdGVkX1+Ee4Gzlc3khW7K/Og+w+w36VesSJ6VI08="
          }, {
            "num_cand": "U2FsdGVkX19H/4pV7+zf5LDoMhZZRGxBhRzkSQ0ZEcc=",
            "cpf": "U2FsdGVkX1/4H78rIcBOiAeA4JP9OpZX80vpqsp3KtY="
          }, {
            "num_cand": "U2FsdGVkX18gim2+kOqV0CEY9rtqjoK0BmepfsRhY3I=",
            "cpf": "U2FsdGVkX1+51QczBA/T/NpcQF1D2CvJc5NMw9HzINw="
          }, {
            "num_cand": "U2FsdGVkX19ikWol/2VLmxQWtgXr3PnydfX1+nMo5p4=",
            "cpf": "U2FsdGVkX1/XTDBMJB/q6JpgwDHTdSZRZMgqDeVUDDc="
          }, {
            "num_cand": "U2FsdGVkX18TsJMAGlWstXShxeO+qQd9Pxs/d6h91K4=",
            "cpf": "U2FsdGVkX1+SQuZF5AorwjDH9MmtiE0gxXmRg+GBzdE="
          }, {
            "num_cand": "U2FsdGVkX1/81hLl9Cq4AJ7OWnHSeTeQsfjWbobBU6Q=",
            "cpf": "U2FsdGVkX1/ktBBIjyux+je56jVdptZ4judOqy8IMqE="
          }, {
            "num_cand": "U2FsdGVkX1+z2TcyuxhUAky7DIT04gvts1OEBXeFCMg=",
            "cpf": "U2FsdGVkX19y/LdPZO51/WjDdluptfx8b1tYH6xG8bw="
          }, {
            "num_cand": "U2FsdGVkX19fWlhstwrt7sTTIKufSMksYQA/pV2RXnA=",
            "cpf": "U2FsdGVkX18fvIUGjg4TZ5e7927Bp0ucs/MKkYgshxo="
          }, {
            "num_cand": "U2FsdGVkX19UtUDYLu8LdxzbdVJbLv+ITyjt1pKIaKs=",
            "cpf": "U2FsdGVkX1+KaDosK93aAxRrCf70ICF4aFQdzeNbM0I="
          }, {
            "num_cand": "U2FsdGVkX18ImQcrZoO0L9AZfnMvER3GRooTdmzWLSo=",
            "cpf": "U2FsdGVkX19FZsftsxKPpxTZY8uuSBX1zr7iY+8pZao="
          }, {
            "num_cand": "U2FsdGVkX19yZV1F8xQCkA4T7Cq27ewT75LWCuyiHXM=",
            "cpf": "U2FsdGVkX18koPXjJFI9Wuwak7iovZ9Ckm3wAh23/jM="
          }, {
            "num_cand": "U2FsdGVkX1+5JMCdyxSa0uNpZPkLjzS6psCyfcuWQhA=",
            "cpf": "U2FsdGVkX18QaBvDUQbA8ocSJLjZabaGv2ktF21pIQw="
          }, {
            "num_cand": "U2FsdGVkX1+XzG0pegG+2wBIV8n1sJbqIS4snFpU8SA=",
            "cpf": "U2FsdGVkX19RFSOWMWd2yPJTIe9QgB4gLA2ZAs3ZxJE="
          }, {
            "num_cand": "U2FsdGVkX18CvzhW5u5ea+cm7Buyvq3SJ1X5tof3z9o=",
            "cpf": "U2FsdGVkX18u9Ezjkz+ILVQ2sgjIpz6Pc9e27WPkpMM="
          }, {
            "num_cand": "U2FsdGVkX19WkmnPQ4/5UY8YCD+I2TTQ3c3Q4pr6X7k=",
            "cpf": "U2FsdGVkX1+fjgbhKDnvhapEBpuJusqkO6eKNX2bQtY="
          }, {
            "num_cand": "U2FsdGVkX1/s6ibFUxag1WhpT/JRbeDluLQGAZiYz4U=",
            "cpf": "U2FsdGVkX19zvJDQAl1BOMhjnpZaR36TPsGMSaKWCMg="
          }, {
            "num_cand": "U2FsdGVkX18jVbjbvXnw08xBts96+zhDD3r73XbMY2c=",
            "cpf": "U2FsdGVkX1/naCUkk+EdR5fkcURDk2kEB77ER7Ii0Xs="
          }, {
            "num_cand": "U2FsdGVkX18WQ3PbPh/erENB0N6TZIG8HdgAK/BtiBo=",
            "cpf": "U2FsdGVkX19jr7Naf+4ZGfAH2bh5c3CHOome7ZQlBG0="
          }, {
            "num_cand": "U2FsdGVkX19VcrOf2TcS3dvKtA5GZPgeJteaZGVnMMY=",
            "cpf": "U2FsdGVkX18MgAXxdnVN5ZuJN/hDXTp75cKAIDlokfQ="
          }, {
            "num_cand": "U2FsdGVkX1/8aNqWmEKzf7bVc0iiH8ktR1nmum4Xlzw=",
            "cpf": "U2FsdGVkX18202lihgdo2wGb8UyT1bC1v3he3/9UUJs="
          }, {
            "num_cand": "U2FsdGVkX18ExGSwNp3eD12r+j4n1Nn1gNw/IEw17I4=",
            "cpf": "U2FsdGVkX1/KmvhAFeXa4UQkDvA4xfZZGgvgqJN1Vxw="
          }, {
            "num_cand": "U2FsdGVkX184CmdsjFrCSTHQYM1oPr0KbwmoP3zQq08=",
            "cpf": "U2FsdGVkX1+2eot6C3CAS07FB+v+88NnLSHEy0Ldb9k="
          }, {
            "num_cand": "U2FsdGVkX18nEWHLLGx4L/YjJoybzPNvkkpA2N6kM+w=",
            "cpf": "U2FsdGVkX1/aKbVIc4tVs+j4AwkYmqEGmM7gOVbh6PM="
          }, {
            "num_cand": "U2FsdGVkX1/LZ9Rv6ph0x3u4sRs0wFPEdWOaaDkMiuM=",
            "cpf": "U2FsdGVkX1/tmLw1Yhje0FJ8ZUMgwDRwuy/FLLfdtFo="
          }, {
            "num_cand": "U2FsdGVkX18inu89F5hlUAy9TpFQVkoniGp5cejc5IE=",
            "cpf": "U2FsdGVkX19ImMC/Ga4C72DYvUZ4jqSwLhHLVnLTf7o="
          }, {
            "num_cand": "U2FsdGVkX185kZabz9JywykwUnjqWLIXxSpqxYeMLyo=",
            "cpf": "U2FsdGVkX1+Xlitelw4lTtG71+ok02GuVT9QQgqQcU8="
          }, {
            "num_cand": "U2FsdGVkX19gjfqFn/htShli+mbgknyFsy2lxEeR0eI=",
            "cpf": "U2FsdGVkX1+fIl4MY+aSwcpMiXdgJ777PPNXiQH6y6E="
          }, {
            "num_cand": "U2FsdGVkX18LzI7KoJbBvIdU5IRwldSfoVJr/zRMN8w=",
            "cpf": "U2FsdGVkX189NBKEMj7U97S+0dPGDjRL555Ns6ak8gc="
          }, {
            "num_cand": "U2FsdGVkX1+PqL+vvhMqjy/tNAg3psKLVhY435bAfJ4=",
            "cpf": "U2FsdGVkX1/bhaPlHUWuJ7gsRxfOJOrYRcnIsNqT2I4="
          }, {
            "num_cand": "U2FsdGVkX19cHITXaJHGZNwrq8emsHeoTc1tYDHDbUE=",
            "cpf": "U2FsdGVkX19ECyFYGPzgEiJ17/1+ga5yf+0YQRnMawI="
          }, {
            "num_cand": "U2FsdGVkX196GvK8xIDNg+wM+zy2b0lWG5cP04hnJSo=",
            "cpf": "U2FsdGVkX19rV9b581UXo3kqd/kVziHaq68e8L1rbBU="
          }, {
            "num_cand": "U2FsdGVkX18i2GcMH/0Zf2NBnexAcQJyhjRnaRXgXz8=",
            "cpf": "U2FsdGVkX1+pRNoSqfibNQ/mbSlZZ/D0a/Oym/Hwpsg="
          }, {
            "num_cand": "U2FsdGVkX1/zzcfaNn3KFXRFn28JKkAHYLn4ox54iRg=",
            "cpf": "U2FsdGVkX1+vq16/Aw5PcT7S5jh08KBhW9mYp9lHPWA="
          }, {
            "num_cand": "U2FsdGVkX1/iGWkfI9PxjRELMie70jJkDZvUu1fR38c=",
            "cpf": "U2FsdGVkX1/o/UNvA008oMelB9GEvNSOpUbvx7up7/g="
          }, {
            "num_cand": "U2FsdGVkX1/eurmlOU+QiBcO1KC0bZKUhHnHhDofIvg=",
            "cpf": "U2FsdGVkX19NhLLSvQLCSSG5UShG3klIUBts5iw87sk="
          }, {
            "num_cand": "U2FsdGVkX196IaaC5wOBQMxnSTctmVLtx8svpyl2vhs=",
            "cpf": "U2FsdGVkX1/3O+sPlU4hUVO0FFfRXaDNEtLJxV4ak/w="
          }, {
            "num_cand": "U2FsdGVkX18BTfbTze+Gj1ALH3qHNRYX7Nu42rY67WM=",
            "cpf": "U2FsdGVkX1+efPqvaCu65/ui6k5nAXGRavi+84ptZ8c="
          }, {
            "num_cand": "U2FsdGVkX195hzupBR0xd3/yY5Z+iDJgZsbG8VtE3Vc=",
            "cpf": "U2FsdGVkX1/K9Yb+wLgt/L2DNrJxABbkF2+jRuc4g9E="
          }, {
            "num_cand": "U2FsdGVkX18GQ10yf58hZwm1+z0ySMPNbEqdAZ+ACqc=",
            "cpf": "U2FsdGVkX1/j2YJs9io0zT1GYtvKBcC2mdu9y0jP7LM="
          }, {
            "num_cand": "U2FsdGVkX18f64k0vWsSBp1MrCswCwixIcmsVQjLYQE=",
            "cpf": "U2FsdGVkX1+Emk2FrfjxWlyMazjmkdrei/H7gFLhrkc="
          }, {
            "num_cand": "U2FsdGVkX186FDLysq5G1/Yl5KK37/FV++yKf82MXgk=",
            "cpf": "U2FsdGVkX19CEBdopA/RxWMPqPjj1XMRllQIfPqgmH4="
          }, {
            "num_cand": "U2FsdGVkX18yLZOqUgIljbDNBe5/dXeGEL5IKxKQuIU=",
            "cpf": "U2FsdGVkX1/zRgimHS6x+rLvzOnmMIcwetU5MCG7Ibw="
          }, {
            "num_cand": "U2FsdGVkX19AdDZ0ROrcx2dMpRhpmbcipyWzanp4RcI=",
            "cpf": "U2FsdGVkX19GO7y9q9z5LARZoVzSsPf356E0OTkcabg="
          }, {
            "num_cand": "U2FsdGVkX1/ZTzs3irnqLNfgWfi2477h2vS0kHnEIfE=",
            "cpf": "U2FsdGVkX1+6nkUI63aig/djJ80hvbAUuWwYwydHpw4="
          }, {
            "num_cand": "U2FsdGVkX18ELElvAOL32XAYbiknvTV0jbR65DLGEd4=",
            "cpf": "U2FsdGVkX1+pIg4R/I2J4BuImBLTJeylph/sOsI4iYU="
          }, {
            "num_cand": "U2FsdGVkX193gY9CB0wxkoAWvowsdgxAFTla7QWBoOA=",
            "cpf": "U2FsdGVkX1+FNc+aLTEFlYHNnzaBrNARsyAKtQC4nTo="
          }, {
            "num_cand": "U2FsdGVkX1+MOjO8ynqDjV2d/IUVRodfnjP620zSC6o=",
            "cpf": "U2FsdGVkX1+Jbft1vXJTR653sQ1nGERwCLc93kt8Zy4="
          }, {
            "num_cand": "U2FsdGVkX1+6UMRc5TpwV+Mp5FF8anoS+8EJaV1r+xk=",
            "cpf": "U2FsdGVkX18uOKnsanQvp8CMHTxlVsafR1VnBcxcNSI="
          }, {
            "num_cand": "U2FsdGVkX18+30jpAfMvReH4+3ts06tdpGt0u5wdH30=",
            "cpf": "U2FsdGVkX1/9ggBfGtHYlFIOF4iY0cgrPuSFy4o+g3A="
          }, {
            "num_cand": "U2FsdGVkX1/eHPOJ6aSyEX3FHs+NnvzLPsiPwEYX5I8=",
            "cpf": "U2FsdGVkX1/7xj5i5KNNpruJrxqaianV/Wnf0Xuq+is="
          }, {
            "num_cand": "U2FsdGVkX1/iUKNsFoCgtIRYMbVBaMiiH1eKwH3i1fw=",
            "cpf": "U2FsdGVkX1+q8cHQOITs5AU142cGRzIAisSQg0e6a1I="
          }, {
            "num_cand": "U2FsdGVkX18qOztPLZYa6EzTVVaVaDmESUqBd1dXAD4=",
            "cpf": "U2FsdGVkX1+ElG3xR9hbPeQKZcL5C+KSEX5q+OT5n6U="
          }, {
            "num_cand": "U2FsdGVkX1/t2/7KeYLshB3HRACKHf29gYI7acJnUYY=",
            "cpf": "U2FsdGVkX18cEOwDVJD8asP2TJ7opr9qdT7ZjdUIvoA="
          }, {
            "num_cand": "U2FsdGVkX1/iSxrx4NBBzwFfJgcEZKSbcLDlEF0WBcI=",
            "cpf": "U2FsdGVkX19R7GDU1V4t9HN8EgfZC0sz8raUPb+JCJM="
          }, {
            "num_cand": "U2FsdGVkX1+YJ/LzRktnUx1u8CYpGDAoM5dTkipFSo0=",
            "cpf": "U2FsdGVkX1+J7b7GTFQVmG5irFrsgmCnmUFfhB6c9+o="
          }, {
            "num_cand": "U2FsdGVkX1+pvsskvauAeiJqpKxgd3LYQ/s32MkbIig=",
            "cpf": "U2FsdGVkX19j9pc1bSadV8E6IkmFgtLGVgR9A2JqEv0="
          }, {
            "num_cand": "U2FsdGVkX1+Oi+PIaXgizDVeSc1wp4ywCHoolb6waTA=",
            "cpf": "U2FsdGVkX1+1unKHHC1U737+tX3nNppRw9mFMw9P0EM="
          }, {
            "num_cand": "U2FsdGVkX1+hXcKj2IbZ7Sc8b5i/R0Y1IlZHqNMoUlw=",
            "cpf": "U2FsdGVkX18z3kf4+YPiO2mD+7d+6bHBmVZSg4f1Qlw="
          }, {
            "num_cand": "U2FsdGVkX18m6V1eMkEmK8eYtvm5iPIFsOu66/vcXRM=",
            "cpf": "U2FsdGVkX19id+2JLjizgrTc1C8LUM4hMpPO5xrJ/E8="
          }, {
            "num_cand": "U2FsdGVkX18/gGUD0lC1l9Ya0Y5sOaTuMAwJh/ZAqP4=",
            "cpf": "U2FsdGVkX1/aNM+42Sy+lzLYfqoFR9B0B4Dlh5InXeo="
          }, {
            "num_cand": "U2FsdGVkX192qOp3rkusejxaLuY/t+595RWEA1rWoBY=",
            "cpf": "U2FsdGVkX1/dd7Z/cp/kE9yAdepzaX+Snq3S9+rhneQ="
          }, {
            "num_cand": "U2FsdGVkX18gV+rVK14266MPODC9Bm07hXuJMBBUtBk=",
            "cpf": "U2FsdGVkX195YWO08SH+sd0AJd4j0jC4VopnBDEz5Y8="
          }, {
            "num_cand": "U2FsdGVkX1+Kkdkz9Z6QgJWp6Za3AMTJ0VunI6ndkaw=",
            "cpf": "U2FsdGVkX1+6zk6GiDM/85nRCisSPCwF4xiYj3oi1U4="
          }, {
            "num_cand": "U2FsdGVkX1/oM9i7YTCAJRykbixrIH5Ymca0Rfbfv9g=",
            "cpf": "U2FsdGVkX1+Sf4+74LeyKmwZIHkbQ3VLMtuCUlmCBa8="
          }, {
            "num_cand": "U2FsdGVkX1/TIE7YaUpBiva71w347R79ah8Zs2oRutY=",
            "cpf": "U2FsdGVkX1+iylY4s9Cx/mWjM+SgmAjEGHj9WE5CtUU="
          }, {
            "num_cand": "U2FsdGVkX1/yz0ZrFUJvirwbyOYA7JIQbfk7JbYJbOw=",
            "cpf": "U2FsdGVkX1/yHJSLEi15PryVBJ9/fyYDyLrx3u4/tDA="
          }, {
            "num_cand": "U2FsdGVkX197MiRASbvfNtCnoIvGbeem62UVrahJ1B8=",
            "cpf": "U2FsdGVkX19jTDlTQrN19BKiQ720L79B62mriWNAtis="
          }, {
            "num_cand": "U2FsdGVkX1/HZJmUim/PGXnehQLkJ/Bgsiv+Oi8uu/4=",
            "cpf": "U2FsdGVkX1+kN5cdqZawxljFnic+J7GZyOb4Hmnsjcc="
          }, {
            "num_cand": "U2FsdGVkX1/7CJlzkzVn1tLzj171u14GoyFS+3IwskM=",
            "cpf": "U2FsdGVkX1/bVzQM3RkdMqQQlm+IwCPYH5J2l7LHOJA="
          }, {
            "num_cand": "U2FsdGVkX1+Z44yHQChDhwBDC1kSupGbegUa3w6EdMQ=",
            "cpf": "U2FsdGVkX1+x5SR6jx6vnPODSRhN/LCKuRDA9B6DmXI="
          }, {
            "num_cand": "U2FsdGVkX1+gSqKJKgt4ZmpVBOncqgFXGit3NSM1Dt4=",
            "cpf": "U2FsdGVkX1/g1yjYzRIKt5/JA4ME6DrWHUA3qNdessM="
          }, {
            "num_cand": "U2FsdGVkX1/G3P1Cv/fPiPv5i0FHbhu7YDiW9WCcKEA=",
            "cpf": "U2FsdGVkX1+bWbQzQP4PcZXAA5T6jv2VG1IQ6JJ7z64="
          }, {
            "num_cand": "U2FsdGVkX1/nO6fwZtYOurhJDz9alBNCY0yLirnM208=",
            "cpf": "U2FsdGVkX18x4vlu8xGm0yQV95eaeapOsT9okjsoCTk="
          }, {
            "num_cand": "U2FsdGVkX18oDVcUxbDS06w9EFtgG6zGZiRJQT3msIs=",
            "cpf": "U2FsdGVkX19GFHVNExvdkUzbVt9jTFszaaWyS5DF69Y="
          }, {
            "num_cand": "U2FsdGVkX18Pu0UrZQFor7n394dxR5xup6/XSqk8j74=",
            "cpf": "U2FsdGVkX19DxaGyGBmSgnitYud2osX9ND07CWOJNX0="
          }, {
            "num_cand": "U2FsdGVkX1+c1poqx0APcW2LX4Lptn8sP8Unj4YSv2U=",
            "cpf": "U2FsdGVkX1/QfRjzqThMG6D9hy3ruvu2Rp3JX96TFoo="
          }, {
            "num_cand": "U2FsdGVkX19adgMVHvZcnI55bddY3Ia+CRZtpJ1HZtU=",
            "cpf": "U2FsdGVkX1879bm3r9Uf6nEUuprOc+WnXpLxTs7UgNk="
          }, {
            "num_cand": "U2FsdGVkX19qZCJq50CW/d4/dCe/b3JVkx4iqAghFBo=",
            "cpf": "U2FsdGVkX19UpPZdDKB3q1NgZrOGabwaJaqMqCD9cAA="
          }, {
            "num_cand": "U2FsdGVkX1+G70SPOdJ+2OlZvCNU2rXrFJo07dnJT1M=",
            "cpf": "U2FsdGVkX1/GGSh/fXxE2ukySbSV77gGUqOYKgNtVkU="
          }, {
            "num_cand": "U2FsdGVkX1+IYvS86olFCnC1sWBefHMKlCVhKZ+tWJ4=",
            "cpf": "U2FsdGVkX1+nDmNNs6LLZqo7o0YioteaCg0Os0wozLY="
          }, {
            "num_cand": "U2FsdGVkX19ne7CxLPYzkxsj69WVEcc35oZICDEu3mc=",
            "cpf": "U2FsdGVkX19XQbraoKfBf0TvCcDo1gPPilbkh90+dOw="
          }, {
            "num_cand": "U2FsdGVkX1/UqoDXiIlrFezIKyRSS6T3OJH3qUir/tk=",
            "cpf": "U2FsdGVkX1+O+83WJQrkl61to6sVP4b1HeviQw89ibs="
          }, {
            "num_cand": "U2FsdGVkX191cAjYLlpzZrGH6UQpP5paFlUxxg9nOdw=",
            "cpf": "U2FsdGVkX188B8kXYdUnBz1gR/SfSMO6JuZL2ggwZpM="
          }, {
            "num_cand": "U2FsdGVkX1/wSYLdGHVItZWtB0301QejBRhmu8e1IfI=",
            "cpf": "U2FsdGVkX1+2bTLll3WgS+56Agm2vr6qjGY185Q6FpY="
          }, {
            "num_cand": "U2FsdGVkX19zIJtR8cyqE4KT6Uv4kzp4z1i7+LFQoh8=",
            "cpf": "U2FsdGVkX1/l440PT/swcWuOBa1CSLLUxo2ugr25XTc="
          }, {
            "num_cand": "U2FsdGVkX18I9MHkKnKhMXEyJxOzNIZQozN+aUjSm9M=",
            "cpf": "U2FsdGVkX1/3A2LmuqV4Fmc4jFtYX4ZhDoTfNvp9x3c="
          }, {
            "num_cand": "U2FsdGVkX18wkiBCll/MPvRZpftBeAF6tC9VTVWc59s=",
            "cpf": "U2FsdGVkX18DxUGCD6bymTS4E2G80jVfwycf7NMLAPo="
          }, {
            "num_cand": "U2FsdGVkX19wOws3xXJjQ9sQvAlstFQHbKozuJzeYGw=",
            "cpf": "U2FsdGVkX1+NJ1hZh4t43u9Iz7o8KprwQNC4bCfPKOw="
          }, {
            "num_cand": "U2FsdGVkX1/tQHiBkmVGcuhmogmwLIw3QvdUweK9HSU=",
            "cpf": "U2FsdGVkX1+iC9iurspgem1nPX1d1ywH0MZdHbk6/ME="
          }, {
            "num_cand": "U2FsdGVkX1+foC1Qlq3BG/xjmasTG0oTbylK/nCIuvU=",
            "cpf": "U2FsdGVkX1+4MIGOLts9VDctPGZfYjMOHOtxqqFkeaM="
          }, {
            "num_cand": "U2FsdGVkX18ucuvHJkZnDA4rGUYCO1L7pPKgAkLpn9A=",
            "cpf": "U2FsdGVkX18k2h3UsNm4lMcfWSeM6G3u9fdGaVwFzgs="
          }, {
            "num_cand": "U2FsdGVkX199X0OvSIsDdz0WIS3rt54zxojDbsA662s=",
            "cpf": "U2FsdGVkX191UcPKMEt05CjpfzySbZWc5lGdfAetMV0="
          }, {
            "num_cand": "U2FsdGVkX1+R2CE2ME3sXwBdr5SW7CKboGKAV2AfM34=",
            "cpf": "U2FsdGVkX1/Jzkgbe2t3CLocYOgjOPsYc6XKP2vMxsA="
          }, {
            "num_cand": "U2FsdGVkX18D+LfJkYWFc9OvHnSRIHeJMSa91W9zpPA=",
            "cpf": "U2FsdGVkX1+wSOZhV7cInfMJCXU+JpM7UIc2W3lkBaU="
          }, {
            "num_cand": "U2FsdGVkX19oZZSyRT15Qp0wklmwzSouOr3TS7f9lq0=",
            "cpf": "U2FsdGVkX1+uymhairKOJAoJjcn2GDf38Pi2TVIeunk="
          }, {
            "num_cand": "U2FsdGVkX1/HYDR3dTE991xC12udxQ0MgZ5SYV85zB8=",
            "cpf": "U2FsdGVkX19nvV1WMHqU1m2Y1Bt9A0MClV0vOfhNiMU="
          }, {
            "num_cand": "U2FsdGVkX18FaVTrT67ykN69A1b0NSPH5KSU6ga95Zg=",
            "cpf": "U2FsdGVkX1/kx7HOcrMzZQ6C6tSnY0duDjc1u+Yv/y4="
          }, {
            "num_cand": "U2FsdGVkX19GiOcaqi4AGRJc+NY/XrgrGCDahkbF5T0=",
            "cpf": "U2FsdGVkX1+eY6QtJb1KQGRkeaYtMNI8lKdR7zmBdlA="
          }, {
            "num_cand": "U2FsdGVkX1++SBiJ/6SrYQUeHEH4WLNdx7lcpuMA9Bc=",
            "cpf": "U2FsdGVkX191vFxcO/EazRgI3APzQ/OOn5VXctTjy/U="
          }, {
            "num_cand": "U2FsdGVkX1+iWUkJSQZvlCyLo2uJxLc4SUD/EpkHFrA=",
            "cpf": "U2FsdGVkX1/iOAi8NRdA+XUIYWcB2GtaZSltDxNAbQM="
          }, {
            "num_cand": "U2FsdGVkX1+0nDKrU5djIOLyJC7TdpaGc36HpltJtZc=",
            "cpf": "U2FsdGVkX1/d87CYLb+7fxqH+RxyPD5Om1+/MlRxgG8="
          }, {
            "num_cand": "U2FsdGVkX1+ztpWY4Qx6Gb78naOu79aLTxwFHwBRSZg=",
            "cpf": "U2FsdGVkX19447hYwf+Oyx98ttXatuAlfVBt6GKmmFE="
          }, {
            "num_cand": "U2FsdGVkX18hXDEU5ZWLRxDpRqV66Gt9wgpbFHhBh0w=",
            "cpf": "U2FsdGVkX19E9Ul9L4A51fyUuUEFEx0tpmLIlL8jVVw="
          }, {
            "num_cand": "U2FsdGVkX1+HdtVW+SbjvAHu7fZ69aAUZzQxsuDqnK4=",
            "cpf": "U2FsdGVkX1+A/ynvJIxrg7NigSPDAcBZIM0KWkFlokE="
          }, {
            "num_cand": "U2FsdGVkX1/X0FvNRnT3KlbOJpArx+isrxAX3DBp9A0=",
            "cpf": "U2FsdGVkX1+dzWJpm227+b8vFN11RZAqluiJYk09ctA="
          }, {
            "num_cand": "U2FsdGVkX1/fGTxYSU5xHntudDk8U1xPYamICexlWgc=",
            "cpf": "U2FsdGVkX1+cnNhFlINN5J9olVRc2+sAs1lRgtGR5b0="
          }, {
            "num_cand": "U2FsdGVkX1/WQirhjlMlmyAo6z+OFb8BVIZ+zQNiwmU=",
            "cpf": "U2FsdGVkX1+Oefn056mRzsY2Ipnunz27gC7FF5c2/rY="
          }, {
            "num_cand": "U2FsdGVkX18ZzPNah1mK42YwHNVLkrqS7InSp8cYsOw=",
            "cpf": "U2FsdGVkX1+Vgo0tvYKN4E68xtFJHIuPPHa8vtYLfWE="
          }, {
            "num_cand": "U2FsdGVkX1++XFZBuggxt/p3XVacrbw/mmJZ0Se6In8=",
            "cpf": "U2FsdGVkX18opo60kv3V+phGFXRlg4YdaMJZqdxi4xg="
          }, {
            "num_cand": "U2FsdGVkX1/2H9YyZZfnmVXikQdczHyRlT6aeFotuh0=",
            "cpf": "U2FsdGVkX193lh1RooDlQZTzijRWjoKcHIw/BUCcoGQ="
          }, {
            "num_cand": "U2FsdGVkX1/VKVMdQdB1U2jSNl9woJs+DzIQR/ITvcU=",
            "cpf": "U2FsdGVkX1+MKXBZDE6XqF2e6N8S3LMs+kLRMP/wmsg="
          }, {
            "num_cand": "U2FsdGVkX18NYd3ftno9TUoGAwmoWIOYp2UBzVJJ9vg=",
            "cpf": "U2FsdGVkX19YyXy7ODg97yGQ1PZ82QtsBFjBc4kXXIY="
          }, {
            "num_cand": "U2FsdGVkX18xkuTFpgUJ/xnw7PWn4aJlvafWUu5Bh1Q=",
            "cpf": "U2FsdGVkX18eNDhPnPDHtHvmYi9weKDFQOR72x+/fcg="
          }, {
            "num_cand": "U2FsdGVkX1/U++fzsrd8hIg7yBL2+TmSyL0SmPGS5/c=",
            "cpf": "U2FsdGVkX1+D9ExRd6LUzRynk2ctCFQOlrMawFjtqZA="
          }, {
            "num_cand": "U2FsdGVkX1/uPnJhOF1PUFDi+PSN6NXFZnJ31Pm6Fw4=",
            "cpf": "U2FsdGVkX185x+zAqNls+YQuS4h6pYZMRxcjKD/wpxA="
          }, {
            "num_cand": "U2FsdGVkX181y5NgvQ//lTT0+fJHwI9gpOnxkQsN2zs=",
            "cpf": "U2FsdGVkX19RySIHxtdEzW7ee1DkqbwjcW+61/mAylQ="
          }, {
            "num_cand": "U2FsdGVkX1+FLH4seuSP3GI10VyYU3dpx2PEAvFkSL4=",
            "cpf": "U2FsdGVkX19z6rPaAVk/Syet++UwsVwjl5nBdWh0TO8="
          }, {
            "num_cand": "U2FsdGVkX19Z8mG4aw9j+19jl+i05SjTGkZQXMKR/No=",
            "cpf": "U2FsdGVkX1/5MzmXr57I1UVeh+VU4927uYa7XE+Ihuo="
          }, {
            "num_cand": "U2FsdGVkX19yjNGyuGvGZly90PIyfwXbJIT+SNhgfj4=",
            "cpf": "U2FsdGVkX1/z5IamZAMjhjy1csR3KSqNSxPg7biLpIM="
          }, {
            "num_cand": "U2FsdGVkX1/fMFrRgpN1OSKmzQnNurfHIRWhYTUEKDU=",
            "cpf": "U2FsdGVkX1+dK51V3GLCtKF2mBHgtE5cOnS1/m7l6RA="
          }, {
            "num_cand": "U2FsdGVkX18xvVggtMFmJqqbS5iFBstNJ7lcENx8/eM=",
            "cpf": "U2FsdGVkX1/+mb0SiIDha4LESlHTFzcroWBZKDBBDgw="
          }, {
            "num_cand": "U2FsdGVkX19/h9dyozT5SK38trv48HD/R3j1q31b6eI=",
            "cpf": "U2FsdGVkX1/ARokKAFhJhBjVA3+vnb8BbanhPWCp+Zw="
          }, {
            "num_cand": "U2FsdGVkX1+k/JgXRoZt63LalegXAPCYH2X53FcX04Q=",
            "cpf": "U2FsdGVkX18d+9/YD2/zF9HAWtuaRhq7A1yAmD6+zbI="
          }, {
            "num_cand": "U2FsdGVkX18WaGJokCsODbJA91/nQMXS6Sx9NhOBGwQ=",
            "cpf": "U2FsdGVkX1+/TcndMw7euGrpr7xVhyf1/6Nxh2rzefo="
          }, {
            "num_cand": "U2FsdGVkX1/GaMU/8z0JOx576r+1etWRkpkSKDySlTg=",
            "cpf": "U2FsdGVkX18vyt6McM2QXjJcgGJQoUf1sQK7sdf8BOE="
          }, {
            "num_cand": "U2FsdGVkX1/qgjCuUF+VDb9tfOQM10RNsD/FlYeCfp0=",
            "cpf": "U2FsdGVkX1+tbyo2yiHhw6slXPnRII6A7dGSQJjlEaM="
          }, {
            "num_cand": "U2FsdGVkX1+Sj9dQb2Q/Le6Xv5bsAnBhb9Gedj2t5Ew=",
            "cpf": "U2FsdGVkX1/PhroFjt7D5NhiCw75L+qt+u+xPb9ET8k="
          }, {
            "num_cand": "U2FsdGVkX19JnuKHUY9x7+MrzwFpr6oCTgSZjCtGis0=",
            "cpf": "U2FsdGVkX19PxV5AdYsp2RMb3O6bxyxnagNsQePTVw8="
          }, {
            "num_cand": "U2FsdGVkX19WLJUcTH0RHYIFuLwpQt1tSixicBr1slA=",
            "cpf": "U2FsdGVkX1+fNLkMVSP/TBUL8o65nE5IvN8RbG8qaEU="
          }, {
            "num_cand": "U2FsdGVkX18otl/EDyf//Xz5pcSTBd9wWLj6FguEJQk=",
            "cpf": "U2FsdGVkX1+Bg9eFdnerm7AMM1xx6apdaIFofzCMX+U="
          }, {
            "num_cand": "U2FsdGVkX18SRaYZxVVHaqAZen+nQWe3rd2VDkBPbd0=",
            "cpf": "U2FsdGVkX18YXT4w9+C1pty/RCuBYcWCTBc5FZc+ATw="
          }, {
            "num_cand": "U2FsdGVkX188poV6nEgfMfokYhctrVFKuGkGPD4NnV4=",
            "cpf": "U2FsdGVkX18KHsiT0fhD6ermM1sKpIxfXnOUTFxxfaI="
          }, {
            "num_cand": "U2FsdGVkX1/lqtMZWgeyhAc+r+RfsjEncZp2KN+5udU=",
            "cpf": "U2FsdGVkX19Cows+bOtpCdI+qYQAYgmcDO38ANTE7C0="
          }, {
            "num_cand": "U2FsdGVkX1+U56V0f3TyI/WHWU3hPF8omCNFiQIQp7M=",
            "cpf": "U2FsdGVkX1+gbAIef9E8lMyx65/a4Q3g1WzeDQKwtoU="
          }, {
            "num_cand": "U2FsdGVkX1+COBaWJFjH0T8VPzz9RYas5n4Br/j8RA8=",
            "cpf": "U2FsdGVkX1+JHbXaOxD/q++Wm8URqMHpLuSi1Vw7p2E="
          }, {
            "num_cand": "U2FsdGVkX1/dJDNK8kl611B2QnYyxBEoCVU6t0w1ppY=",
            "cpf": "U2FsdGVkX1/47gp75x2+CxeajIw8Xgg/DPB0LiNPxIg="
          }, {
            "num_cand": "U2FsdGVkX18Q/t4ayhqzEAxJLhMqZFqGw3WABDtlwxY=",
            "cpf": "U2FsdGVkX19IbcLTkmQTTaKqwPCTxVNChLiAswyd5wQ="
          }, {
            "num_cand": "U2FsdGVkX1/NZuQoZnF3IjQdxND3CcXmAWcZf52lQEM=",
            "cpf": "U2FsdGVkX19G2o6x8M7817a3Maq/1CqFIPLcKz05YgA="
          }, {
            "num_cand": "U2FsdGVkX19xVZ92ECOP4SC0IqcHd88vuwKUhC22hmI=",
            "cpf": "U2FsdGVkX1+HgD9DH67n5/B57mVv5qY/FUiPwsKKIp4="
          }, {
            "num_cand": "U2FsdGVkX18BVgIPszE7WRkVm2MQACZ92Y17Sr3ZU5w=",
            "cpf": "U2FsdGVkX1+GfX2NwsktkVU5FixL3U7pUICudZ0edDM="
          }, {
            "num_cand": "U2FsdGVkX1/xLD4NRU4ZAQrncvD4IVMaXmEsGHoz2dw=",
            "cpf": "U2FsdGVkX1+R/Rdgwj7ChSoPkoS9D9KZAq+7/lvprLI="
          }, {
            "num_cand": "U2FsdGVkX1/GeVGgkC3k4Dc9BzMp4pLRD5z93eTHDyg=",
            "cpf": "U2FsdGVkX18dJoF4GuYnc4zZhs5rZOOIiLcqUK01w+o="
          }, {
            "num_cand": "U2FsdGVkX18IJH/mIJ9mncuv+UH45aIZ5dyYpIYdx4I=",
            "cpf": "U2FsdGVkX19wM6Wy8Bzj33qsLKlqJDfRtonCWJuT+yw="
          }, {
            "num_cand": "U2FsdGVkX18mabYfwsMZjcGLA55uj5+AduoXRDdulB0=",
            "cpf": "U2FsdGVkX19pylfuVQAD+0YReXNHFDs/XoOtGnTYMss="
          }, {
            "num_cand": "U2FsdGVkX1//Apvn82Rn2sAmtgg9rLW0eSgpDe2SdJY=",
            "cpf": "U2FsdGVkX1+6ugUC20D4pyJMbjgTKyn7LRWJM3o2zXI="
          }, {
            "num_cand": "U2FsdGVkX18EbClqdahlHAtX3YQvfsdDqrOzuJhftj8=",
            "cpf": "U2FsdGVkX1+F6QcRtdnzlNgF0CIC1pV6lzX42pJLv4M="
          }, {
            "num_cand": "U2FsdGVkX193Dj2XzHQNpzQ2xWr3EPsXTfHHksjZd0c=",
            "cpf": "U2FsdGVkX1/Ov6WCiX8locvcXhKhBtruxA9mFyjnZNA="
          }, {
            "num_cand": "U2FsdGVkX18gw4/LC8TgDxijPw3ey6I/QAUJoM8Vrn0=",
            "cpf": "U2FsdGVkX196IWKFv2xCBUZ9X4/ABAZvcrnmhTUhlXA="
          }, {
            "num_cand": "U2FsdGVkX19eQTAJUHlMpP6XP9MrowqDzMKqh5iRViY=",
            "cpf": "U2FsdGVkX1/05bHr5FWY7nEv2Kc7FAAcEFkw1Qyj6Mc="
          }, {
            "num_cand": "U2FsdGVkX1/Az0G8RebP9UJHST5sWTa53989jPlfYBw=",
            "cpf": "U2FsdGVkX196+MxubBM1uMKBu/NkhvexeefvPiy8Z6U="
          }, {
            "num_cand": "U2FsdGVkX19Lh0J0oB/fmV1tQ5JeJwU+nK+zFM8wvFc=",
            "cpf": "U2FsdGVkX1+Ptbnk21ru6hjoBpTbY+qzNaOUPCGos8c="
          }, {
            "num_cand": "U2FsdGVkX1+24Yr5Ud4YwaUbXPpOJyPE/+sg87vn/2U=",
            "cpf": "U2FsdGVkX18cXpTkofAzGBQJKkUVMmMWElu55lV0Ae0="
          }, {
            "num_cand": "U2FsdGVkX19VJhWD8RTzqFWxuFK0QjnxMn/eVggtaYE=",
            "cpf": "U2FsdGVkX1830AhcBq2Eisek9qqYvdprAmCXK93yN4g="
          }, {
            "num_cand": "U2FsdGVkX19eVJvD1PytV3dVxS3xGnXPtB+hSuta1WA=",
            "cpf": "U2FsdGVkX198JSNRXp6tTWCKGWkqtILSEC3HSVY5Jnw="
          }, {
            "num_cand": "U2FsdGVkX19UIlrRQUP3ZYGuvxLVSQ2CXDY6Ykk4Rog=",
            "cpf": "U2FsdGVkX19urZv45x+WhKv5NWL2UhXv/zMYK5Hl1Os="
          }, {
            "num_cand": "U2FsdGVkX19vSNx4gN7UYSvOiyUcFon6wdYOV/7L0MI=",
            "cpf": "U2FsdGVkX1/LxZ8iOY4o5bh08I7xAsmGgqrJzeZTLAM="
          }, {
            "num_cand": "U2FsdGVkX18GF6+lMJjxFnE6OznJTqlsvirS6CN9BqQ=",
            "cpf": "U2FsdGVkX18+VbsZfMkPqzkaCg9SAOgvuNra+/Qex/w="
          }, {
            "num_cand": "U2FsdGVkX1/bH9b6nw7lPvibJfGVwBP+kE4nzwRROdM=",
            "cpf": "U2FsdGVkX19x5DuZWHQq8GmIJzJHup6kCgR5n3kJePM="
          }, {
            "num_cand": "U2FsdGVkX1++U0dfZGjbMqaX+blL7oH5XIxBmHAAyrc=",
            "cpf": "U2FsdGVkX18DQWFMuIAxgqdjH0896xp4xo8Rs+Wvr9s="
          }, {
            "num_cand": "U2FsdGVkX1/KJdQtSv2yAioRc0vExGcJ+uR9M5+Vw/M=",
            "cpf": "U2FsdGVkX18l23bQpcmOFSz/BW10NrApZroUUZOoDdA="
          }, {
            "num_cand": "U2FsdGVkX1++shXlOAmZ3w9Mk3WTv6pyjN/RKM9mYFM=",
            "cpf": "U2FsdGVkX18svJPNTqfKo3GIZa7UhfgThsxgepLxtpc="
          }, {
            "num_cand": "U2FsdGVkX1/VHzYrfb5bpI1wMHJBozkar94QqiIqrQk=",
            "cpf": "U2FsdGVkX1+cIVx0L7DnIbqi4AqMUmhwzwghgRWcS3k="
          }, {
            "num_cand": "U2FsdGVkX19xGEHvUT74fKPkg4pKxYAu5d6C6GH0nx0=",
            "cpf": "U2FsdGVkX1/ZpwP0sB/PCP4TaGOWaB4EdcLFHa/Sufo="
          }, {
            "num_cand": "U2FsdGVkX1+5oO5UtmuKiPkQGcjux3LB6vhG5Kl7IXk=",
            "cpf": "U2FsdGVkX18VA0TjyQRINbF9RJstcQeH+vDxbRAonoo="
          }, {
            "num_cand": "U2FsdGVkX1/5DYLFCJcSpduX11iFGS+Tl9tJ9a4+kwk=",
            "cpf": "U2FsdGVkX18qxyO4OdEmX+kRNB2DQIrwMkL6m9gSLno="
          }, {
            "num_cand": "U2FsdGVkX19xTKobGaaOEYoKOYySg0B5Q97IJBxh5Io=",
            "cpf": "U2FsdGVkX19GlbLcUju6YvaRXdlAPTsaVHemInyq/Wk="
          }, {
            "num_cand": "U2FsdGVkX18jmhYVz6hzSV1ft5NL4RlI140oJNR2luU=",
            "cpf": "U2FsdGVkX18JZxXreSEpzzWtWn8GL8z8ryWVZkSX198="
          }, {
            "num_cand": "U2FsdGVkX1+J2KRZjq2jwp5sVoYFwtpLKs0sFqo1nwQ=",
            "cpf": "U2FsdGVkX18PTIjRogvx3+Jb1lQusfOoEMfPEwl2xhM="
          }, {
            "num_cand": "U2FsdGVkX1+vQuSJpCkiWNwphncXd9GS8SKR8+5EgpM=",
            "cpf": "U2FsdGVkX18i2PZnzCCi5duK486D8KcFcRvTvd+BUtw="
          }, {
            "num_cand": "U2FsdGVkX19J+7ooFbD/Y5KYC36T0kCMNBxNQsw9CeI=",
            "cpf": "U2FsdGVkX19bbev6DvB1O7ws9eD+vC/vNWwnJ4MdDWo="
          }, {
            "num_cand": "U2FsdGVkX19glJTMYi7BzPdftR4cQSLWuiEN+YCdzIA=",
            "cpf": "U2FsdGVkX18GH/xzydzbEbp1v4BkASNeL9JNOXir6KY="
          }, {
            "num_cand": "U2FsdGVkX1+DA1lGjzxClLma0YvWdKYY2NEBuV5Ifb8=",
            "cpf": "U2FsdGVkX19fv16R1co8fm0LgFGylHby4yelfmPJsVg="
          }, {
            "num_cand": "U2FsdGVkX18puLmsAESn6XMGqbL/HzH7uY4HDNk2T5Q=",
            "cpf": "U2FsdGVkX19JXtbCMPoKgckO6P++Chm0S34aMQOQQuQ="
          }, {
            "num_cand": "U2FsdGVkX18/PKKuNPdMHajgWhi9EeQiyIbdgrXgJfg=",
            "cpf": "U2FsdGVkX1+UWffw9aEZW4JQIA8RIXi/uvSIUKGYWwE="
          }, {
            "num_cand": "U2FsdGVkX19I6dCjt6sCllZAtVS7nTqNuKxDvpzj8VE=",
            "cpf": "U2FsdGVkX19dZ++PUdc4qp7FHYuXT3kqaTWM79LEWsU="
          }, {
            "num_cand": "U2FsdGVkX19zZbYhuoWoEi2WWo3X38P0U+L/Lo4Yrdw=",
            "cpf": "U2FsdGVkX1/e4AGY9UKwliHLJ9qxDZWUY/ON+vwGJMA="
          }, {
            "num_cand": "U2FsdGVkX19EGV9uzzAVPekXGbbraQyYQ0WG/1gDltY=",
            "cpf": "U2FsdGVkX18dG4P4biCjf6s6eITM3OH+b0nSSDtrwwA="
          }, {
            "num_cand": "U2FsdGVkX1/gaHv7E7zWtu/ft46ocZrXA1qXiB8BkBM=",
            "cpf": "U2FsdGVkX1/9riFqOr16ThT/5bl08kY8X/ygaYIdu5U="
          }, {
            "num_cand": "U2FsdGVkX1/ZnEWiuqTTfOfC5nyYhQvx9fSkf+02Wqo=",
            "cpf": "U2FsdGVkX1+65PpeGJ6xEyExEXuH4EK9mMYRX1+WCa8="
          }, {
            "num_cand": "U2FsdGVkX1/fFJw42FyYVNU7R+70rb27ka6sDJmO8tg=",
            "cpf": "U2FsdGVkX1+rQ9kfcbGLPHKfDkQHWQtgGfCnH46vTm8="
          }, {
            "num_cand": "U2FsdGVkX1+a/vE8pC5rPBQJM4/uxyMRv4n2WZEM0bc=",
            "cpf": "U2FsdGVkX1+pUBkSiTCGL4t4ctwpDV5y3f84oGa8mjw="
          }, {
            "num_cand": "U2FsdGVkX1/iY3c4zqGfaJCvugVTNrtXqNWUgce3T7c=",
            "cpf": "U2FsdGVkX1/hfVLCteyuEAUO8Rg252r9FH/RN7FsFXY="
          }, {
            "num_cand": "U2FsdGVkX1/paGCu8SE82+oaSdv9IYRjx9hejMJeTcI=",
            "cpf": "U2FsdGVkX1/aIm8c90S/n4MhwBuKQQo4Sg4fk5w8z58="
          }, {
            "num_cand": "U2FsdGVkX1/7t11/ltQ0o2gZhN9uVxMVbLxLuPmLcU4=",
            "cpf": "U2FsdGVkX18HPMup57+TZO27OSxM4PkrsdO+o9EVjVg="
          }, {
            "num_cand": "U2FsdGVkX1/E4H47KEu0NtDZ74QMIT3/5FvhMttc1+I=",
            "cpf": "U2FsdGVkX1/OxQEaSL/+an24zP0TRjW1gd+6vk6psc4="
          }, {
            "num_cand": "U2FsdGVkX1+iXCCLeNon2U1CGc8tCuhPCp7NZXYNW94=",
            "cpf": "U2FsdGVkX1/6YQF372iUogp3lRYb8a7X5W6sYHZUhGM="
          }, {
            "num_cand": "U2FsdGVkX18kGPXazHy3UdkhEgiMTl4eIlHzY9YOnI4=",
            "cpf": "U2FsdGVkX19/n+2UFqgVwaVb5NRo2QRIIA4uBXo6Ue0="
          }, {
            "num_cand": "U2FsdGVkX18wrlBizbh4/a+7rvcBCxHTeX3R8rpExgo=",
            "cpf": "U2FsdGVkX1/G5kogE3fnd2wkX5N/f+5TBh7Z9M440zM="
          }, {
            "num_cand": "U2FsdGVkX1/MWQVTU2FzuE06Z5hIbBFPpsPbkJzp9bY=",
            "cpf": "U2FsdGVkX18cvoT940KYXx7ATsGg2B0MndS2YcCziGM="
          }, {
            "num_cand": "U2FsdGVkX19k3sQ1azpSml1fjnkxG0jCnbuN1SFeu0E=",
            "cpf": "U2FsdGVkX18+tg+LvkvAOF3nYTbfmVjrPdLe6shoaAk="
          }, {
            "num_cand": "U2FsdGVkX18CKdr4oJDP1ZnRHGmpIfXSFFNkKickc/8=",
            "cpf": "U2FsdGVkX1+0+gT6Ex+BxvrYFiEn3EebI199uTJ3wQQ="
          }, {
            "num_cand": "U2FsdGVkX1/QK0fwedqXezZPOX4rS3Ze4stSgJPbO7A=",
            "cpf": "U2FsdGVkX1/UgRKgKCLTHaCC2roQrEqN1uuE+nczm2Q="
          }, {
            "num_cand": "U2FsdGVkX1+RTmXnR6NV2vu5bI4V+hPyXTyaD64Rqjk=",
            "cpf": "U2FsdGVkX18nHfZWQ6SuhBpdk7rVzbtUvi/+rf3pgmQ="
          }, {
            "num_cand": "U2FsdGVkX1/kFf+q9oX55P7wVracixezQ69WkTRbe3U=",
            "cpf": "U2FsdGVkX18NscPQuYvqgn1KK/SBK83RAPMs7OyZd0E="
          }, {
            "num_cand": "U2FsdGVkX1/60mCor4iX+es92+K6yEDS0/RR7MXLXQ0=",
            "cpf": "U2FsdGVkX19igH31upSEDArH8eCAqJCmX0nb+Ugl058="
          }, {
            "num_cand": "U2FsdGVkX199ITC8O0up9fJpMKF9EtcYTPbqSgKmPGQ=",
            "cpf": "U2FsdGVkX18HSOTQOBZTEyLxEe5jjuK838wJdowGsxM="
          }, {
            "num_cand": "U2FsdGVkX1/3Osgj7t8Umj2LFBSOdufd0dRWkYa7yjA=",
            "cpf": "U2FsdGVkX1+CJuTuPh/3zwWMPFXKuqimczA+CFjiSA8="
          }, {
            "num_cand": "U2FsdGVkX1+qzWEHUJJ1u6TqZAjahpxlMQ/tFfzEL3E=",
            "cpf": "U2FsdGVkX18IXnxJCqLZUpRlXbvbsMVKz7MM6jvP9l8="
          }, {
            "num_cand": "U2FsdGVkX1/6fqdR+H/EzXcQAESIm//eGxyLo7qFczk=",
            "cpf": "U2FsdGVkX1+e7OXNjaYOcQdDlA4J9MfJgGEmDoVAbx4="
          }, {
            "num_cand": "U2FsdGVkX18soqOyZhGuxPIxbMkTP67vWtbCj3e8dsU=",
            "cpf": "U2FsdGVkX1+EVTrH9Dq5FQkFn1NC5J1ZWS8AmR0ARVk="
          }, {
            "num_cand": "U2FsdGVkX1+cCJoD/u80lXIzEQPIVYVm+5bmHcHpLBk=",
            "cpf": "U2FsdGVkX1+ZJ7NMm84HLSMT9+L1TUy7QB00njJgMjI="
          }, {
            "num_cand": "U2FsdGVkX1+LoGEd1eKbIHLWNFTnIF5nPrzCKL4KY18=",
            "cpf": "U2FsdGVkX1806WQBOu8Lzs+HnQaH09CfqFRxbc5/+AU="
          }, {
            "num_cand": "U2FsdGVkX1/tqElncNYn+7Zeqr1/Vm9H/ZDVFX4KKgw=",
            "cpf": "U2FsdGVkX18m8tqYNjA1RYqSLldhsQCkxwDTUKvx2JI="
          }, {
            "num_cand": "U2FsdGVkX18XYU+krIkR8CE8cBgPv/DDo5xUucbbkjA=",
            "cpf": "U2FsdGVkX18sSzqkJ2I/nQjAhSEnJRNsxutu6XRzYiQ="
          }, {
            "num_cand": "U2FsdGVkX1+xZYPyhfPJ2qgsn3JWvd9y6aj9l1jk6nY=",
            "cpf": "U2FsdGVkX1/2vGdYaDI/4KlAHp+Qi8TointpSTCANAI="
          }, {
            "num_cand": "U2FsdGVkX190jHfkmMkS0UdILPGKt6ALNdyxGKTEI0Q=",
            "cpf": "U2FsdGVkX191euniVsSiOVAPI22i3PykV65OacSmDw8="
          }, {
            "num_cand": "U2FsdGVkX1+J7/l53x6JaQIdAwqsDrKcIhM4oRdgd7w=",
            "cpf": "U2FsdGVkX18lwTLxPkRD/40fvRPI7s0dNh0im3Ymcto="
          }, {
            "num_cand": "U2FsdGVkX182hXp2JgqAcYkRPdXFAd8QUgWE5XxeAcA=",
            "cpf": "U2FsdGVkX1/3SAcvkKe1tNsxv5br5L830SS2Q+RV0GE="
          }, {
            "num_cand": "U2FsdGVkX18sYeoj9tybtuKzZfDXpVo+GQ4VpenzpPo=",
            "cpf": "U2FsdGVkX1+chCdrrnbOaNONb3YNu+WFjc/b172PYxA="
          }, {
            "num_cand": "U2FsdGVkX1/eADfuA0F37ncHSP8rkd+z28dQIz82Ld4=",
            "cpf": "U2FsdGVkX1/idpSw5FpsPA1zO1SsAkV0bvdo8PrSE+E="
          }, {
            "num_cand": "U2FsdGVkX19DdpNCI49U91lOs99eB5T0I0Nx/pgUDqs=",
            "cpf": "U2FsdGVkX19kQQ82LTqBmYdfWWVIZ4GxE9kGr+XYQNQ="
          }, {
            "num_cand": "U2FsdGVkX1/90kmMiDm26lh65biguaJzqGowRtgGx9o=",
            "cpf": "U2FsdGVkX1+tt16jKgR+1wuXNG4UECqUXgPk3XjIq68="
          }, {
            "num_cand": "U2FsdGVkX1+/C2ko9FYcViwzWkkwHEdH5Rsas1Ly1AU=",
            "cpf": "U2FsdGVkX19Yfeddb9lVscwkHexp5fwlBagLQ6YnAVw="
          }, {
            "num_cand": "U2FsdGVkX1/8nd178ctE5CmtO/Es7iCqZMspkrmsvbY=",
            "cpf": "U2FsdGVkX18SQeQrvwnT1APiQETpYZcx4J6neKfV54Q="
          }, {
            "num_cand": "U2FsdGVkX1+RCYoQv2gVEfDBxxJg85AXZqaiF2V27So=",
            "cpf": "U2FsdGVkX18KIOyJ03qR2ZO09LONEciauDJVrrjBZuc="
          }, {
            "num_cand": "U2FsdGVkX19n/JRYB/Vcnuv8Bf9l+MWsvCONvQCqB/4=",
            "cpf": "U2FsdGVkX18fKJv43gFVusclC8twDd1k86sp9nPBdyE="
          }, {
            "num_cand": "U2FsdGVkX1+1SOnqzjV6qad1t+qRNpcNwMl9FhT14S8=",
            "cpf": "U2FsdGVkX1/VwjsjVIDBeEXeQ2PDFLtUzAL09riFLE4="
          }, {
            "num_cand": "U2FsdGVkX18caIgoIUTSqOEVqXIlU/3uQU5aE8C9Ez8=",
            "cpf": "U2FsdGVkX1/f5zy4zMsopI8Ki/ldvREjoGpiPm9x2Lc="
          }, {
            "num_cand": "U2FsdGVkX193ZL6W8TIVwf87muJKG82kf8TvRSGveiM=",
            "cpf": "U2FsdGVkX1/QBRo4YO7BSsIfYHbkThw3P565dJRPr2U="
          }, {
            "num_cand": "U2FsdGVkX1+x3MhHdzyQttsSd5pnzbkBe4V05dVyzB0=",
            "cpf": "U2FsdGVkX1/yq4d/NXFv7cX10ByANYPgW5Kr9Jt4J64="
          }, {
            "num_cand": "U2FsdGVkX18e/NTjjJOhs0CNXcXlrIU4d+SEKvcnBbg=",
            "cpf": "U2FsdGVkX18WriESx1wkUzoierAc5/3nGJp/LIy49bs="
          }, {
            "num_cand": "U2FsdGVkX1+BS+8y1spY8ywzp5hdFR/8yLhcDkXP5Vw=",
            "cpf": "U2FsdGVkX1/jZ9QPKpDddzwp878SPHfckAq5yuBk+rM="
          }, {
            "num_cand": "U2FsdGVkX195BasBj7IeUJrSI9V67gxXgAOYPiNt/lQ=",
            "cpf": "U2FsdGVkX193NGjPY5nxnX2DOKONGDioOYu0Qalgpm8="
          }, {
            "num_cand": "U2FsdGVkX196nMnHLdhzyE5B/t1DI2vzDyaXaVTHoHY=",
            "cpf": "U2FsdGVkX184efIM5I7CdxiAgObNeujC4oSxYX48aEQ="
          }, {
            "num_cand": "U2FsdGVkX1/lskzW43olL14W+owbLYmErl/ydYddz8I=",
            "cpf": "U2FsdGVkX1/KAFYCfx7iTAXFCSOwM8YURPgRuqlT50Y="
          }, {
            "num_cand": "U2FsdGVkX19UCZ+OjQafrg0+9PW6YJhbcyCwcrdOtUQ=",
            "cpf": "U2FsdGVkX1/l2sxrtt7i2pvULnwbl0Qa+Z2SNheeO44="
          }, {
            "num_cand": "U2FsdGVkX18fZS2tU6V+2Xc2XbHzkN+sWSKUZOrven4=",
            "cpf": "U2FsdGVkX187LALcb/9NV8Ifp1ujwjXkHnXUkr5vMFg="
          }, {
            "num_cand": "U2FsdGVkX1+bFeNkg0YUnejstIJCAVsAeO298TWn3JI=",
            "cpf": "U2FsdGVkX18mVNe2c3CwIe0Ow3B6Ix6m4cYXsiMybCU="
          }, {
            "num_cand": "U2FsdGVkX1+OV6A3JDOIsN1WRGilA/B/AKgjIwO60Fw=",
            "cpf": "U2FsdGVkX1+CHFJmVCIutthtz/ThMynTKNuafNOJnao="
          }, {
            "num_cand": "U2FsdGVkX1/FJUd43oyl/lQf216lDwcbkjoKzItx+6A=",
            "cpf": "U2FsdGVkX1+iRm4jGPN3bPduNqveL1KRFqNvomqZ8VU="
          }, {
            "num_cand": "U2FsdGVkX1/HhGB/kzKQ4CLn4kzRONZfdI1KZn/r8B4=",
            "cpf": "U2FsdGVkX18LXkOUcHZrmzvuBdmO6VC38iMZNKzGGgw="
          }, {
            "num_cand": "U2FsdGVkX1/wgXA603CDZUa8QktCirxitzUD3EsOGow=",
            "cpf": "U2FsdGVkX18plTM/3GwqIK/qI2y2hCx+TP/78CSdspI="
          }, {
            "num_cand": "U2FsdGVkX18p8EaxADAT8tdio0ImUnnD+4XflKg5QKo=",
            "cpf": "U2FsdGVkX1+ckLn6MX9o8zgAfMdp++I2QgWA/6V8KF4="
          }, {
            "num_cand": "U2FsdGVkX18y7Ts+JgyaFWIZny4dCc3pXx6W45oAsr4=",
            "cpf": "U2FsdGVkX1+eV4y6sbUaZo37xWHd6oSrGFonium+wak="
          }, {
            "num_cand": "U2FsdGVkX1+pRO84o0ayBdG9FdInY1kdxBUjlZlrjZg=",
            "cpf": "U2FsdGVkX18kyvimMz+VMVLJnpgAGzfunl801/C/X40="
          }, {
            "num_cand": "U2FsdGVkX1+ql3YfKUGcg4wrJLpcNDorhNCJZS9kGYY=",
            "cpf": "U2FsdGVkX1+WUVY9/U803YivYC020Tj8ah+ccFDfyq4="
          }, {
            "num_cand": "U2FsdGVkX18QAbvlvGkEH3jQIQLKnFkcgHc9Ipq7p+4=",
            "cpf": "U2FsdGVkX19mWvK6SY9GI1jR1Vlllr8THF5VrNx2ipw="
          }, {
            "num_cand": "U2FsdGVkX1/MfKH4Mm5gBZUbFZJsE17rTen8/f85XsM=",
            "cpf": "U2FsdGVkX1+fSXuMzSv8PH37RHEY/ldqqiHEdZXZu74="
          }, {
            "num_cand": "U2FsdGVkX1/ua4SW7haMDMCCenOFZ+IOvLqab/o95yQ=",
            "cpf": "U2FsdGVkX19LgiMKYpyyqxMgFbH2RmZGGbkuYWzsNbM="
          }, {
            "num_cand": "U2FsdGVkX18o4GfN6uRHMMniYVVxuy6jm2ZaO+X1TEM=",
            "cpf": "U2FsdGVkX1+grNrhWQ8CxA5cslZrHhjL95pNSh+xXgs="
          }, {
            "num_cand": "U2FsdGVkX1+i/zrkR4cD9YuMTCA8NqUvw1SzH6QzGps=",
            "cpf": "U2FsdGVkX1+ydwO3b61axaw7mIt8McjNup7D90NPqto="
          }, {
            "num_cand": "U2FsdGVkX1/VspD1HTHR4Qd+kGdrkW7IijpKs/PjvF4=",
            "cpf": "U2FsdGVkX1+NO8eCzETMUczYjYUOYlMinScfrbOwiAc="
          }, {
            "num_cand": "U2FsdGVkX1/54v21+h1vKYidxpWEGt76Mv14QITWFbY=",
            "cpf": "U2FsdGVkX1+qbsob9oNjwk2EE+JhgBlj3wEtTMeJ8Pc="
          }, {
            "num_cand": "U2FsdGVkX1+vpqqIPK1V4KHAcC4iurRkB+m13RvHqBs=",
            "cpf": "U2FsdGVkX191pUeKaGw4wcG9koKYwv1UH/O7snW8rss="
          }, {
            "num_cand": "U2FsdGVkX18+5xjMZ3vV8cjM1yH1A7jko/1KoqCR3Qs=",
            "cpf": "U2FsdGVkX18gbIzi2MZTVnVkd65CZd9EGJ1l55hG9cQ="
          }, {
            "num_cand": "U2FsdGVkX192t+keEQFLRipeUkwmgLoQLhAvw8quhI4=",
            "cpf": "U2FsdGVkX1+xzH38jXt9wBabb0s6VUfPVKvJeMqK7qc="
          }, {
            "num_cand": "U2FsdGVkX1/yAsjWuvDNrHKGHzVF518E+fRmvYpX/xc=",
            "cpf": "U2FsdGVkX1+mxKMCPbpfGtAZ1dZgJN5XC0EsRMvSaHU="
          }, {
            "num_cand": "U2FsdGVkX18PysLl7JltcnsB2p87PP1pV438LvzPaqk=",
            "cpf": "U2FsdGVkX1/nMeQQLE3EFpNys2pE30YE9thzt90qTKg="
          }, {
            "num_cand": "U2FsdGVkX1+sJJq9/uN8gIvADxNXrl3z/krpz/yYCzs=",
            "cpf": "U2FsdGVkX180HgqqG3Dd97KIkPQ5EISePrYRxG5m7n4="
          }, {
            "num_cand": "U2FsdGVkX18fk1Y1HcSxVhEqp95kHbpCCWv5HYGM0oU=",
            "cpf": "U2FsdGVkX18DPbMG3XFww8Ajelc7Khke9b4zgxInerM="
          }, {
            "num_cand": "U2FsdGVkX1/He2jFItnC/8cq1bl+9mOcY8/EXIINbdc=",
            "cpf": "U2FsdGVkX1/Li9ZapHrh7jThqTcJnAFRn1U/CTQlLKM="
          }, {
            "num_cand": "U2FsdGVkX19LSTsm/UL9Z3Z2yspLFm6yS/1yEjZuSDI=",
            "cpf": "U2FsdGVkX1+NjugUYGVd5jdCU1aBklMMPqMA3BfPihE="
          }, {
            "num_cand": "U2FsdGVkX196x5fMYliEJJpic/7Q+hIzuzNuICfB2+s=",
            "cpf": "U2FsdGVkX19NlAuM8sQdi5+W6Jep6gArRbwdUY2DjkU="
          }, {
            "num_cand": "U2FsdGVkX1+fuXRCYKN0Pg+JnsK1AxWGVWHL9ZnF/SM=",
            "cpf": "U2FsdGVkX1+R2hVKf5a52EWLp5lWYYRRj8OsqBB+k6c="
          }, {
            "num_cand": "U2FsdGVkX1+BXesTh9ctE39i1Dd6nVgbBC7WKWEKSIs=",
            "cpf": "U2FsdGVkX18YTD3a0pDDv77HSTcoQEL9lOkNRpWTW/0="
          }, {
            "num_cand": "U2FsdGVkX1/RG0Y4Dni75vfFThGZvR1qMHA3PccfTMg=",
            "cpf": "U2FsdGVkX1+Paii0MkUduuQa/A/yDJdevRzEoKwTq5Q="
          }, {
            "num_cand": "U2FsdGVkX1+o2rGEAsObfdo01AI1KDwf4fS+IPBuzTI=",
            "cpf": "U2FsdGVkX19JVdH86We6wPvmYRGW1z877IWUVqWBEhU="
          }, {
            "num_cand": "U2FsdGVkX18NO5VJYkcdnwzVXtRqsYBhyFaAd+dW5Ng=",
            "cpf": "U2FsdGVkX1/VWLKkAa8QCE8aru7pptAOqbvA8xvXQRs="
          }, {
            "num_cand": "U2FsdGVkX1/s4f/DWgc40qTllhvekNw6RG80tWjvwqo=",
            "cpf": "U2FsdGVkX19MOBEZgzCTDVFtvzstndzHey0oC7k7zng="
          }, {
            "num_cand": "U2FsdGVkX19LnIzEuaBtWQN2iwCpWGIvzB4EONcgHDM=",
            "cpf": "U2FsdGVkX1+BnbSORlmloSIXkx7/ywQzVYsiU2QD9YY="
          }, {
            "num_cand": "U2FsdGVkX1+i8JCIcW58tpNONaiWcZo9kXwS5/QlkDU=",
            "cpf": "U2FsdGVkX19+8RM17pmp1B6RxS0XJc1DlSqH/Ds3zX8="
          }, {
            "num_cand": "U2FsdGVkX1/CVyKxJZee2RDjYXza2+uuoqvH+DxKvxI=",
            "cpf": "U2FsdGVkX1+iJVRSBG5ZBKYKZIvoalUFi0b7CoG5N54="
          }, {
            "num_cand": "U2FsdGVkX184S6BzbvRbgcjDuue+zJdkrSHtuBzOTo0=",
            "cpf": "U2FsdGVkX1/l03d2qPnYnE789cdcKnCgaog/dIy7fzA="
          }, {
            "num_cand": "U2FsdGVkX1/70ANQVIkM7jHWaUcT2ll/NwC62zw6sf8=",
            "cpf": "U2FsdGVkX1/VtEp/iNayILV5qrZMexEharVLakc2xLI="
          }, {
            "num_cand": "U2FsdGVkX1+AQv+E8JPvoHvezyMgVVKplfOyS2h4ZkM=",
            "cpf": "U2FsdGVkX1/u5iwqdGZB6Mw0oBt+oXnXsBsyumxxa2w="
          }, {
            "num_cand": "U2FsdGVkX1/j45lmI+6nMaZ7XiGcoHM19JBte5Y5FvM=",
            "cpf": "U2FsdGVkX1/6knTk/bAjhBDQo9nIDJS1y75r9be6wdw="
          }, {
            "num_cand": "U2FsdGVkX18/L8t7bM1/+CeCGaeIagICjB8KD3NuuBI=",
            "cpf": "U2FsdGVkX18iSGrmMwSD9MTCX56fCXtjZlvip22JOts="
          }, {
            "num_cand": "U2FsdGVkX18O4CLUabIxKLUU3LJc0ftkuSFV+4+uoFs=",
            "cpf": "U2FsdGVkX18fc8XkQSvDysg+1CVBj/g5IYaLLQiQJ2g="
          }, {
            "num_cand": "U2FsdGVkX181bSRK3h5DMmysB6yqPL/l/VQ01l8DXeo=",
            "cpf": "U2FsdGVkX19a3vgNxqvBja1aG0MuwRrwjqWiOwX9GGY="
          }, {
            "num_cand": "U2FsdGVkX1/ZDCmlJc1MXFvnw6yBt5xZYfh82wub4jw=",
            "cpf": "U2FsdGVkX19CHJcVauS8el9i/men4Iy8nG1UsDkNLvo="
          }, {
            "num_cand": "U2FsdGVkX19n9hJ288JRj2bCIarguMa+6Yh1xua3apQ=",
            "cpf": "U2FsdGVkX1/AzI0KpAS/kSngduCZE/4H5+tfCVt/M98="
          }, {
            "num_cand": "U2FsdGVkX18p9vU46T0Ebude6mA2b3e0XpUNv33oQpU=",
            "cpf": "U2FsdGVkX18n08QWi9r7gSidixAFuCDxaah6IDe9Ee4="
          }, {
            "num_cand": "U2FsdGVkX194eBB4vTX+/fj6ln7rmiAz7fGrfr4tkv0=",
            "cpf": "U2FsdGVkX1+pCtGA4cBr8sZ+sTc0Yz68DlhmCfv9CNo="
          }, {
            "num_cand": "U2FsdGVkX19q/TfYobp+Q6b3hi1VbqF/COB69+ozE5o=",
            "cpf": "U2FsdGVkX19royK2fF29uRNh1Nnup813EO6b1w5z4cI="
          }, {
            "num_cand": "U2FsdGVkX19lVlGPBHdaXCxKPgLP2ps4D1o3nPPA9bQ=",
            "cpf": "U2FsdGVkX1+rMbpf7Jf/SahAvLQIJF7oPzgEjdziJjU="
          }, {
            "num_cand": "U2FsdGVkX1/KzR30qDHVfZHwsyOPFEfQXxtJQPt0+kk=",
            "cpf": "U2FsdGVkX1/3XatoyVd2WOniXek/gMX1wpNs+ZmeTG4="
          }, {
            "num_cand": "U2FsdGVkX1/tafH6gquwpiQn1XZzXBvR5YXMMskzHGI=",
            "cpf": "U2FsdGVkX19G0zElykpKIQEwZJghXStjKVR98GcdTbI="
          }, {
            "num_cand": "U2FsdGVkX19Akpt2kAkzgd3qb2aSMIAX2GPilplr1WU=",
            "cpf": "U2FsdGVkX1/wcqsKOWN1O/+kqZbfFzLoPo/M6LHsdxY="
          }, {
            "num_cand": "U2FsdGVkX192v0oDmExVIOb8zrxQlLo9al8F9S/HXWM=",
            "cpf": "U2FsdGVkX18X9cw4At++M8FqQEFJYkReIGqnxiKX5Tg="
          }, {
            "num_cand": "U2FsdGVkX1/NkQXnVAtEub9BEkMi4X/tjHKlD8qPBYE=",
            "cpf": "U2FsdGVkX18JQh9p0RW86tzwkBqZLNKKyQNoqATclLg="
          }, {
            "num_cand": "U2FsdGVkX18eaWfBNE3I7D4mH9N7nrZXdPSZx20Dse8=",
            "cpf": "U2FsdGVkX1/oDlCGLGlcD4SKcdMsULdlwWGndBNtoxU="
          }, {
            "num_cand": "U2FsdGVkX18o42mN5BLDFXad59XuMYrWfe9DxbVUfJY=",
            "cpf": "U2FsdGVkX1+Iw6kbFg0nsqsvYNWAxIBkV9SBOIPUQDY="
          }, {
            "num_cand": "U2FsdGVkX19r5n3uv2H7iT9bJh3qaMxJSnY9zS8IdIw=",
            "cpf": "U2FsdGVkX181S1TjLzQiaPhwyXMQdNLs37Oc3PqQQbw="
          }, {
            "num_cand": "U2FsdGVkX1+K0hOc41YaE+Z01gjt/SaOqkj52hYskyY=",
            "cpf": "U2FsdGVkX1/bDGTuqP77yhyTqnQnnpsB/N7GjpFGMTY="
          }, {
            "num_cand": "U2FsdGVkX19RN+T45xYYAVwW+cdWaeTbagyoPkJabLE=",
            "cpf": "U2FsdGVkX1961/0WNIUlRTOsm2+IcT1ICrBNJn/bNLc="
          }, {
            "num_cand": "U2FsdGVkX1/vLP4TH17GBkLhUe53tOZhvvPhqI66hbA=",
            "cpf": "U2FsdGVkX1+yhAxNFze0KEbonnHs0P7gaDISlNoZDGs="
          }, {
            "num_cand": "U2FsdGVkX19AEb60V0AgJKnG4zpNOE00UNhfxEzTGXs=",
            "cpf": "U2FsdGVkX1+OAFjkOAE8H8TMI+W6RVy2N9apCDgUKLw="
          }, {
            "num_cand": "U2FsdGVkX1+u3coBp4KWQbeclVctcJNYneltLd92evU=",
            "cpf": "U2FsdGVkX1/nTXKh3cGIX3jSyL3sfAc9MJvPJ8EUeNs="
          }, {
            "num_cand": "U2FsdGVkX19a8/wvAGjuQD9FieIxirYl0Gqya9or80A=",
            "cpf": "U2FsdGVkX1+FtQrD0Z5xf+H1cyer6Ed63Dl0L450mRU="
          }, {
            "num_cand": "U2FsdGVkX1+SVhjAN5S/Ac5bZRwqvAqz2g4GsjBsKGM=",
            "cpf": "U2FsdGVkX1+TVpS2DhBoh7LwrK1egRIEF1nrmgbCONI="
          }, {
            "num_cand": "U2FsdGVkX1/x7QA8lpEzhO4x/X3aecxRScrsfghwDdg=",
            "cpf": "U2FsdGVkX1+izfjRGAjgCJ3bdk84e2h37BPkSd4LrdQ="
          }, {
            "num_cand": "U2FsdGVkX1+7yEJ+folKsIpl+WpSfXl1bY0TFmk7ZIo=",
            "cpf": "U2FsdGVkX1/cGw9aXmV/GJJQ9COVd3/eu6Ys9JOJpbg="
          }, {
            "num_cand": "U2FsdGVkX19j9iUNENIHfeQRcCPXoGrc85GDdN9cjAE=",
            "cpf": "U2FsdGVkX19KoGCQjHBvqjjh1LYgfiK+6GOk+EfOETY="
          }, {
            "num_cand": "U2FsdGVkX19kYqTHPzjavLbMrBDnDYTqzlOc0yXt03Q=",
            "cpf": "U2FsdGVkX1+UyLEPCNed/M0G1EJzlL8SV/gIF73Huyc="
          }, {
            "num_cand": "U2FsdGVkX19PZZKVt70BfbjxyXO+gHA0BVy/Pn+ZN4E=",
            "cpf": "U2FsdGVkX19WIKbwK+zr6jCsukGdtQ+1QJVMpWSw6ps="
          }, {
            "num_cand": "U2FsdGVkX18quXEV5ovr/U0kTPpJHiIuhobs1PABKWQ=",
            "cpf": "U2FsdGVkX19HCRn5arqrMZ22l/kTudAMbpjvRwvm6nA="
          }, {
            "num_cand": "U2FsdGVkX1/1Y5bTroSJon0iNTNu+B+IFSNqKycFh18=",
            "cpf": "U2FsdGVkX1/EcS74yT32YQfIEtIGHPz8n2hPmK8YysA="
          }, {
            "num_cand": "U2FsdGVkX19fnki8cL3TUgi0witcIcnNxtL2qBNXtTA=",
            "cpf": "U2FsdGVkX19LA5bNWyo+LSUEQ+vTUDFEy/GYnFNDHgo="
          }, {
            "num_cand": "U2FsdGVkX19F0VzvPE4HdLOn/zWwiAeFfLUD0YA2Yas=",
            "cpf": "U2FsdGVkX19uD31o/oCzkrXTNpBbz2JEsaPuGARkfQo="
          }, {
            "num_cand": "U2FsdGVkX1+r8yl9zKQwWTNJYF10vm5+85JUSwZB+mM=",
            "cpf": "U2FsdGVkX18byNQLGXaxRiqXDXxQB+eN1kguiXD2ypk="
          }, {
            "num_cand": "U2FsdGVkX1/Fbg3M+7ChX3i+RsE74lo725xMpxCLKsY=",
            "cpf": "U2FsdGVkX1+0DxrIgQUSLIfrrrL3opSPXAqi35DcWBg="
          }, {
            "num_cand": "U2FsdGVkX1/J0Kni64fcnsLadvfcc9O5LssqhFc3u4U=",
            "cpf": "U2FsdGVkX1/AYaXLzkuqqrBcpI0c+KByimyyImDVOi4="
          }, {
            "num_cand": "U2FsdGVkX1+TAsMM8uPGL9m+TJC4FIIq484xx0XDLhM=",
            "cpf": "U2FsdGVkX1/oR84q5+Q1ckoU7ZaCbkZx5yYyqYMwE4c="
          }, {
            "num_cand": "U2FsdGVkX1+evXNdKCOcYDMv/7N1veOBriphdZ2NnJk=",
            "cpf": "U2FsdGVkX18p93BWRzXGsS1QeNzHru1PDXwbQzayG/M="
          }, {
            "num_cand": "U2FsdGVkX194uZmgIG81/f8687atenqhThuBG7ct+x0=",
            "cpf": "U2FsdGVkX19GY9pNKUu29CULlqUr6nczhXIY090Dxsg="
          }, {
            "num_cand": "U2FsdGVkX18F0+LEqZJ9Pc+urfgQ0mNc18B8V2262gs=",
            "cpf": "U2FsdGVkX1/kFUp5TYJHB8L3pUzTAivINt/A0KY2DPM="
          }, {
            "num_cand": "U2FsdGVkX1+WVw1e2GTiu0iBMhCMKvmPWzYwfBVORO0=",
            "cpf": "U2FsdGVkX1+JDlrwmmxDOf5phfeGXyTIJPROe3XMTy8="
          }, {
            "num_cand": "U2FsdGVkX1//tHrf/83swI6FxJnr+pj3pvPR8Z6OK+g=",
            "cpf": "U2FsdGVkX19bftmpA9Hgve7It3lgXnFzWz0GJmTaaL4="
          }, {
            "num_cand": "U2FsdGVkX1+ANFibjsJq8BsqxE+JtWQOuUAOzBLkp1Y=",
            "cpf": "U2FsdGVkX1/l1tnwS2pyakPXJoU3idAh+Nrh/8Fx5GY="
          }, {
            "num_cand": "U2FsdGVkX19Z838HE9q1iBRCURE4xXrFL/9mTdO62VM=",
            "cpf": "U2FsdGVkX1/ipficJIV6iS71nYH6mjUNV9K+THPHV6I="
          }, {
            "num_cand": "U2FsdGVkX1/ck3fPS+d2O/uLP/Txrag0UvKYXo6qTs4=",
            "cpf": "U2FsdGVkX1+N+/eRXgDccE0oz3CasnML5ae8o5Ql1uI="
          }, {
            "num_cand": "U2FsdGVkX18hCi+NFCHmFQhtCF1iywSu1uRyFFayT7U=",
            "cpf": "U2FsdGVkX1+m7z0ewfoNVuDXBWDc+A7lDwmk+sgU+qc="
          }, {
            "num_cand": "U2FsdGVkX1/72dLtiTmRiR+4s8phY7OxbNlthk/DB9I=",
            "cpf": "U2FsdGVkX1/UhOVhTHB018f6Xkm25g3lFcVi5ASiXvM="
          }, {
            "num_cand": "U2FsdGVkX180pBei/6e8dT0fveD/rRAXCv5Z6YGGdmM=",
            "cpf": "U2FsdGVkX18JmDKUudwob+nwu2sjkWsbhU5gPx5UD44="
          }, {
            "num_cand": "U2FsdGVkX1+E5FYkAaVk2oMonn82k/at27Uk3njUOCQ=",
            "cpf": "U2FsdGVkX19uBXhc3yT2DfJNT+Ihlvk4BvRjDr3Lqio="
          }, {
            "num_cand": "U2FsdGVkX1/mQXL6v2KQhtNh1cVWwUL/aEEtw3oGMVk=",
            "cpf": "U2FsdGVkX19/HZKxKDs5NlL9a+GIG5aqLzirNEMbDXM="
          }, {
            "num_cand": "U2FsdGVkX1+o51whfLbupXqEVwMGfpcNZWdDi7PTEQE=",
            "cpf": "U2FsdGVkX19hmjr615mTDjIMkqjaRsNjNNBp2FHmsZ8="
          }, {
            "num_cand": "U2FsdGVkX19u6m5i5RdSlOZxda8Bn00BDQes6QOCogM=",
            "cpf": "U2FsdGVkX19mcFdYwTEwVgb0tvkDXQMoxPvffc/uWps="
          }, {
            "num_cand": "U2FsdGVkX19fTbG9erVcrtPDbT4501PMnQhZiYCm2CQ=",
            "cpf": "U2FsdGVkX1+6l+0+XpJ5Gb/WwuxPuU/ueGsd/bYpG1Y="
          }, {
            "num_cand": "U2FsdGVkX1/nnuXIg078Yumkf6hZV4rHc2ha1qJzYJ4=",
            "cpf": "U2FsdGVkX181SdnjR/o8O70W4wm893KhPpPesySILxQ="
          }, {
            "num_cand": "U2FsdGVkX1/K1DvQMXRX7lt/IXyHrZ4peILGbvnW3XI=",
            "cpf": "U2FsdGVkX19NIjPNma03aZWsD6t9nWTrNDjK6d436WI="
          }, {
            "num_cand": "U2FsdGVkX1/qTmOg+9Ab9GiquA3x0eAWsxtvpBxELLs=",
            "cpf": "U2FsdGVkX1+rkvjcAGauBzcSZpqC98ft+Rs/L3PsHaw="
          }, {
            "num_cand": "U2FsdGVkX1/wo37bCTiPIrFK+09lxRs8LyrPBhi1Sy0=",
            "cpf": "U2FsdGVkX18cH21TqxDP/Hg4T3MIutCmoe/5yCoOPzk="
          }, {
            "num_cand": "U2FsdGVkX1/lKGeHAKCyh446yOCbUgxbrOI1CKnxzkU=",
            "cpf": "U2FsdGVkX1828lrb0yxB0RwhJoc1Od+xcqgOvFb6vlc="
          }, {
            "num_cand": "U2FsdGVkX19nufEk0nVdst2jDB7yKeXc9ZzCBYOd1y4=",
            "cpf": "U2FsdGVkX1+HlkgS9i6+C4sphIUrqPlH+eq5lXxqDvI="
          }, {
            "num_cand": "U2FsdGVkX18ZZfcMb7aFyvHM8BaRc08pmrIhCe1lzrQ=",
            "cpf": "U2FsdGVkX199bHz7AwCa0iZyA8OcZHlNAeZ0mAJVFYo="
          }, {
            "num_cand": "U2FsdGVkX19GlaH9yLgbG0CS9ngqyfVVw9jSYuKQ6yU=",
            "cpf": "U2FsdGVkX1/5sArrAOXDxoeAq+pAnpYgcZDqwNeJLXI="
          }, {
            "num_cand": "U2FsdGVkX1+S6Az/IXg0Q7cwAvq/0oBm1NouWExzOnY=",
            "cpf": "U2FsdGVkX1+fiQH5nV2mBMWmoboSmS0dcq81yCqOcb0="
          }, {
            "num_cand": "U2FsdGVkX183v5SdQqnYARmgd4OKkgv5fNxvUgLS2r0=",
            "cpf": "U2FsdGVkX1+YtgIwH7ZskJEEUqCBIJg+SminMa9C8Q0="
          }, {
            "num_cand": "U2FsdGVkX1+xh8DKr0kwIpSHROW6Xsd6IKCPDzJh3Qc=",
            "cpf": "U2FsdGVkX184Piq4Ku+4gE5/LdUNcdvCTlklnDY5JQg="
          }, {
            "num_cand": "U2FsdGVkX1/XDNS9WKJYb7OmHAvaqy/c+v9L7F5pCGE=",
            "cpf": "U2FsdGVkX1+CYbaCUf8vdxaPFbzGPl7CWAURp3WKBBM="
          }, {
            "num_cand": "U2FsdGVkX1/jqNqRBiHIovZQ9U/0dccP0c5FLxe7EuY=",
            "cpf": "U2FsdGVkX18IyRkP/cle/d0riJuFlGXsbx2h7TCqQHs="
          }, {
            "num_cand": "U2FsdGVkX19SVSKoDJsRMePlRf8j0yX8nW7/xk3mXRM=",
            "cpf": "U2FsdGVkX1/zV7aq06BlGOWCJZcI6604zjM6Hlhjt40="
          }, {
            "num_cand": "U2FsdGVkX19lO7X8gqDA0BWcaPr2HJ9p1NJGmeOmOQo=",
            "cpf": "U2FsdGVkX19OWJvHVyY9/TtGES5f3Zo0FJsjVvkj/2Y="
          }, {
            "num_cand": "U2FsdGVkX1+FPAr2CG1oMYgg9qpkFXTR7TKzSs+J6G8=",
            "cpf": "U2FsdGVkX1+71I1XLwqiZjqg8CPCKlGV5ZMYwxgtvsA="
          }, {
            "num_cand": "U2FsdGVkX1/k2cjJvvWEzuc6LFE/5EMsoSS5wBhaoyQ=",
            "cpf": "U2FsdGVkX1/g4szjifVXCyQKGV/UJVYL9t+zaz51Of4="
          }, {
            "num_cand": "U2FsdGVkX1+rA2v2M9VbKjiSUyl3yr7v/TVsQ7G4TJI=",
            "cpf": "U2FsdGVkX1+P2iJbMR+C9peaqzG8q0EXlLy57Ql6xcE="
          }, {
            "num_cand": "U2FsdGVkX1/wDL4DqsRG8UgRBaof0OUUpt5/EGu+pl8=",
            "cpf": "U2FsdGVkX18bXmuWBlwU58brLurmO00dW0g9rcQ3gx4="
          }, {
            "num_cand": "U2FsdGVkX1+g1meVgX+m9J7AzJP3eY1bj8q5fNxPQTk=",
            "cpf": "U2FsdGVkX1/00StDwbSmg/cqS+QntzWrpqXuT0lLLA4="
          }, {
            "num_cand": "U2FsdGVkX18E4WArbfiNl8b5gj/mW4rngcGQa0nJZHo=",
            "cpf": "U2FsdGVkX1/0MKq0j/2ZXANeU6XfwcasEy7nFqNKcSE="
          }, {
            "num_cand": "U2FsdGVkX18oGq+ad4byQ/OdBXHR/zFyP1G6npf0r98=",
            "cpf": "U2FsdGVkX19lNgsX04xzrOlL8TPLeuA2HwSxIzzGaGc="
          }, {
            "num_cand": "U2FsdGVkX19okuEOiKxUTf0tOcTR582faktHNPef1e4=",
            "cpf": "U2FsdGVkX1+t1ddoE3p4WIZyjI2pgY9aDyZrSUno0pM="
          }, {
            "num_cand": "U2FsdGVkX1/JEWSTLBVaXflCzmMJn3rrAd+sL74Mw28=",
            "cpf": "U2FsdGVkX18R58+aA7RtwlV3MjR1zU9a4Nbdc3abv20="
          }, {
            "num_cand": "U2FsdGVkX18Al6lo/4nYJ/rQQnnGqqXZJFKmk7Is6Lg=",
            "cpf": "U2FsdGVkX1+VZcWsCmu28KmQkKcJ+0q6/H4WihXEgxQ="
          }, {
            "num_cand": "U2FsdGVkX1/sQw31c4hQgHrJYq2d5ENNgxKQeG9nw1A=",
            "cpf": "U2FsdGVkX186DRnJc1H6/tdCXLCyChhee0WsXLPFxxA="
          }, {
            "num_cand": "U2FsdGVkX19mXILlEf8kIlQTQovwP60iA+3t+NnC74M=",
            "cpf": "U2FsdGVkX1+EUIoZeNWXLvDEV/cMGW2WQ4/W5Dvj/wc="
          }, {
            "num_cand": "U2FsdGVkX19Fx8KMl1DFFMHBqCfHTtzUeuJL3Mnxj+o=",
            "cpf": "U2FsdGVkX1/OSwuWzPR0u9hpZ1bR77LSkOLbWixTLyo="
          }, {
            "num_cand": "U2FsdGVkX18F0bAwYFvvUtKwyLy26WquWSZZ164EOkY=",
            "cpf": "U2FsdGVkX183aawnLQpYQkCx+3FQMX2ATQAJ9+9dtNM="
          }, {
            "num_cand": "U2FsdGVkX19HJOmOxZ6FZRu8hRLqB6VWZHVPa/UnGas=",
            "cpf": "U2FsdGVkX1+uzs73823K3cu7hRsQTuAUqT1bqjx9oA0="
          }, {
            "num_cand": "U2FsdGVkX18HdmR7dLVADfaANqXh+1UwGly6lhiQWh4=",
            "cpf": "U2FsdGVkX19Ufz+48DLyU22fIGvuAHYhCosvsHR+YBE="
          }, {
            "num_cand": "U2FsdGVkX18aDhiQs7f8bhD2MjVgqGdcTt+d4oMyfKA=",
            "cpf": "U2FsdGVkX1/Vi08/hOcWiSFafJ4zMRaJHsY+cWw0Jmo="
          }, {
            "num_cand": "U2FsdGVkX190LQZzrCdxjINV/IDcq247yaQA/jxQfsg=",
            "cpf": "U2FsdGVkX19lSozuMp+rOV0A8JC7vcM/JgkDP/Wrmyk="
          }, {
            "num_cand": "U2FsdGVkX18xzraP+IQaVRAwyCzro4yvKPs+ylJxJ+U=",
            "cpf": "U2FsdGVkX19J9g/zrlOCZNXTEBisffvU7YxguXL1w5c="
          }, {
            "num_cand": "U2FsdGVkX1+8UxU1XSll1lxQkY1y1R7hItJ480I1TIc=",
            "cpf": "U2FsdGVkX1/Kg00OvLj/35s3/xIrpS8vRKc8SFssd7I="
          }, {
            "num_cand": "U2FsdGVkX1+Uwn1DLAA9yB+nViVhdWDcYXd9TheFDPQ=",
            "cpf": "U2FsdGVkX1+7y77nVCPiqW+nmsFHs9XGGkdnIQjIrz4="
          }, {
            "num_cand": "U2FsdGVkX1+zTg/D19NOdn8h6XdKeosV1SXRchFFepA=",
            "cpf": "U2FsdGVkX18aN81dN1G/S8r5MNL11ShpGHtqs5eUg6Y="
          }, {
            "num_cand": "U2FsdGVkX19eTVcyxzIUeLUe+huS3cFkOattx+fXLoQ=",
            "cpf": "U2FsdGVkX19y7I6BKKGA38mn1JF0OmeH0d3GMM/jFFo="
          }, {
            "num_cand": "U2FsdGVkX19y2gB5C5h+AQsPkxX4vyd85CmUi5ZXRFk=",
            "cpf": "U2FsdGVkX19ePPWUkqOOCzI1wG9Jd3AyQbShXKWtQAw="
          }, {
            "num_cand": "U2FsdGVkX1956BsFGs7TlrGSYa5aF4e90LP308nBq2c=",
            "cpf": "U2FsdGVkX19dziMZRNwLaGBGjhi0eL8xmgH0mW/kzzQ="
          }, {
            "num_cand": "U2FsdGVkX1+VxXiMDId0k7XKHKaMsF1cpcQvBnFfezk=",
            "cpf": "U2FsdGVkX18uvdLhooWBP9KUxaaGtIoTRXzGysSZbC8="
          }, {
            "num_cand": "U2FsdGVkX1/ect6WRxWiNRKE+NK84av0N0oQ6oM7yq0=",
            "cpf": "U2FsdGVkX18TkMIYIjDQXXyb/juyIv0wdFV/3fRyrR0="
          }, {
            "num_cand": "U2FsdGVkX1+TVApsK0cbjqiwWaY5hHsYcXZPwAlpLOE=",
            "cpf": "U2FsdGVkX1+kmSjcIhyDv6viu9IqlVmU6lX4ysPuhVM="
          }, {
            "num_cand": "U2FsdGVkX1+zIB4MC7mjZB3o28DNCCR8vtyzwqyYO0E=",
            "cpf": "U2FsdGVkX194pB/LL1Cs7fUvRLjAlVAZfSd6qb0a2so="
          }, {
            "num_cand": "U2FsdGVkX18UX3exAVUWuPjf+eHgsepwZhlxiBQPM0k=",
            "cpf": "U2FsdGVkX18vFSqWQGI6bqHCvrN/Aep5gF5mYyUxNpc="
          }, {
            "num_cand": "U2FsdGVkX19pxTRCTckKEm2sZHGJmz357sP3f1VO+LM=",
            "cpf": "U2FsdGVkX1+NCj/2gHo/T+2SQUrVlVsLUbsJYnV1VgQ="
          }, {
            "num_cand": "U2FsdGVkX18je273vL4SEFDi73l8yFrfdwKBwETQunI=",
            "cpf": "U2FsdGVkX19xkfEOnxTqHFgpZ/q/h82o50v9pPe/+nc="
          }, {
            "num_cand": "U2FsdGVkX18MAZAg5urtodJbeProBx4mFQ9/3c8Ak3s=",
            "cpf": "U2FsdGVkX188WoqYVz2Psot0dglOT+ZXV1U+HUz+nT0="
          }, {
            "num_cand": "U2FsdGVkX1/PER1uNKqwsR81wxv20jzCePC5bI/D/3A=",
            "cpf": "U2FsdGVkX1+YU64jIvUEymrSqL8wzUdRFp4XoLPC8+o="
          }, {
            "num_cand": "U2FsdGVkX1+dQw1og3mZXzlUf3e3xXUW+7FXDbINXUQ=",
            "cpf": "U2FsdGVkX19hD6mEl3hHDDpaY9vzzMAylhOisp3xKK4="
          }, {
            "num_cand": "U2FsdGVkX1+mxYWuxODhDoXgfE5nXnfLrWiIl19+MoM=",
            "cpf": "U2FsdGVkX18zEesXaX1Zasw4nAa61d7/OK7BYDBJlsg="
          }, {
            "num_cand": "U2FsdGVkX18PFS++NzWsU+RNG2M82FMOZNwnVS/dXQs=",
            "cpf": "U2FsdGVkX1/sEvghAxFL88EiNFg8zE5lJLA3ls6IhMU="
          }, {
            "num_cand": "U2FsdGVkX18Xsn+mI3VdUVSXR4bEgK7pHU6Svalec/8=",
            "cpf": "U2FsdGVkX1938l0uaG+hBEVrWIU0hIVIoQzKtcb/AM4="
          }, {
            "num_cand": "U2FsdGVkX1/KsdJMIGAP/HoRkcjr1cS4S2ki4A4PJpA=",
            "cpf": "U2FsdGVkX19VlylefsVjkMv1n4vsnVtkLrrL8tk/3Uo="
          }, {
            "num_cand": "U2FsdGVkX19/u2aMMF41X8oNLlCcddclHlHbdCk1K2I=",
            "cpf": "U2FsdGVkX1+RjIuUyXePoMTTA7xiIPRkFty1L6CyI+Q="
          }, {
            "num_cand": "U2FsdGVkX1/Rf4UCvkQODbzE+yBs1qrscFkbmP5tLeM=",
            "cpf": "U2FsdGVkX1/SlwUcWsEqnWdqMgSH5dpAs2ykwjhwe10="
          }, {
            "num_cand": "U2FsdGVkX19/O5UBROeluJ5JjF/DzQBsI4Og9Yb4/bk=",
            "cpf": "U2FsdGVkX1/qS4fYa2GmwYf75klo5OUeWN0hUj7AWRE="
          }, {
            "num_cand": "U2FsdGVkX1+8yPxqjpJFLP1xh3hi/OPC1KUvHXjZzH8=",
            "cpf": "U2FsdGVkX18yJXH32QCZE09OPQw3qn6E6VcfLSgAkGI="
          }, {
            "num_cand": "U2FsdGVkX18rqyeOX6liyBGTXHzGw4txDTK9mY5YKi4=",
            "cpf": "U2FsdGVkX1+Zi/Cu2AFREfT5l7nr7GVMSHgnKttdbF0="
          }, {
            "num_cand": "U2FsdGVkX1+A/DDP2x5Yc6bzPiMDgZlh+ImyaZJE7Es=",
            "cpf": "U2FsdGVkX1/daCLRtP+dh/Er79S51rD0Z3/nfhIQkr8="
          }, {
            "num_cand": "U2FsdGVkX191BZTd1sEgNYJOgfspU2g8Wa47V/0nTDw=",
            "cpf": "U2FsdGVkX1+xT7ZyM3Ve+HzxkZCZA2+xd7gwFVofRZA="
          }, {
            "num_cand": "U2FsdGVkX18+4XzEQQTRaNAWlia7zmmyJCUZr93oAHA=",
            "cpf": "U2FsdGVkX18pTjjsX6fRmklmN9/QWZVF3cJgQGDm7LU="
          }, {
            "num_cand": "U2FsdGVkX1/DC3aQ1XhdTTNmKx960eE+/wbYVNjmb70=",
            "cpf": "U2FsdGVkX1+2KWy4UsQwHDtU6rSFxSxuYJzfQtWyptk="
          }, {
            "num_cand": "U2FsdGVkX1/OclEpg41DYHGqlAuc7zlvxslaAR0rKjI=",
            "cpf": "U2FsdGVkX18B7TCMw16WhbUKU2frrKn8eEthoto2vP0="
          }, {
            "num_cand": "U2FsdGVkX1/U5S9MlxsO4R5j4YWxAJtmdZMZVwM/3Qk=",
            "cpf": "U2FsdGVkX19Ogdjc7T5a5leH0DKrXH4Zxmc0rFW3f5I="
          }, {
            "num_cand": "U2FsdGVkX19Ee+ChnSNsyPscGHNFJjCbUX8JtgAzqmA=",
            "cpf": "U2FsdGVkX1+oepBvZOcH+5FNFQht7imHJYBQWSBsGAY="
          }, {
            "num_cand": "U2FsdGVkX184xEWOJyLggoCGwibvH0nBUyOalRzTHSU=",
            "cpf": "U2FsdGVkX1+IAb1RWTOHzJ+eSQeliwu82eyYsIv7HmA="
          }, {
            "num_cand": "U2FsdGVkX1/kht8j3kLt1c5KKPnsgt/nUTRvAK2gBTw=",
            "cpf": "U2FsdGVkX180FUaP+ra1T9kFNK42GyDhpbfrpxmgSa8="
          }, {
            "num_cand": "U2FsdGVkX186xniThyFioOxx5w8tkScSHgzCHycEJgw=",
            "cpf": "U2FsdGVkX1/Yp7afTSSVEtTpMn3sUkUB9NNiK4alrWs="
          }, {
            "num_cand": "U2FsdGVkX1/xANRUplwLUjdudjZzDgBAgXMABctDiAk=",
            "cpf": "U2FsdGVkX19zj+9c9lPar9ZuQITgAJloKSxyRfWO0AU="
          }, {
            "num_cand": "U2FsdGVkX1+l2eACgWer1Y82vM/bw1tl/6rzFqfano0=",
            "cpf": "U2FsdGVkX19+zW0EWUhf/uxBN1cW7FiamZ5Y4jo5Uv0="
          }, {
            "num_cand": "U2FsdGVkX1/HpFfrpRgdm3vuksuLR7PcYjX53CPsfhw=",
            "cpf": "U2FsdGVkX1/L95ep1nTtzHNVDm9ThbMJLUBN2ol/HFs="
          }, {
            "num_cand": "U2FsdGVkX18u03AKqmxCWP77TzWfTBS+GlXtVvqJ9Ts=",
            "cpf": "U2FsdGVkX18jYPHHMnOAVpeayisEDDp3nMguqZ+pe2Q="
          }, {
            "num_cand": "U2FsdGVkX18dnOLdD5P+DncSipj8GBqkgOwWge3RHrc=",
            "cpf": "U2FsdGVkX19WGzKY7KZi5H1tCRJIgtRnPNF1Xy7CZ/s="
          }, {
            "num_cand": "U2FsdGVkX18cYhPE6ytgksr1hhbDvgncRuW58Tz8NX8=",
            "cpf": "U2FsdGVkX19Mq96TZ0qTGLjQklqEN60aynnEmoEMG4Y="
          }, {
            "num_cand": "U2FsdGVkX19HT7r563FGIotJzYoT5J5i1u1UJOushtQ=",
            "cpf": "U2FsdGVkX18Ez3EQM/TCx75FA7ZWf0BSxiei0oq2upg="
          }, {
            "num_cand": "U2FsdGVkX18b1qgoJt+JrG8CNsabjru7WrGq7+isQ9c=",
            "cpf": "U2FsdGVkX1+kvChcsB/MCYNZjbwed1eXWTAuROImNzk="
          }, {
            "num_cand": "U2FsdGVkX1/oA0b3e6Jn8/dYE+OVqb+gxKVcCeUuW2s=",
            "cpf": "U2FsdGVkX19Uv1MC+sxH8YXla+1BT5iqvdwr6I7Kb+c="
          }, {
            "num_cand": "U2FsdGVkX1/8TdO3cxIhhHmcpG4AOK1Q3TmDkaqr/cA=",
            "cpf": "U2FsdGVkX19x/03LPMOEYMsRECdu/9wMsDAXG+unYv8="
          }, {
            "num_cand": "U2FsdGVkX18E18ZD2aEh8Y1Hywb38F0JAq+00FFc6NE=",
            "cpf": "U2FsdGVkX19fIjXeTzP4LV04tS53ESkRG6wRQ5ZaW5A="
          }, {
            "num_cand": "U2FsdGVkX1+dySxLbADjcRM0BvDHCK6MO2GH/nbY4+Q=",
            "cpf": "U2FsdGVkX18T1NOFez1co4ROOywZrLaBLZrDF9yRUCk="
          }, {
            "num_cand": "U2FsdGVkX18eeF6iGwLlwl6ldvAxe5k8c4ZqzqQiP8Q=",
            "cpf": "U2FsdGVkX190+EQgquwrkPI5Cq5FvQUy7GWTaAyzbpo="
          }, {
            "num_cand": "U2FsdGVkX1/pwHgbBtzwxMX/gXc519nLR+g32M6/nVM=",
            "cpf": "U2FsdGVkX1+bX9N/n52jHZ2tMqlFejDd2MF0l5EVdtI="
          }, {
            "num_cand": "U2FsdGVkX19hvxgY7YeFzRBqZ2EUSxspO8VLcKv4xtk=",
            "cpf": "U2FsdGVkX1/Bi4IsgdQImEr6eUVz//vAkRuFdh431fU="
          }, {
            "num_cand": "U2FsdGVkX18w4orE845wuBRYIYwlE6eaE/+XirKgqsM=",
            "cpf": "U2FsdGVkX19su8JH0albSCXLVkUPN5rPVOlWGC6k760="
          }, {
            "num_cand": "U2FsdGVkX19rSID3hd2kS8h+/GYYKFqBMf8T0BAOTeM=",
            "cpf": "U2FsdGVkX1/cL1n/l97+o/Qff17xkxW7bsFSf/FzBJI="
          }, {
            "num_cand": "U2FsdGVkX1/zVGiTrxHaBo+/m2rUoLdL/tRb9hpRxrE=",
            "cpf": "U2FsdGVkX1/51Ltyttj4NUmuRkF+XJrYM2cevyVoF74="
          }, {
            "num_cand": "U2FsdGVkX1+CB/WCbgfuWoRIvLvbl1zamCEx2wTNdAA=",
            "cpf": "U2FsdGVkX19amDq0SqiHXVwrY7sS7GjHSHHF8d9LXhk="
          }, {
            "num_cand": "U2FsdGVkX1/ckloS1vrvz+lwYvSW9HovBCe1kT3r08w=",
            "cpf": "U2FsdGVkX1/wdeLtKUzfokVC9F7lqRqEhUPZTMMHv6k="
          }, {
            "num_cand": "U2FsdGVkX1/Yy7aav5ephSUFbYtonebp3E0u3EJgmoo=",
            "cpf": "U2FsdGVkX1933DxDbnKJG74i/3ZPm/DQYUMwej+BKZQ="
          }, {
            "num_cand": "U2FsdGVkX1/VOT7cPeihqnKED+Yu+eIv+AEYqTajy/o=",
            "cpf": "U2FsdGVkX1+qZ8swC1wJ5zcD8hWraZS5ZxMBmNMsIng="
          }, {
            "num_cand": "U2FsdGVkX18ApVv/QPRP0PMmtIfKoNCySHfeakp91Cw=",
            "cpf": "U2FsdGVkX1+cM/Cz9STGcglOdHaGEK92PeUHYIE9yZo="
          }, {
            "num_cand": "U2FsdGVkX19DB4k60OtQDEq4NeHwKgMR0jjINxvOj1c=",
            "cpf": "U2FsdGVkX1+sLUoiC1S3+xjf/YCNmwSQbZxHgV4wLgc="
          }, {
            "num_cand": "U2FsdGVkX1/e4RlSaUzvAR6IC+4HImx2Yto3bbIlvxc=",
            "cpf": "U2FsdGVkX1+NshqP2q+ulRrtxGiEt58hd9oS2swMoEE="
          }, {
            "num_cand": "U2FsdGVkX18QxEcT0qR6zz2Tji9NJm3huocYw7q+3es=",
            "cpf": "U2FsdGVkX192q2UG8DSZSMfqgeSXXw0Tvh592DsEFCE="
          }, {
            "num_cand": "U2FsdGVkX18EQXLNgw1keSzqj2q9LlDfEC5x+8NpbJk=",
            "cpf": "U2FsdGVkX19ZtaAGmasdNx6Qv6DVWU1pmun/silmGQk="
          }, {
            "num_cand": "U2FsdGVkX1+69ifBI8iAcBYOIg3KEtdZqtY5fWM2ntY=",
            "cpf": "U2FsdGVkX18pYTrkRqd121Z3KCG5hUuD24TRvSDwaC4="
          }, {
            "num_cand": "U2FsdGVkX1+e772E3Tf1pTz9efvIBkxhi8I1hk539JA=",
            "cpf": "U2FsdGVkX19I+H4/3RCT3+lPbNAvPQ+wnCh4UQ48Ol0="
          }, {
            "num_cand": "U2FsdGVkX19GdZlLX1YrVn31Z+jhvRbLp86ro9j4mT4=",
            "cpf": "U2FsdGVkX19QL5QEa3osBydW9YkCBSzvAzwn/qtqeXA="
          }, {
            "num_cand": "U2FsdGVkX18+xcwai/iNerwuBmIqzH0VHurg7g6FE3k=",
            "cpf": "U2FsdGVkX1/0BsoXMRCV7jlCbX3kuPyrb29McgRk4yY="
          }, {
            "num_cand": "U2FsdGVkX187whDhjPJD+TVhCcY+LkcdRfdwCC1t28Y=",
            "cpf": "U2FsdGVkX19LJUcY2uaGXeHHcx7ViFLx8GxUCwYk8vQ="
          }, {
            "num_cand": "U2FsdGVkX1+1wOzn7YdOafDR9sdMe72b2CFzM88jegY=",
            "cpf": "U2FsdGVkX19jiry74zL+mm6enDQ1sUHxlDCv62jJdBo="
          }, {
            "num_cand": "U2FsdGVkX1+wXE0ICujIjFZdMrp08sJ25P9z0FL1T90=",
            "cpf": "U2FsdGVkX19mhIEm7jg5/7DTJedASpB8NKoZab8p75o="
          }, {
            "num_cand": "U2FsdGVkX1/WRKCnPCZBfxDf+r5UYnRyrafoRA5+oUk=",
            "cpf": "U2FsdGVkX1/RIg+WTnSHkPQ7MWD7P1QcqyO3ZY/pFxE="
          }, {
            "num_cand": "U2FsdGVkX1/aKJYTCaOrACmXSGtU5momHWxpkWYrpoU=",
            "cpf": "U2FsdGVkX1+fMdACbZ++ePbYlsiusNZM/Me8k0GsByA="
          }, {
            "num_cand": "U2FsdGVkX183d4LT0Zwg1nyr1JRjg7ndHGx4//IKJ/w=",
            "cpf": "U2FsdGVkX1/25XndTH3DQMnB4dG/SzcidXa9xpu65i4="
          }, {
            "num_cand": "U2FsdGVkX1/2MHDbGBSuaVMOpjUb3xxQ7SaeCzjOmhs=",
            "cpf": "U2FsdGVkX1+qksSIFhYgpWC+4ZnXVB5zvXA29BsdWQ4="
          }, {
            "num_cand": "U2FsdGVkX1/UZTAmf04bdaYDt5Pl9lZWQSy3yHmnT5k=",
            "cpf": "U2FsdGVkX19DG+JBTBPxkH6AmhHfno00ne8E60Js84k="
          }, {
            "num_cand": "U2FsdGVkX197b2POBrvgMH1UOLn1znIIXU5f/jE5q88=",
            "cpf": "U2FsdGVkX18+EXKF7xQuiORawOZMsdBLQKSAPPBJkH8="
          }, {
            "num_cand": "U2FsdGVkX1+hSidAwatGrt4xmqdH63pVE2VYfUEM8mA=",
            "cpf": "U2FsdGVkX1/JXIiUQPf+fSyPAUcEQQpK/08lyD9CVqk="
          }, {
            "num_cand": "U2FsdGVkX1/SY1szn1C2oOqk6/6Z48N3R64uRepWuKU=",
            "cpf": "U2FsdGVkX19+ZshyNg6F1wYSGmt0Vf75N8Zcuvu0asY="
          }, {
            "num_cand": "U2FsdGVkX19YPZ+ByWFGv0XGYqKE009r8u3tGJDC3AI=",
            "cpf": "U2FsdGVkX1/eStq+lzy/7/hxxAWAQhFcBMNHImt0MTg="
          }, {
            "num_cand": "U2FsdGVkX19GHnMh8jx1V4EZAwXGZkRUZgYC5fvbqN4=",
            "cpf": "U2FsdGVkX19+B69AXjrJ3lTGIANxf4mzsb+EKQ5nn4M="
          }, {
            "num_cand": "U2FsdGVkX19THv8VdWbtCOxuJEA1bWl8k1BDYxKHqj0=",
            "cpf": "U2FsdGVkX18XdEKM9aYUBF5IfiW/O5uxSSlNJZ31zHY="
          }, {
            "num_cand": "U2FsdGVkX183woW9D4fy0mjzzR3oyBps+MGM41FEUyg=",
            "cpf": "U2FsdGVkX1+ZPtSdri9wmMhlsdRhx+A1G8yiTMVcLMc="
          }, {
            "num_cand": "U2FsdGVkX1/U4EIlI5l/flJJbYfzeEVOnpy6NkeXMRM=",
            "cpf": "U2FsdGVkX1+jNjRZj6NUNeuQvj+oPfdTJG2VBfylwe4="
          }, {
            "num_cand": "U2FsdGVkX1/YIhv8PzcTk53Ib2K258d5vQUCyvSuE9s=",
            "cpf": "U2FsdGVkX180PwL/ZZCm2grjZbasvR6TN30NpZQDEFs="
          }, {
            "num_cand": "U2FsdGVkX1/k9vse5OeZ3C9GtFlowTWd03krxVDj5K8=",
            "cpf": "U2FsdGVkX1+ETPkw5IowS9vxJDDprw9bwUV1S/Y6ShU="
          }, {
            "num_cand": "U2FsdGVkX1+XNa1lgvmocsWKzDN587/8o//NTJ44rlE=",
            "cpf": "U2FsdGVkX1/whwiigrZHvn+PaD48QYPVH3VYLMMizwY="
          }, {
            "num_cand": "U2FsdGVkX19T+p11ybsi1/N5ghDudcByyjY+SdT4e5U=",
            "cpf": "U2FsdGVkX1/M9yYzZc0MGh28GeUOdycC5H7HmaTTq4k="
          }, {
            "num_cand": "U2FsdGVkX1+cDYtkVy+mEofC0kJm2j/q53+7DMPZtT0=",
            "cpf": "U2FsdGVkX19xBw8tSK6asmd3B6sb5KIUqAqDkROO5jY="
          }, {
            "num_cand": "U2FsdGVkX1/9VpqCtsFK1tN4ZEKYs3f2ob+9ARASlco=",
            "cpf": "U2FsdGVkX1/LSFWTCFb0DwbeT7jABbsAnUi09m2txWI="
          }, {
            "num_cand": "U2FsdGVkX1/cQPr1kRpoBd4PV72XngCn8obyNRC0HEA=",
            "cpf": "U2FsdGVkX1/WR/UTfP/0O3htpk4eSPr+EgAB0nXY9dY="
          }, {
            "num_cand": "U2FsdGVkX1+kXuwK/f8V9IibpNXyoasU8oXo5sH6S+0=",
            "cpf": "U2FsdGVkX19JBz/tnSDhA80HxQDwaYKaWFIrvJV+ld8="
          }, {
            "num_cand": "U2FsdGVkX18/Ex2zJw1MoFIBvH5nr9dhpmjobwvKg5g=",
            "cpf": "U2FsdGVkX1/RdlvwPQKptRwzGH7WlO4zQd3c20nm0MU="
          }, {
            "num_cand": "U2FsdGVkX1+d+I4skCK28c0l4ruSjJ1BTbBiSxGytb4=",
            "cpf": "U2FsdGVkX1/fmaTcYTUZt3iGvNJuefHI/8qNW3UskBY="
          }, {
            "num_cand": "U2FsdGVkX1/avmXCDqdPuKJttYXQt2f2DL9jVG6m7UM=",
            "cpf": "U2FsdGVkX1/ZE3Ae5wHm8rTsNCjAkiTscdL8mrdE0pA="
          }, {
            "num_cand": "U2FsdGVkX18G/pY5ad5ceeoIuL+zfCPf1JGVrfvKTa8=",
            "cpf": "U2FsdGVkX19g+uWb0h04GsvFECdDxpZa2Giowg9VCo0="
          }, {
            "num_cand": "U2FsdGVkX1/BdTgPnZAdVJIHFCJcJfXS8Otq5v2UgsY=",
            "cpf": "U2FsdGVkX1/GDjsvugEaMoyqqUC72vii7fvIzJM6Tg4="
          }, {
            "num_cand": "U2FsdGVkX1/2I6bBu3owwZvW0XL16HQl2CQ13O7SSEg=",
            "cpf": "U2FsdGVkX18NgqpUXjh+gVT4q09+gNpLCbnpvtW+aOE="
          }, {
            "num_cand": "U2FsdGVkX181ypgPb1asC+5TrBgq+7Dobv5eTHnTGlY=",
            "cpf": "U2FsdGVkX18E8Gj7PmfCf7goKYsu0/j3mV5JxTYglSQ="
          }, {
            "num_cand": "U2FsdGVkX19uYuxKo6C/2QvAz51J+YBKw93j4IOVIR0=",
            "cpf": "U2FsdGVkX1/4mDna8Dv6UiOBRY4clIJtfsqfInoruJ8="
          }, {
            "num_cand": "U2FsdGVkX18hApxzZ/Xs+tjifoZtYUKI7BNnYrcizWA=",
            "cpf": "U2FsdGVkX1882qh1rdsWtMX9niC5euyrGyymeHL8LTo="
          }, {
            "num_cand": "U2FsdGVkX19/fu455sOqo+Vo01wDI0AlWHr3JalpRVI=",
            "cpf": "U2FsdGVkX19MB3VjsQHkTJi1Ir9k1iO9pCoOLVGjVLw="
          }, {
            "num_cand": "U2FsdGVkX19CNAfZp8ebC8kST5VOMIX4jxWmRFpu8qA=",
            "cpf": "U2FsdGVkX19ed/QaUym5d3S9l9SsvN4SN/m5XoDlkps="
          }, {
            "num_cand": "U2FsdGVkX1+h/ZPevA6WrTeT2NzwZPHT641Roz4RLVU=",
            "cpf": "U2FsdGVkX1/4j+bVHZhTt3CeHutNTkQKmG2/7erCrik="
          }, {
            "num_cand": "U2FsdGVkX1/0sx6w84/wIkUlXV2ExeKRhwxi4R78ysM=",
            "cpf": "U2FsdGVkX1+WvAe3YcOiB9jZwxspuG/8TMKmwySrmJs="
          }, {
            "num_cand": "U2FsdGVkX1+dOFzRDGpgojd44esu4lMTwSxQT/x2YhA=",
            "cpf": "U2FsdGVkX18MLNRNS1kTQxJYVpt+dhOZJuKDcd401vs="
          }, {
            "num_cand": "U2FsdGVkX1/rJCFVbj7jKxUPWws4HXitf2Ie/+kAM2k=",
            "cpf": "U2FsdGVkX1/54yycdm/5B7n0iaaLe+92kZcG/aOfrQc="
          }, {
            "num_cand": "U2FsdGVkX18O4ZzFywpjZbfsMsp2tjVgbLnD6DqUIH0=",
            "cpf": "U2FsdGVkX1+atsH3OaMXsbWeH03cnA0fvrTl1enHTH4="
          }, {
            "num_cand": "U2FsdGVkX19kndzHjf8j9Kk2QwufsNl86exgXuMWEOc=",
            "cpf": "U2FsdGVkX195Y3rOk543BXbPOUxPDPl5LETU/hQ98ZM="
          }, {
            "num_cand": "U2FsdGVkX1+ATR0WG4D6wPYL0EvHghcIHW97D3qC0as=",
            "cpf": "U2FsdGVkX1+4zn04TDQFKCqYCZT4OntyM49I+D5uQdU="
          }, {
            "num_cand": "U2FsdGVkX18tXiHJHuUfbKxIzIZ5rVmCui6P5FeWjOY=",
            "cpf": "U2FsdGVkX19i10y0V0+WUGPOHeM41sibJMrHwj+IYV8="
          }, {
            "num_cand": "U2FsdGVkX1/WdI5+vsnWZguJWd4NI9xicsXTc62S5hY=",
            "cpf": "U2FsdGVkX19nNe2eX2Ys4OOtKhJ2Xd36RdAun0ouPXM="
          }, {
            "num_cand": "U2FsdGVkX1+w2jfCf4MJsIppjkLGTUjq7x1XfGza614=",
            "cpf": "U2FsdGVkX1/q1lhA3VhBc5eYWkERs9mrK/i/rRqkDMM="
          }, {
            "num_cand": "U2FsdGVkX1+PAODdb8UGR13M9BPypipQ67ioITf+N5s=",
            "cpf": "U2FsdGVkX1+LHyOMBf9vtvEQzLLZPgEmwHKyQltnjTI="
          }, {
            "num_cand": "U2FsdGVkX19j8E8Ed/c4/y+fRL/1/XzQwAQjTXiYs44=",
            "cpf": "U2FsdGVkX1/1JmYWYA0rP6TCypsASXMAOTSAPZTGEq0="
          }, {
            "num_cand": "U2FsdGVkX1/PbXXbdPMfs9yvVil8J4oNvDatdwLUYVY=",
            "cpf": "U2FsdGVkX18kLQfIExpoRzhWlq9IC3jFxXZuVS6WcFo="
          }, {
            "num_cand": "U2FsdGVkX1/FRGdpA8ZoKpuzfBuZS42sD7jM/g1D94M=",
            "cpf": "U2FsdGVkX19tZ/IRGM9BZRq/DbkLYQCiYyGyMxBZKFo="
          }, {
            "num_cand": "U2FsdGVkX1/5yavqoyeReoxUsQaLF9MuVWtastfyZ3E=",
            "cpf": "U2FsdGVkX191WJb21Ajd+NzTUVazgm/nI6YbTuCrpTo="
          }, {
            "num_cand": "U2FsdGVkX18vcvhr137jMRdeFiXRG1zCKfoeYNu0okY=",
            "cpf": "U2FsdGVkX1+8ByTazpl0cl0sBShTvwCvd9wrfedmDxY="
          }, {
            "num_cand": "U2FsdGVkX1+GapOhzd+8gRW8AkaddzXj2fggCBCz4j0=",
            "cpf": "U2FsdGVkX1/j05qXoK80B9p0VK+yk6gr99Zn4NFpZJk="
          }, {
            "num_cand": "U2FsdGVkX19GUyDP6kg/IVjr3gIQK+Knvd+W7Tx9gT4=",
            "cpf": "U2FsdGVkX1+E3CsSsaMBCNXuIOCQMmc4ipTkMVIx8vw="
          }, {
            "num_cand": "U2FsdGVkX1+nSqVmNKyToH0CcKx/8lXxsX15Kdwnjuo=",
            "cpf": "U2FsdGVkX1/FLRxUoIn2e9QzJfjqExAn/asz7AIifo4="
          }, {
            "num_cand": "U2FsdGVkX1+VyTUxfNljV3TEAqHLnc6s9eSVCxW6Kk4=",
            "cpf": "U2FsdGVkX19WlRoRSg5SfATBaAzNY8hg49+llE8FJRY="
          }, {
            "num_cand": "U2FsdGVkX1/mpl6MCLbzrvhJUOLcBSlXKtx0GTlh/40=",
            "cpf": "U2FsdGVkX1+bA6QwQjzn8HfwXeEXXK1aepxAdnmwYlk="
          }, {
            "num_cand": "U2FsdGVkX19AOqZR/yLrZtkgj6qA5BdmSq+Th/l0h70=",
            "cpf": "U2FsdGVkX18rKlehvHia1o2EDZ9+bBK1shQtEzs7yHA="
          }, {
            "num_cand": "U2FsdGVkX18a0FJ0cHYvk4c83zcdaJXcvDcQgD0630U=",
            "cpf": "U2FsdGVkX19csyBunsyyCeF9aC2ZOAzACbqaaGrYk3c="
          }, {
            "num_cand": "U2FsdGVkX1+9hVrSOizbhgcZWkbkyXKvXSceZgMXXLY=",
            "cpf": "U2FsdGVkX1+FJivtJxq4S/jpLaO0l/OpPusXoyMwzrA="
          }, {
            "num_cand": "U2FsdGVkX18Oe7o2iREtcSkD2AN8DtOD/69OgwyixGQ=",
            "cpf": "U2FsdGVkX1/01reFMyMFGJJD6443dIFup5Fi347tDzQ="
          }, {
            "num_cand": "U2FsdGVkX1+FNmvC2Iba9fUaXHS0ITa1oewGed6+sWc=",
            "cpf": "U2FsdGVkX1+xos9iCS7X4z7+zN339TJb7qkb9d5mzh8="
          }, {
            "num_cand": "U2FsdGVkX19fDKdRBIFz1HkU1+ir1/JlfYHbG0T7ZPc=",
            "cpf": "U2FsdGVkX18rkKms2rQkEa3Ep/uTEuTKg8Gef+WAZY0="
          }, {
            "num_cand": "U2FsdGVkX19txz2zqg+/Z4KcUw25vuDsuRPMMa7UBgM=",
            "cpf": "U2FsdGVkX1+4R/oE9bVqhWWxtK1kiuOdKx+IBrVFZ5Y="
          }, {
            "num_cand": "U2FsdGVkX197Ybz21KbALjBT2wwWS77yiO+hQzZGxhw=",
            "cpf": "U2FsdGVkX1/0X32j+Nj3n+kw73/cUEYXMcUCezE7tpo="
          }, {
            "num_cand": "U2FsdGVkX1+Do0GF/++uGqNPPw9IXfqGpvaFqDU73CI=",
            "cpf": "U2FsdGVkX1+BPoz/D+eHkxUMs1fxwulax2A8BCR4dco="
          }, {
            "num_cand": "U2FsdGVkX19ZP9JTiCTuAta5iilWf4dpqi7uopKjdrI=",
            "cpf": "U2FsdGVkX18bMNoxpEv+Orbw0Pf+uE5fxg5hq4EH24k="
          }, {
            "num_cand": "U2FsdGVkX1+jTCHEWVzAY2Bh6pOtCl49thx2QL6lAYo=",
            "cpf": "U2FsdGVkX1+juGjK7VeyMPfA+ziNCXYhR5m1O2meHHc="
          }, {
            "num_cand": "U2FsdGVkX1+D2NHwPweH4V76oGRqZXSqGR1NgxGR+Kc=",
            "cpf": "U2FsdGVkX1/7u3mrmS5PCLjjZArgyFXGvyq2qtib1uU="
          }, {
            "num_cand": "U2FsdGVkX19jfgsbTlNEYR3PgZysv1VYQQMQG46oc1g=",
            "cpf": "U2FsdGVkX187DC8EUGntzY/TSwDm6R3yFW/Pvzd5H5E="
          }, {
            "num_cand": "U2FsdGVkX1/wLV1xObqn/jCPxORiVr/JkdA7RwBy9no=",
            "cpf": "U2FsdGVkX18XftfJ5Hr2qDHSOjsxw3zEnRclwJ4xNOc="
          }, {
            "num_cand": "U2FsdGVkX1+xVCAmUn5h+28x7LoJ2PhN/9+J9uZykn8=",
            "cpf": "U2FsdGVkX191K8mfpQLG++2ttMJwPvDuZdKQZQmY3Lk="
          }, {
            "num_cand": "U2FsdGVkX1+AnH+gi98NsRf95wKYaO31VDSGBI+53ZI=",
            "cpf": "U2FsdGVkX188Jfcrw2P1thJ+5gnyPOsjagWQYpmWTIg="
          }, {
            "num_cand": "U2FsdGVkX18sOmdXjvl3UXa5ZKtGVfn8gzsYz+XVTYM=",
            "cpf": "U2FsdGVkX19IlAsK9cCBM5jktYUsyWGAdFv+Tu7c3+M="
          }, {
            "num_cand": "U2FsdGVkX18pxoeiOBPiBOdJDDYSkdJt4WQ6rviAPlA=",
            "cpf": "U2FsdGVkX1+zeL30Q0n9YPXxZx84sCPynOwlPguRH4s="
          }, {
            "num_cand": "U2FsdGVkX18kmOnLfjAmMxfZEwXSxFDzOpHVXRwQONI=",
            "cpf": "U2FsdGVkX18ZQQBtYQUINfRYKYL6vPD+S9LzRtNxWAI="
          }, {
            "num_cand": "U2FsdGVkX18JdkRiNQAcXCNxnGs8oG1ZqvDJaPmHTxg=",
            "cpf": "U2FsdGVkX18keyqabq15g8teHOOBW/NtnjxpzGJeY8o="
          }, {
            "num_cand": "U2FsdGVkX18qZuf2//bU2UyLfGlIGcwD6cqj8JjMZ6s=",
            "cpf": "U2FsdGVkX182eBCcZfdabgCkDxRPJUR70cwCXjHl3+s="
          }, {
            "num_cand": "U2FsdGVkX19gz/tyP+DGi1/PyRrWtn0QA7cgMKf16pk=",
            "cpf": "U2FsdGVkX19wG8LDHgVxQze5kAAvJE6TJmnQJ1HJE3c="
          }, {
            "num_cand": "U2FsdGVkX1+iP41wSs/m+v+yY8n29jbI0i306fjspX4=",
            "cpf": "U2FsdGVkX1+VsXiAKcFA9FXq6M4PMM6yD/+/N6nzdR0="
          }, {
            "num_cand": "U2FsdGVkX1+6/VndqTKokW1HQISi2DwnbDPSokvfi2Q=",
            "cpf": "U2FsdGVkX1/fPJZ0Sw+sSPq/ikcBg1c8KW5OrFzIecc="
          }, {
            "num_cand": "U2FsdGVkX1+tcIoiSR5/HNcPg7ZLAuRw7hMZQeooODw=",
            "cpf": "U2FsdGVkX18KkpY5Jtx7+wVZ/uYCpYe+eSTHto16nHY="
          }, {
            "num_cand": "U2FsdGVkX1+Lr8LBpb4VajDinEvBsZA1VZXbiEbXIEo=",
            "cpf": "U2FsdGVkX18XgK5lbKMjnC1+UtARCr7oTLb9wJ8QGcs="
          }, {
            "num_cand": "U2FsdGVkX1+lIIAnA5IvHS7fEJtLClqnB74iZDjbyag=",
            "cpf": "U2FsdGVkX1+DPP3A+RYCQ5Uj09zvgU18recsvo/SSoU="
          }, {
            "num_cand": "U2FsdGVkX1/GzpDrCD0uT0J3KfvBELennU59l3C/sgI=",
            "cpf": "U2FsdGVkX18NoLU+BQMKs6PtPevqG7AZFm7R/ZFesb4="
          }, {
            "num_cand": "U2FsdGVkX19jZHdbOX1yLk+YtJL6XDjhrFynkhiLjvM=",
            "cpf": "U2FsdGVkX1/AYBs56DP4Cx5V+idmJqThLI00o4jLxZU="
          }, {
            "num_cand": "U2FsdGVkX18OTId10Jj8GN0t1AlZwUtw3IImQncf1jc=",
            "cpf": "U2FsdGVkX1+Ubp+paXQPn/NM3hI9WuCBL8OIYmEgoQk="
          }, {
            "num_cand": "U2FsdGVkX188AdGnNkpADTJzGpPn3xSYnPzAfpi7/Tc=",
            "cpf": "U2FsdGVkX19N1x399ZKyOrAaHkQbx87CBFLFBxhrePU="
          }, {
            "num_cand": "U2FsdGVkX1/l/UfUQt3aIydoIgBaNre49XirLbrxqgE=",
            "cpf": "U2FsdGVkX19eB7MCbQAjSP2bU4WESi0+oWFYrrS7p7I="
          }, {
            "num_cand": "U2FsdGVkX196iRYmEsVthw9SIl7uHcgUFs1zITZ7wlU=",
            "cpf": "U2FsdGVkX184HDrQjqGbZTLrtSOGnu5bN2iYXrecOzo="
          }, {
            "num_cand": "U2FsdGVkX19/fjgy5Kee++INwXJWPb6YSnxD5jeC68U=",
            "cpf": "U2FsdGVkX18KVJz1GknRdO5vAshyVL3bqYcX9Yoz/TY="
          }, {
            "num_cand": "U2FsdGVkX1+3Ff2GaXbNNFvL4Gzdxpzb3FGAoJqY6pg=",
            "cpf": "U2FsdGVkX19gC9MfNjXd3IgLV58wVZWPlqsEodRadZI="
          }, {
            "num_cand": "U2FsdGVkX1+M5CeOuxqXXVDlyxTsmADOMlEFDumEgKs=",
            "cpf": "U2FsdGVkX186fojGZIQ+IA+ivN/BpZVakHbigVv/fpo="
          }, {
            "num_cand": "U2FsdGVkX1/ayRbntZYiUnXv3P8UyBAlbKLsECfOlYA=",
            "cpf": "U2FsdGVkX1+JnjRLEpuZeIg8CPUIy/wth31XxSAG/58="
          }, {
            "num_cand": "U2FsdGVkX1/Qc++ClGla00Ainf59Sd+D65LDMs9gCsk=",
            "cpf": "U2FsdGVkX1/QA/AxSlAK43ka0osr6S+lge8W67fy5io="
          }, {
            "num_cand": "U2FsdGVkX1+fD0qNdkCMwYAo0gY4/oaAFMYfWvt0tvg=",
            "cpf": "U2FsdGVkX18rgfw9XxmPFlQMhvHM9QxH/0MixZrv1pI="
          }, {
            "num_cand": "U2FsdGVkX18SWcShbrxs/Rl20ssW95MyGzIvQd1AmOs=",
            "cpf": "U2FsdGVkX1/+1JfL44n8TgLQWiHnV751NgpTVXmFOYk="
          }, {
            "num_cand": "U2FsdGVkX187MWCf17fSzPu4G1EystLE58771e1ejR4=",
            "cpf": "U2FsdGVkX194X6Qg8xCtMZ+KeOtqUccXSs2GzPtwGK8="
          }, {
            "num_cand": "U2FsdGVkX19wqpYMXS4k3JY/1+d+VH8IGX8sCt+XMi8=",
            "cpf": "U2FsdGVkX181zhX12sYjaowDB/7zAHQzpmY101kUAeI="
          }, {
            "num_cand": "U2FsdGVkX18eXxYZgaOh6zwLbL8An338YYRdmQ4X5q0=",
            "cpf": "U2FsdGVkX18QEDEhxMrvKcnmvQpYQhkhD4Oy2Ao6mIQ="
          }, {
            "num_cand": "U2FsdGVkX19Mx7GV/fWBdLVfDzRebkTc4vD/qj+E8Rc=",
            "cpf": "U2FsdGVkX1/oT1X/89ylWRz0LC9IW8WpuZ+ndOx/XhM="
          }, {
            "num_cand": "U2FsdGVkX1/mLHbZZsucBbOO+oRsnXi0w6/iZsSqkEM=",
            "cpf": "U2FsdGVkX18OTtQ8Xudtt0LgvKCIkORwFNHeJvPH5I0="
          }, {
            "num_cand": "U2FsdGVkX18uG8sn9CJiljpRDl2gbpNdNszrPl3nM5c=",
            "cpf": "U2FsdGVkX1+zequhBGnv1b/PWoriSCeJUFg2r7BOm4M="
          }, {
            "num_cand": "U2FsdGVkX1/QhQhQkYpcZCxT5K7yzScd0+/BVjdnLA8=",
            "cpf": "U2FsdGVkX1/VeGw7WrtLekupyEwV1qh1TIA5cE2yIZA="
          }, {
            "num_cand": "U2FsdGVkX1+c7+hC+r1PklCE9vueU24cFf56tPKDBrY=",
            "cpf": "U2FsdGVkX19vcwEBJkcV9j4fuWeztm1nKa2gxKDU1pM="
          }, {
            "num_cand": "U2FsdGVkX18t9cSUdY1Egn1Pu0jLbsYnrBYbfeKF0Io=",
            "cpf": "U2FsdGVkX18FWvfz23VLj2mbdR5jgYJ8HPYN569oHcg="
          }, {
            "num_cand": "U2FsdGVkX19wzIJj4JyL8+KkFuap7j47z52rGtOf6LY=",
            "cpf": "U2FsdGVkX1+lasp+KV4EqUSagUUn1BRHY569FYY5Sok="
          }, {
            "num_cand": "U2FsdGVkX19LA4bf6uE8jIPh8YvI88lkbwHS/XlzHkY=",
            "cpf": "U2FsdGVkX1+p4oG8iJZkHn6N6xkNqV36wbqHzM5ehPM="
          }, {
            "num_cand": "U2FsdGVkX1+eAkjvSunYGu119gD9YD+mZRti9YQy0ro=",
            "cpf": "U2FsdGVkX19dibOmGeTW+NimueKyJA8ceo+GHVJZcBQ="
          }, {
            "num_cand": "U2FsdGVkX18J1n3s24QSWCj6u6xcsL/jso7oy+1Ey4U=",
            "cpf": "U2FsdGVkX191q3p9Ehuefb7OL2Pda5IKlcuhtCzaDRY="
          }, {
            "num_cand": "U2FsdGVkX18+MH68qdo4NgTvCF4EHwKwb9KbTDFglDc=",
            "cpf": "U2FsdGVkX1+Nepjg3oaBdTwEsVy+kVcy+x6SERSisLU="
          }, {
            "num_cand": "U2FsdGVkX1+sWZnZQ8nxPDoVwBQnaMwToErfZ05aikU=",
            "cpf": "U2FsdGVkX19q/JZorqhlMy0ClmgXhkZU7lndhjgPsTc="
          }, {
            "num_cand": "U2FsdGVkX1+do3aU5ZnIgcq0TUfdUc1f9fNHEC5r9gU=",
            "cpf": "U2FsdGVkX1+NDPL0MyryVAv7x0QuldMe07ur5M2UNGE="
          }, {
            "num_cand": "U2FsdGVkX1+qS7MMacsOdMGWbad+J+0Am19i6xgIVus=",
            "cpf": "U2FsdGVkX196lUBNFEoHZtp5Dy+QQ0QUHU91laJFnUs="
          }, {
            "num_cand": "U2FsdGVkX1+5T4TY6qzp9uFQdoZyVbubuL6Se0kViME=",
            "cpf": "U2FsdGVkX19aLWyo1TCd02Yu3FNa6fi44uJ1fYhOHY4="
          }, {
            "num_cand": "U2FsdGVkX18nc8nCjL7tWtqBycvji5gBp5wRtJI9q84=",
            "cpf": "U2FsdGVkX1+DsaRtO+IlF46jrhlNpQ07Q4rNl3HB6VY="
          }, {
            "num_cand": "U2FsdGVkX18Jbj2ffTlQYeyQBO8jQLJ7aCJ9Hzj2Yco=",
            "cpf": "U2FsdGVkX19UfYRSBbkBi3VT5DwRA+ZAfP7+z/cre74="
          }, {
            "num_cand": "U2FsdGVkX19L0Tu0hmpzmSNtrrbNcDK3o7RLPYk+nO8=",
            "cpf": "U2FsdGVkX19PyA9JHbHzK5rucdyLL/KYfnkRwWliYAQ="
          }, {
            "num_cand": "U2FsdGVkX18/osbaYVGwRZaRrA2E624313upPtkV2+M=",
            "cpf": "U2FsdGVkX1/t3WB150X3MzuO1KBskPYS3VJYFRu2sYE="
          }, {
            "num_cand": "U2FsdGVkX19j6LQlujx84zeW4TlNTXYpSz0MMoMVFk0=",
            "cpf": "U2FsdGVkX1/9Fojm+//uCG6rbcUDHDPervPLaQBjqKw="
          }, {
            "num_cand": "U2FsdGVkX1+tDJ5ogvm+7yDHILPYyX+IiChK+XejJZE=",
            "cpf": "U2FsdGVkX1/X9qc4pVht25NI0bGO6bSYjyUSDa/8CUE="
          }, {
            "num_cand": "U2FsdGVkX1/72C/tz4HSQZEcLHPZ4EnTV+8wvf1MMB0=",
            "cpf": "U2FsdGVkX1/Cd1qD5bM6ujlW51gp92fAsaIj63k+oVk="
          }, {
            "num_cand": "U2FsdGVkX1+Y5fP2WjsTF8ol5sZgVeXtYgSPWT2FK3s=",
            "cpf": "U2FsdGVkX19fir632DXowUeJXmvaEOcMcMabkRdg4io="
          }, {
            "num_cand": "U2FsdGVkX1/L0psep069IUAJKFmNQYInVVUkTXW5oxA=",
            "cpf": "U2FsdGVkX1+rK8oRxxKErS/hoIAjXdN9MwwYIfYQQkI="
          }, {
            "num_cand": "U2FsdGVkX1/fJZqyYmxzno3hKMBwawJyePl/GbmLbvE=",
            "cpf": "U2FsdGVkX1/f2SprFLpoVMyVEuhi3aBEOUPt8vHClX8="
          }, {
            "num_cand": "U2FsdGVkX1/3G/Dpv63GGjXuNcH1hRqOeZcCL6OG0e0=",
            "cpf": "U2FsdGVkX18q7N7lq5ICFbVM9a4iOXJh0MhiMfmkYto="
          }, {
            "num_cand": "U2FsdGVkX1913o1rXBpDzgMT+6Cy2jYYeU6tRnnHD5k=",
            "cpf": "U2FsdGVkX19Wj+F+Gi/O8l255/Jq2z7Z46UAoElS55A="
          }, {
            "num_cand": "U2FsdGVkX1/gBRrY8Rf+YNMlqb1Jg9qDrO5Js0aAaV4=",
            "cpf": "U2FsdGVkX18jDuAT0cBn57xBlpklh55tTFTLxMAy3k4="
          }, {
            "num_cand": "U2FsdGVkX1/Qzd2jBKr7mwklzoktpjgWLd6BHZjKSRo=",
            "cpf": "U2FsdGVkX185BZoLB17W3JLPfqNfHqniSqz6IdONnvc="
          }, {
            "num_cand": "U2FsdGVkX19qPo2VDSuao6tLBgR5HWr6OFj7I7v9rps=",
            "cpf": "U2FsdGVkX19crIvZATNPPVXRQq5kQC1a99R1NnKKo0g="
          }, {
            "num_cand": "U2FsdGVkX19L6LuGrR/bbS+Mjn2wEy803TFf7oWRKlg=",
            "cpf": "U2FsdGVkX194Nr6DoV6O7QTMZufp4i8Y5y7H7eKrWvU="
          }, {
            "num_cand": "U2FsdGVkX1+DF4ETPrBaiMBrqg/73bsfVpmNaghSA68=",
            "cpf": "U2FsdGVkX1+0WKzsog7dOxuFhUqQ9JWEuN9sQJOvyNA="
          }, {
            "num_cand": "U2FsdGVkX19asXKkBl4uu6i1vrqHucifzr/wozdJwVA=",
            "cpf": "U2FsdGVkX1+YrPOK2WqRuTAm8mz5Fx3VeiLAMNirSFQ="
          }, {
            "num_cand": "U2FsdGVkX1+NERaRx1K5cegbsMan19HsNyG+eWWGxZo=",
            "cpf": "U2FsdGVkX1+Kb3QYxpJW+4zEEf/y6xfEhAkI7j8A6ZE="
          }, {
            "num_cand": "U2FsdGVkX1/63VADU4IKt6jd6O9zzSeW/ZUSU/GsmmM=",
            "cpf": "U2FsdGVkX18pF9yK6S7dqAZwci3q2SJY2hoWEWSNZtU="
          }, {
            "num_cand": "U2FsdGVkX1/v1KT5MF17MgdsJOmQwfg7jN2XGeRrUgg=",
            "cpf": "U2FsdGVkX19rIT7Dg9ehVDJHuZn7IfiHTfvJX7v5OLc="
          }, {
            "num_cand": "U2FsdGVkX18iHHp1/UDdLwKBl9J+yI7xcdqQqpSh+Ps=",
            "cpf": "U2FsdGVkX18zrv5dE98l4oz+r3C9D9LY11YGOhauFKM="
          }, {
            "num_cand": "U2FsdGVkX1+rgjUwqDVyaXx04Uw2CVd6nPngtncOi50=",
            "cpf": "U2FsdGVkX18NkW90DeXfqFwegxkFwoJh8e7Bh32S4Os="
          }, {
            "num_cand": "U2FsdGVkX1+vYfJ9wsV92jVbY63ltDFRfslUmKK8OHQ=",
            "cpf": "U2FsdGVkX1+sqtaxjIy6Bagt6msMEGKV2mfJxQiJFkw="
          }, {
            "num_cand": "U2FsdGVkX18Hd7sSgGRrpHjtsctHTB3ISXXJBWuwoTQ=",
            "cpf": "U2FsdGVkX19kvUlkCKP5j/qX4BoSeKtFFKUBkcn0444="
          }, {
            "num_cand": "U2FsdGVkX1+IOTM5/E/oDaS/z17dBYRaE8XntPGeYSw=",
            "cpf": "U2FsdGVkX1/u8VYVTTx3VBV+5WQSJ5GU/01+EGy24Yo="
          }, {
            "num_cand": "U2FsdGVkX1/i2NdXsgnrhVricSK1NekRd3n7XcmTKJQ=",
            "cpf": "U2FsdGVkX1+9pyFbCZeyQ4pOhsRBP3tBKIFWoETMEV4="
          }, {
            "num_cand": "U2FsdGVkX1/mVa/nBf87pS/pC40apptFS6A5kcLcOTQ=",
            "cpf": "U2FsdGVkX19z6F13j5kjn3pgJQvnZDfZ6iFFt+ROhPg="
          }, {
            "num_cand": "U2FsdGVkX19qf4K7Ek6vSM5bSx03jCm2M+pj3NKCpYE=",
            "cpf": "U2FsdGVkX19PmPEqOFeYSPJbkB13f765aYSvBSU5tkc="
          }, {
            "num_cand": "U2FsdGVkX19CRk1XeTdfcwyQ8tSRm1b5ndDyrJBIpys=",
            "cpf": "U2FsdGVkX1+2pNvu++WMoQ1uZ6wE2zmux2Rj327CAKo="
          }, {
            "num_cand": "U2FsdGVkX1/K33+JvL9DIIUDhxn4k9BeGnJ81/n5DSg=",
            "cpf": "U2FsdGVkX19scoY/xzx8TTcMqSgbvH3an17BwRJCdbQ="
          }, {
            "num_cand": "U2FsdGVkX18zgvMvf48t2G0dMb1g7TdfGhIE7RJ7kXw=",
            "cpf": "U2FsdGVkX1+NOa/Lti9wLXYNLXy3qVVg3DiPA+UjIao="
          }, {
            "num_cand": "U2FsdGVkX1+ymKCtCJH/ZunViaG9jmrzEyKizM5XLyI=",
            "cpf": "U2FsdGVkX18EcpWV7FJttJkWw4hi1F7Un++KwWhMV2o="
          }, {
            "num_cand": "U2FsdGVkX1+W5q5/A+jcksudVK03MKYM50I3mtu7NR4=",
            "cpf": "U2FsdGVkX18s47pmvi7JkSp0/4dy5+Dh4M9qIJk9X4Q="
          }, {
            "num_cand": "U2FsdGVkX19iKiRAcg59qsuD4cUZcKrj0hJh0HakwoE=",
            "cpf": "U2FsdGVkX180fXnCV2NsTv9faFXa8mI36Zh90bbLuFo="
          }, {
            "num_cand": "U2FsdGVkX18J/MzmP1mOJsWadDtN2e6fu/AH53JFzLg=",
            "cpf": "U2FsdGVkX18uHEWHsZwKJIwEk9yvF0hKdgo6/Xan5+I="
          }, {
            "num_cand": "U2FsdGVkX196B6+94GTJj/uScWF5CrnFfV3TkZTR/sc=",
            "cpf": "U2FsdGVkX18k3eNDroxVTbQUiw0MJyjfukof/lcZoQk="
          }, {
            "num_cand": "U2FsdGVkX1+gnbVsEx+G5DCuT4RYMnyC99Y62zcNli8=",
            "cpf": "U2FsdGVkX1+0A8baVFPShdwd3GGLr1mHdstiqWW22mU="
          }, {
            "num_cand": "U2FsdGVkX1+nmXpLr77nGsYlWCX/89NCI9CpgeuoLtg=",
            "cpf": "U2FsdGVkX18e9EhtUwUFMUTom4SKLN8MN48kFPX29YY="
          }, {
            "num_cand": "U2FsdGVkX18RqM/LN8Y6wyYsfHqCBqO6cOAo6stB50c=",
            "cpf": "U2FsdGVkX1/vYKWdviQzgwGaShQFy9OgBjQPSpIE4NI="
          }, {
            "num_cand": "U2FsdGVkX18JwjsfnAWq2M5y64+aiDAiDKzq3BR9e0M=",
            "cpf": "U2FsdGVkX19Vn7VRnjMMsX15RcubZHjdyVf21fv/DOQ="
          }, {
            "num_cand": "U2FsdGVkX1+xGQ37IDx9fqkAkNz3uQ8YqScU42Jxe6U=",
            "cpf": "U2FsdGVkX18mq+o1gk+unf4RwT7mwMVAsXHr2nxeCrU="
          }, {
            "num_cand": "U2FsdGVkX185u0vM8encLgtunCt9TRv1fXpBUlDdUlM=",
            "cpf": "U2FsdGVkX1+4mIqrCrIovGzl2f+8NYeXpzr162SMBb4="
          }, {
            "num_cand": "U2FsdGVkX1+INkTRUWSh/PdiO8W7gI0gCkUqRC/mhTI=",
            "cpf": "U2FsdGVkX1/V7x84M2fkVsjaZwqfx5krpIqcUA/eTyg="
          }, {
            "num_cand": "U2FsdGVkX1+z5zq8NXjiNXI4AVOT9Gja0Iec4GnJwbQ=",
            "cpf": "U2FsdGVkX1+NOGNcwu158prWjN6ttFaT7vh0oN+S/3k="
          }, {
            "num_cand": "U2FsdGVkX1+727s2jxNXu6qmZA39BOcqtLcs+d+bO8k=",
            "cpf": "U2FsdGVkX1+zmI3wHkCquxr0j4043TFU7aGJl2k9xLA="
          }, {
            "num_cand": "U2FsdGVkX19Ij2NeNpdX+UymlDdKd3aEoeOS4001iwE=",
            "cpf": "U2FsdGVkX197Xmfaa/gomiMP+SuIjIu+xkdizpcMPTo="
          }, {
            "num_cand": "U2FsdGVkX19YbHjLYOMWbVzsrO5/XkOmNm7nDRLdZ2M=",
            "cpf": "U2FsdGVkX19rlxveIeM0VdEqTOh9nGEYwrCwSj4Emfk="
          }, {
            "num_cand": "U2FsdGVkX1/TGlCrl6QHDcxK9SfEEKlRyVpZz4/H1VY=",
            "cpf": "U2FsdGVkX1/s61hKK/wmfltkZNmCBESr5Ufq48Z9KIE="
          }, {
            "num_cand": "U2FsdGVkX19GXX/I1SrRU1x8kjyf7PnzyKVhFhTqzJw=",
            "cpf": "U2FsdGVkX199yPmDA2UvtgMT17B25Ki6GfZZX9XuxDs="
          }, {
            "num_cand": "U2FsdGVkX19S+1uBjYStsKl2JSkOrXRe35PFHWFi3q4=",
            "cpf": "U2FsdGVkX1/vngW7Jl01EX3GeAwXuVPBOXveHqRDA6w="
          }, {
            "num_cand": "U2FsdGVkX18aq9fHKN1uDaHLkWvTiCGu6yan/eWL0G8=",
            "cpf": "U2FsdGVkX1+0LXYxlrAPuTG2kcWRT6coXPeOPqV78Pw="
          }, {
            "num_cand": "U2FsdGVkX18aS250w03PH6xPWDEnAyxFqTc8/FBzi/4=",
            "cpf": "U2FsdGVkX1+TZfHSD7EnqB/Fbix70TsNaTrKbeiX42Y="
          }, {
            "num_cand": "U2FsdGVkX1+1ZyO6fXpR5TQA6LsVLOIt2axf6cQBUE0=",
            "cpf": "U2FsdGVkX19WU5DyYCGls3pZsBwZk48rbpFQoj4PEfI="
          }, {
            "num_cand": "U2FsdGVkX1+8A1cWYhUp422naGmCZY2FnLDcoUfc2ko=",
            "cpf": "U2FsdGVkX19XWuVPWxBqR2Tl3UkXWz/uyxhvV12C6OU="
          }, {
            "num_cand": "U2FsdGVkX1/5EKcKs+8086QH3rX19A7AgMOI5bGTkHI=",
            "cpf": "U2FsdGVkX18m8VhZSRCdE+TD+SaU+xar4FTz7KSAuQU="
          }, {
            "num_cand": "U2FsdGVkX1/d0eAmQiWvtQw9rJh04HJJQQuADR8fQeA=",
            "cpf": "U2FsdGVkX18sOr9xEm5Mr8nYi5P7jBErxwh5zibW0IE="
          }, {
            "num_cand": "U2FsdGVkX1/4cR0eHu1YicegKQbp5npZl2wgaKwHlk4=",
            "cpf": "U2FsdGVkX18LPHZHN0Jpbgaj6yC6XgDKdwHGG3tpRI4="
          }, {
            "num_cand": "U2FsdGVkX1+r7mdtobMHS6ZIojeXF5vMg2z4shKIeSg=",
            "cpf": "U2FsdGVkX1/ro2IUuHc8RDfC+PotnDHlOuYg8L/3b0s="
          }, {
            "num_cand": "U2FsdGVkX1+BZ2qnHiccV9+yarHsTD8eAiE2iklOLII=",
            "cpf": "U2FsdGVkX1+hHrnO5qSDxBltbUQFKvuQYZ/y+P7eurE="
          }, {
            "num_cand": "U2FsdGVkX1+crtDz6HrynjnHBz2SDrdr+jPvutbYVko=",
            "cpf": "U2FsdGVkX19hxdErpvLEnbLadPVhQ7BcKRLPoBiRXmk="
          }, {
            "num_cand": "U2FsdGVkX18ijEqQcNa/7CjSKao5HiYFKqySnCbMxdU=",
            "cpf": "U2FsdGVkX18T59FMEMbYqoKBEj1975d8SsCB29oRGbE="
          }, {
            "num_cand": "U2FsdGVkX1+zJDmO23n3ecggL9d30p/c7kkBO5nhw5g=",
            "cpf": "U2FsdGVkX1/5wwSng+0g9If5fXjxiFPWDDI2COiMbVA="
          }, {
            "num_cand": "U2FsdGVkX18Oiaoa1Z3Q3E8Up2t7jN9sN68ooiIKWzI=",
            "cpf": "U2FsdGVkX19cfDbU4yGqPt0eWWvLQpJiO4st1Tx7W54="
          }, {
            "num_cand": "U2FsdGVkX19MdhcI3hMRIByq/jBRiCPgm/lk+YokcuM=",
            "cpf": "U2FsdGVkX18AEID/nXE+8lOam/YSnMF5XgX3V8Rss2U="
          }, {
            "num_cand": "U2FsdGVkX1/ckNRp1+G/TQoYy2UBVP61W79rphUMpjM=",
            "cpf": "U2FsdGVkX19H/RCujOF8NRpHIOiLEzlmCFyie//kALQ="
          }, {
            "num_cand": "U2FsdGVkX18VGfOUrkpPNC8EfvSZD/AqVVgXahfnTW8=",
            "cpf": "U2FsdGVkX1/U3WOZdDoal2cc7mfUJeYP7RSZRKV/7V4="
          }, {
            "num_cand": "U2FsdGVkX1/wH7KJe/2S6qWGl9ccfvkydgtldMdYoqc=",
            "cpf": "U2FsdGVkX1+5sVe3lVt1jWDlaNJsLmOJdDlHAJmeNEI="
          }, {
            "num_cand": "U2FsdGVkX1/TDyB5a4clu4z67GaP7zf8s6DOsSd4+eE=",
            "cpf": "U2FsdGVkX18v5Lnv49l0kraju3jnYR8Ypks/O1KIFfg="
          }, {
            "num_cand": "U2FsdGVkX18jLBnteGIqgqi/f/73stDErDvRwN6LAJs=",
            "cpf": "U2FsdGVkX1/faiQ0WGRxa2l9cABmPtauR2YdXzanEig="
          }, {
            "num_cand": "U2FsdGVkX1/K/eIxP20bAC1Hx9UJ4V6Q4cfOWutAhIk=",
            "cpf": "U2FsdGVkX19Vzqkxcm2jNnsGovSscPaoY0mgqQMdUgc="
          }, {
            "num_cand": "U2FsdGVkX18Tw0rSpB6Vrc46gw7h/qResqo7/TZkEu0=",
            "cpf": "U2FsdGVkX1+2ML86NXDcsS3YE4yZqB0nVqP2wGlxFbE="
          }, {
            "num_cand": "U2FsdGVkX19YKVUbrAR1PKJhXjh1lBgh2v4+Beh5Q8s=",
            "cpf": "U2FsdGVkX18dYsaQ21vcUIt+JTXYJ5oRDfiCjHJBVbg="
          }, {
            "num_cand": "U2FsdGVkX18QS0bAt6Cw1xPqFbwVk+soHJ6fQnh7Nxg=",
            "cpf": "U2FsdGVkX18qYw83lquuuYzbuzAz61VA0Ic4veeLITo="
          }, {
            "num_cand": "U2FsdGVkX18CKPm1fQzDPuSm8BKp4+EaFL3Rx13vgwk=",
            "cpf": "U2FsdGVkX194cXjNgTe739qgEup0FEO2YNQK2Vd8Jas="
          }, {
            "num_cand": "U2FsdGVkX18kGQjMWCehaMkNx4mYhrVkyWlLZDUH1O4=",
            "cpf": "U2FsdGVkX1+WACnKeZvR58duOvcvW5Utojdtu2+8osY="
          }, {
            "num_cand": "U2FsdGVkX1+c8Dkap73Qs+OSOLsU4vxo/KDqvwwXK1w=",
            "cpf": "U2FsdGVkX18+sPFHQVKevBCmaKUtpUtsNcvExt4EGmo="
          }, {
            "num_cand": "U2FsdGVkX19+1fs1Pw2ifNRj/02wI+Eilye9u0Bu6+E=",
            "cpf": "U2FsdGVkX1/Iur5luBDQLEsNn6F+lglzrfc31NeQGbc="
          }, {
            "num_cand": "U2FsdGVkX18gdXp3PP4a/csG3bni/2YaIA1pEUeUZzc=",
            "cpf": "U2FsdGVkX1+UAhCtsHMd8C0JAhyIb3sehzRw3AzalD8="
          }, {
            "num_cand": "U2FsdGVkX18DZNu9FIr16Hh7uyYAF+cl2NhplheXz84=",
            "cpf": "U2FsdGVkX18DVgFhWR955AYAIpjJ2XGprkGD/BT3tPQ="
          }, {
            "num_cand": "U2FsdGVkX19mz1wd1j+U+IpjYCaM3v0W5as84DWiRNU=",
            "cpf": "U2FsdGVkX1+6X98lsba7Px5kbxzABn2V7VbxqJ6ni2c="
          }, {
            "num_cand": "U2FsdGVkX18sf381wdY8oTWbURc4BgYLHNVP9Hjpmbs=",
            "cpf": "U2FsdGVkX1/EeaS5rA+Ftu6S2cs6dKfTBWOpYgWXskQ="
          }, {
            "num_cand": "U2FsdGVkX18xGj8bWLn15uhkS8OBGCUuHdTOJ4IbX+s=",
            "cpf": "U2FsdGVkX1+gjfW94CnlxD1DQCU2YSEJGP38fzEGuhU="
          }, {
            "num_cand": "U2FsdGVkX188n7iE65eTwQtOB1cU04zUTX/SQDIMSUE=",
            "cpf": "U2FsdGVkX18z0p0MY/Iti3y7zMOZJeKtOcrlKM7y0S0="
          }, {
            "num_cand": "U2FsdGVkX187rZpBYpySfRHzA5votN1h1icLPWR73Qo=",
            "cpf": "U2FsdGVkX18RohX4xqul5KXVHKh+fvqQyG44H83gTWo="
          }, {
            "num_cand": "U2FsdGVkX19uwBhWQ/+FF9qEMYljdYxuFaInVGOnf2Q=",
            "cpf": "U2FsdGVkX19CltBBM0VGXRJSAoptQF5c4RRVaQid5uM="
          }, {
            "num_cand": "U2FsdGVkX1+Ird4WAgFfnMmk2N+hmK4xlPeCQL0J2YQ=",
            "cpf": "U2FsdGVkX180rytqfB8KbI08fHO7Vxu+qlgXUEaIBQQ="
          }, {
            "num_cand": "U2FsdGVkX18KrqdwzetfjGs8HXFGYPiR6DNdqtfQtvE=",
            "cpf": "U2FsdGVkX19GekyWdwbFCptbe7uuzKEq+lJJxVKqt7U="
          }, {
            "num_cand": "U2FsdGVkX1+uuvk84EqlIZq42E5SC13FBQGTOCOx6nU=",
            "cpf": "U2FsdGVkX187s25yLUgFRgb+EMzqB1BdXDA1uYnMvfo="
          }, {
            "num_cand": "U2FsdGVkX18qpWHvkYMR/gye9hnpG2dxhK866lp4wYs=",
            "cpf": "U2FsdGVkX19mkbi3jZUnYlWKVLYv2/M7gAjreqbg1bQ="
          }, {
            "num_cand": "U2FsdGVkX18hqEMNz60QjlN9OfigoyCa9J8qwQ8DInA=",
            "cpf": "U2FsdGVkX1/yQCVE8kYlokZWzje4z2TVjH2A2rbXWGs="
          }, {
            "num_cand": "U2FsdGVkX18AIHWy++tdTtaiOlr6oVyxKrD+Kso2QoQ=",
            "cpf": "U2FsdGVkX1+jv52eYGFEKlCeG/15QDntyTJTr+ScW1U="
          }, {
            "num_cand": "U2FsdGVkX186lcBJgXICf5lmKwtHmGSD5Vo5mNDajvA=",
            "cpf": "U2FsdGVkX18alHlKC0M1iepUGoX/OohGWCDi6+w9+ks="
          }, {
            "num_cand": "U2FsdGVkX19+zZ5jEu4AdPXlqvN5ycVqmEGAcn8aFLs=",
            "cpf": "U2FsdGVkX1/YfovtbarWavJZZ9xc8QclRWMXZm3hA3A="
          }, {
            "num_cand": "U2FsdGVkX195VE6em7lH58mRzKcdfo1npze+8KhYM34=",
            "cpf": "U2FsdGVkX19hxyGpHU8pa+0lgaNGCa3NL2X/AeyPq04="
          }, {
            "num_cand": "U2FsdGVkX194YA40csLo0dOXqPFsDviU1rK8uBgEFnQ=",
            "cpf": "U2FsdGVkX1++NWsb1tGW/tXDVg8+tbPFlYIJC14dTRM="
          }, {
            "num_cand": "U2FsdGVkX1/mC6EwpjTSLI3RNaHJM7K3vuqqAFHai3I=",
            "cpf": "U2FsdGVkX19r0ZiPpNHMgauJmWXo63Hxh/LF3g94T9E="
          }, {
            "num_cand": "U2FsdGVkX1+2yGi+apMXpYnCX3oizp3y5J8ssI9cs7g=",
            "cpf": "U2FsdGVkX1+PTh5hn5IN4WWVobNq/RBs95aqmvVJG3c="
          }, {
            "num_cand": "U2FsdGVkX1+yGx6NNVOz7GeM8aawjmNKO8V4aIgOuGs=",
            "cpf": "U2FsdGVkX19z44xCul2REOldnUqAwQ/vZZF4RjQVdXo="
          }, {
            "num_cand": "U2FsdGVkX1+9avlRc0WgxQyQ5gahItVW0FYNBcxBR2M=",
            "cpf": "U2FsdGVkX19TzpQQ74g+Cdrik2x8xsaP9I+MgHMWtac="
          }, {
            "num_cand": "U2FsdGVkX19MNvR3YQY4aKL0WAINCdnOGfm5a8tKWf8=",
            "cpf": "U2FsdGVkX1+T/phELfCnhFtbteBJ4gp8atCiNdnoiUc="
          }, {
            "num_cand": "U2FsdGVkX1/VC1/dGsynnAj1b5I6JPg0PMzJS9W3+80=",
            "cpf": "U2FsdGVkX1+ZX1wQlHozVoyA6qY2WMbfa6k7HNJCDwU="
          }, {
            "num_cand": "U2FsdGVkX19rVHAHRf/olqCsw7a7iXg9y+sn/aEplJ4=",
            "cpf": "U2FsdGVkX1/LPesbnaNKO85djfh79/CyqEwFr9FMWtg="
          }, {
            "num_cand": "U2FsdGVkX1+siUxMlAvHKdR0hq28U//Xh2PeqLjLKKQ=",
            "cpf": "U2FsdGVkX1+PrL2JbqO1sCdBeQFIvDUyPKPPJ6tmbkk="
          }, {
            "num_cand": "U2FsdGVkX1/QNcgtcuyXpEcA1ekpzhDDS6AI7rROaEs=",
            "cpf": "U2FsdGVkX18T1tzX6r4BFblqU7ttbU0FiPTbR+GL7j4="
          }, {
            "num_cand": "U2FsdGVkX1/y0JS+qcK37sLN38aQ3hR6tJ16koSz/k8=",
            "cpf": "U2FsdGVkX18qHYez9nqfjPp4NZ5XlE+RfjFSxA6Yw/M="
          }, {
            "num_cand": "U2FsdGVkX1/txXZCrk93lVzWhXjATVTFvksVTOLEuB4=",
            "cpf": "U2FsdGVkX19RhtLRpTpTjZtJ5QyGavaY96vv440X6aI="
          }, {
            "num_cand": "U2FsdGVkX18yaYQ24VcImc/7aq88lnAfxlO/HEuyw2o=",
            "cpf": "U2FsdGVkX18M98wS67bNm49jMaaoEQOfGOGvNmulzIk="
          }, {
            "num_cand": "U2FsdGVkX18eKhvuPWasxLLVcbWW6YWrLyNiJspBrBs=",
            "cpf": "U2FsdGVkX1+PcFcAvLL6TGpUpUogKOZ5nJtQ13mjf6o="
          }, {
            "num_cand": "U2FsdGVkX1/LA7aZrfvM5Rw0YRTM3pIwBCjCXyIPurs=",
            "cpf": "U2FsdGVkX1/BSA7bxCs0GDTGBKOjX5smjUi8SMzS+Jw="
          }, {
            "num_cand": "U2FsdGVkX1/WKdx45xpHmpiuKUSu/NRAElKWpVn944o=",
            "cpf": "U2FsdGVkX18+vgeEkoDPucHQs+PtD38TX4eXJztzIZM="
          }, {
            "num_cand": "U2FsdGVkX19QUx0g+nhgJAyxgyJotCIt43YWLkJddhk=",
            "cpf": "U2FsdGVkX1/WpS0nTcbBnGKmXzkXHDIR8ixeVTxJ6vg="
          }, {
            "num_cand": "U2FsdGVkX1+tp+1TYjt3MUIqE9StXzxYguWQrd2u5GA=",
            "cpf": "U2FsdGVkX1/5EOy2lhzYlj1I5EtZ/XH8keEhdMarAYY="
          }, {
            "num_cand": "U2FsdGVkX18tPFJmeM+uLI/SR35/Iwc63e3CpYHFqsc=",
            "cpf": "U2FsdGVkX192frXpURNpxeDkvBE9NQOpf6oDFJChqJ4="
          }, {
            "num_cand": "U2FsdGVkX1+NDvCRGhk55QsoTFjADoN6HYIiRXDyyoU=",
            "cpf": "U2FsdGVkX1/CHM4tv5BKFA8BRcW31UQJ8GBo15z8GaI="
          }, {
            "num_cand": "U2FsdGVkX19jTMgOXwzo4icX8xwF5egEwxobU7n8cYc=",
            "cpf": "U2FsdGVkX19QwY50HiJXIXWwxEck3fbyM18yabE+kps="
          }, {
            "num_cand": "U2FsdGVkX18L0a64yxiRbh3XUZM9qxZCcBWuFsuIx1M=",
            "cpf": "U2FsdGVkX1+C3bS2O2o9NxcIUFVddNK16BR9D1cULY8="
          }, {
            "num_cand": "U2FsdGVkX19skTvzp216kSpeOy9l3SUJCYb0/4eXcQg=",
            "cpf": "U2FsdGVkX1/s0am++N2JhTgyqjbEYYL00B1Oyw9DzRw="
          }, {
            "num_cand": "U2FsdGVkX1+ORkf4OptXuAzUZR7XjqsxZdpFx4lSBFQ=",
            "cpf": "U2FsdGVkX19344+vVSnLoSgIE65i5i8d7k+q6iqHhwk="
          }, {
            "num_cand": "U2FsdGVkX18MCpBpXiqRGgKaYtZqVr7ieZ0X98gKwJo=",
            "cpf": "U2FsdGVkX1/zm1n+t0rNtnNZJ8rdKn+lAUy84a6BkDo="
          }, {
            "num_cand": "U2FsdGVkX1/kdmFx0te5DV9alfsytHPzMmSW4xb+ziw=",
            "cpf": "U2FsdGVkX18OkHC++qs0Oi2tYNyU9C4I5iRoTRyKBo0="
          }, {
            "num_cand": "U2FsdGVkX18exUMPfUtbCm+diqWjn2UFnrt3+HcwwMo=",
            "cpf": "U2FsdGVkX1+BZsCKt/dDFP/WO7kpZvhroT3XKIlq4xI="
          }, {
            "num_cand": "U2FsdGVkX18t5uMP8UYQymfP9Ie2ZVpSHhtWo1iJzlw=",
            "cpf": "U2FsdGVkX1/GesWXZMr9+/HhvsIqsoCjtq11sWvAv7E="
          }, {
            "num_cand": "U2FsdGVkX1/mo2bY+QJjbG5C2IFzkhgO8spy6KZeOk8=",
            "cpf": "U2FsdGVkX18sA380ODN+DxYT0JyQYQeujpdNBzJ0J8g="
          }, {
            "num_cand": "U2FsdGVkX18wqiEMkAE5x9zxXcHggHqz8qwxwb+aF2E=",
            "cpf": "U2FsdGVkX19jZX4910yaVZ+MSgb0CjmiKgVpEtuZhJw="
          }, {
            "num_cand": "U2FsdGVkX18O4XeLxxwoY8uqMQuUn9FeQirt0Zaccqk=",
            "cpf": "U2FsdGVkX1+nqxz/K2Ib0XIhF6Xg46YBGa6cfwux1oI="
          }, {
            "num_cand": "U2FsdGVkX18qfcG1+VBEHrCtsoQpp+x1XggqrTTTf0s=",
            "cpf": "U2FsdGVkX1/BahRsy+ggvJMm6q4yFhajgsRYdu1TpbU="
          }, {
            "num_cand": "U2FsdGVkX1+Fs7heOV3Ir+dxjG6XWCs61pVyQYcFFzo=",
            "cpf": "U2FsdGVkX19mFRDX+sN5jS/WamPwIVsLoMjJMPvMc6Y="
          }, {
            "num_cand": "U2FsdGVkX1+t3h3cnw5ZDzeydH+Dq93yAnGOBKqfX0k=",
            "cpf": "U2FsdGVkX195gHbVmhwVvA/gKonxvS2dRGbhYb2zW/A="
          }, {
            "num_cand": "U2FsdGVkX1+eZ9zYwogSAO/EuuL+a6s//E0EoXIThTQ=",
            "cpf": "U2FsdGVkX1+KFfReXkWQhUBVa3ItkSAMmnUDKTcrHCA="
          }, {
            "num_cand": "U2FsdGVkX19GVu7n+UG0LIIyqHwAb0zo2tn2iYyBkmk=",
            "cpf": "U2FsdGVkX1/4zEV8N0if4oiIqHBS8DBYYoM+LtAMBpo="
          }, {
            "num_cand": "U2FsdGVkX19SIgZkoiQ9vaNXd/4txjBMHSqV2RCzVMA=",
            "cpf": "U2FsdGVkX1+hXl3qyHOSBxtxRPtJcvuRBd5AFII2Bbo="
          }, {
            "num_cand": "U2FsdGVkX19klcnthLja6BzRINJlZO/+wviqQ7xSMF4=",
            "cpf": "U2FsdGVkX18SwapRFJZEN0CeU0hnw4ktQWn9zsgfoNc="
          }, {
            "num_cand": "U2FsdGVkX1/dk55eLw4jeawO3JeylQvKctUpGeq2qOc=",
            "cpf": "U2FsdGVkX1/eOuSX5bNIdSKUjMiX+4UmdaWmHSzzvJI="
          }, {
            "num_cand": "U2FsdGVkX19e6jiC42I8VDeCKLDDp0Enjdeq/3vXMBM=",
            "cpf": "U2FsdGVkX187zElz0Mga7pwcUyvVB18JSzx5rQ4ky4g="
          }, {
            "num_cand": "U2FsdGVkX18cMbtgd9jmwmOx7kruqHzi1SnSPsbCxRc=",
            "cpf": "U2FsdGVkX190hA639JCqHXuHK0F2p83R7pFYtYrUyEM="
          }, {
            "num_cand": "U2FsdGVkX1/XKP4QK/Areh2KuBEISaBr5S1y3idnMFQ=",
            "cpf": "U2FsdGVkX190zapQKWdCLPUCjuYEmJSc6+zYDXJd424="
          }, {
            "num_cand": "U2FsdGVkX1+u+WHWzYX5yj3e9+5tMCjUD4KDdyPyh6A=",
            "cpf": "U2FsdGVkX1/X0i0BrQDVL3IzasfEC9Ivf+jNl68uel8="
          }, {
            "num_cand": "U2FsdGVkX1+m5cvZ3LPssfPF7P/1UJKerjI1/Uq4Imw=",
            "cpf": "U2FsdGVkX1+cotVeT6NRklXh3yVY1n0i7Q/pLW/VUL4="
          }, {
            "num_cand": "U2FsdGVkX1+hLy3Y+r/pkmvFm6c0smnhmeEr9b2QKwc=",
            "cpf": "U2FsdGVkX1/ufzKT2T74Wssh6s4T8KK2lDc+1uVfzlM="
          }, {
            "num_cand": "U2FsdGVkX19u4k0ntvtrt3mTIBO57jZTQngP8G+8HEI=",
            "cpf": "U2FsdGVkX18xzhNgKdY7ZDb2xQAsbZKZVxVDTkDvYTE="
          }, {
            "num_cand": "U2FsdGVkX1/1/wUOKpNwPSd6r5E+Unmlcp6kJ5/n7zo=",
            "cpf": "U2FsdGVkX1/UR0AFTU2BvD/xeuBz6P8Qg2l1e+jp+FI="
          }, {
            "num_cand": "U2FsdGVkX1+dnYDiP+r85Nts6ucdjoCTEqLn4kSg8RE=",
            "cpf": "U2FsdGVkX19sWoDIzCaamcOc2Ij8k+rFk7q+jFGhQAg="
          }, {
            "num_cand": "U2FsdGVkX18JtVGYgUvf0WuyOqqd/rdk2SVcUY3QMjQ=",
            "cpf": "U2FsdGVkX1+eBUJAyR0ICRRHitF2y5zOzNnszKRLfpY="
          }, {
            "num_cand": "U2FsdGVkX1+/wMH4jWE2wMhaM1zGijir3zaMBbzq/HU=",
            "cpf": "U2FsdGVkX19gtpR+K6iQ2JLD3bV6SnVItUBkWmIZhrw="
          }, {
            "num_cand": "U2FsdGVkX18TuAXpY5JblI7KEBu0aoV1HT3I5e4qA9k=",
            "cpf": "U2FsdGVkX1+yinAAiJQyA3J5SPrqjJ6xopmBkofRXb4="
          }, {
            "num_cand": "U2FsdGVkX193pnbgaDq5f/PknZ+51zp29dSoQAchNjM=",
            "cpf": "U2FsdGVkX18FRY+MOMq5t4hgdMiFCHRi0aO+Wh1zB3w="
          }, {
            "num_cand": "U2FsdGVkX191poFibPLewdYbqCZhl8d/lcFQ5Iynhj8=",
            "cpf": "U2FsdGVkX1/WdtTjss/aG4Xz1bcKLtr6g3gSKqm0nwU="
          }, {
            "num_cand": "U2FsdGVkX18nFv4yJ6X6ddjbUURN0HGEAtUlrFReX8o=",
            "cpf": "U2FsdGVkX19MVim+5rRLbZroFxCx1Zzswfiw0Mt2F3s="
          }, {
            "num_cand": "U2FsdGVkX18gUBxN3DmXk73TFTwMUSRmS8xhFTOKzHY=",
            "cpf": "U2FsdGVkX18vQ2366qKl1ynGIZkR7ercS5NXuee+PAw="
          }, {
            "num_cand": "U2FsdGVkX19cOliP/oMpeZXvR58R2krll8PKaId4WDI=",
            "cpf": "U2FsdGVkX18uYO4FShmW/7UnWoa3u2GF//yGMjCzeTw="
          }, {
            "num_cand": "U2FsdGVkX195K0qSm6v6dM1N02qWMrNckUJe1xn7eDo=",
            "cpf": "U2FsdGVkX18PrXR0Byvw4JsSkuNO4XW3ure+YJdtDdM="
          }, {
            "num_cand": "U2FsdGVkX19IF+JzLL8WtlYqCPhX/y0DP32Z84iTIUs=",
            "cpf": "U2FsdGVkX1/d6QQYVbBcI/z85T9C4TGiLo0XLrRsGSU="
          }, {
            "num_cand": "U2FsdGVkX19CIRvpENVC5TTjURpvDvvMhrxEqXoZZ/M=",
            "cpf": "U2FsdGVkX18IBnxYRPNy/CLatBVFQDNh9AiFvjPuoBo="
          }, {
            "num_cand": "U2FsdGVkX1+le1ynmpDycgxZ0oU9XsJYMYI0t5rsGNw=",
            "cpf": "U2FsdGVkX18TJzTu4Zlq1g/QZvaHxgKX2LuGdVuZBko="
          }, {
            "num_cand": "U2FsdGVkX19UiCfzQg1Nkmom31yoAOfK8RyjynDXfXQ=",
            "cpf": "U2FsdGVkX1+/W7IOmmkPMnowFo7wL0O3PxnTj5vZP20="
          }, {
            "num_cand": "U2FsdGVkX19O10aN0mTkQUu+xxyEdSieiUvtOQrHnnw=",
            "cpf": "U2FsdGVkX1+Ova/KmGoc+PWR5T7qKkjXq5dy+u6g4ok="
          }, {
            "num_cand": "U2FsdGVkX1/wMsy1o2cSFvIgb+s6vaNxl5hcC+1uOAs=",
            "cpf": "U2FsdGVkX19EcIAMtYAqDveW/lWCoYs/nRoX7a9kWgU="
          }, {
            "num_cand": "U2FsdGVkX19WRR30Xc9hghNUdq8klgaAU29KqBytzWE=",
            "cpf": "U2FsdGVkX1/TXQrk95bI/UYpluTrq0B7prjFGHk2pHw="
          }, {
            "num_cand": "U2FsdGVkX1+8r/eEQ0HpGgWQ0XWqATK52pWGyXo78fw=",
            "cpf": "U2FsdGVkX1+SKiDvszvoRc8bXz5dgjUF6pnrDvtnU60="
          }, {
            "num_cand": "U2FsdGVkX1/rvhuVhTasiXCR30Bpy068sp24IciSAuI=",
            "cpf": "U2FsdGVkX1+thzjCkEgVRX+vDsS7WlAF4CiFa+bqjbQ="
          }, {
            "num_cand": "U2FsdGVkX1/UFXLWNBzhgmzOC0byBoL3ur1ZGIQl//A=",
            "cpf": "U2FsdGVkX1++uCmNVi0o8jJbOAScpMXOd8KAAsMbLFo="
          }, {
            "num_cand": "U2FsdGVkX1+OFYpBwmBj0ky7xYlCDjW9kmqw4pZ/zuk=",
            "cpf": "U2FsdGVkX19BGD2bIuNHubYCxI+DfEE7BL0W6wlEkL4="
          }, {
            "num_cand": "U2FsdGVkX18s0J4/K97ZxYg/rZzZrHo2NsRwiMkcMHo=",
            "cpf": "U2FsdGVkX1+DhPcIA09jAHZ1rfILLnZLBv92uUMO84s="
          }, {
            "num_cand": "U2FsdGVkX18lfu4ZvFFx4IKdCIBktjj0sXlDkaeHY6g=",
            "cpf": "U2FsdGVkX1/NTuZeIkpjjjfd+8341VJUDYgjTrpp9Wk="
          }, {
            "num_cand": "U2FsdGVkX1/mxxo4U8Dn4cXidaB6eLDGMWz/jPpPzrk=",
            "cpf": "U2FsdGVkX1/UO0JrwQR8M7r0i59VkSoRS/bsvayNADg="
          }, {
            "num_cand": "U2FsdGVkX1+D53HNrprMBFVkJSc8YX8SNnyyyKP4ALU=",
            "cpf": "U2FsdGVkX1/jfekEwpPh28dVaPbaAIAQpVaC8FArxRI="
          }, {
            "num_cand": "U2FsdGVkX1/l+cFoVknjJ+pGQP1Y5va2hrTu0IAcwBA=",
            "cpf": "U2FsdGVkX18H79jbTChw1PCQOU2vVWfEcPlQcOh3+bA="
          }, {
            "num_cand": "U2FsdGVkX19AYCXCcBbukwUuCzsjXY9wsgonSBck3x4=",
            "cpf": "U2FsdGVkX1/wmNDysc5KVENJsl1RcX72VUEpLDOAA9M="
          }, {
            "num_cand": "U2FsdGVkX19MOi5FyYvixfLij8IeGRIj8B1dJlb0DtQ=",
            "cpf": "U2FsdGVkX18/Yw7Jq2HNSonYUDs6chPiljTRjehcimE="
          }, {
            "num_cand": "U2FsdGVkX1+6sH49J+0N3c9wQkeRH8ypcWmFrp3ZAX0=",
            "cpf": "U2FsdGVkX1/+odP1V95HBSuBjNUg9dIAo6gMsXdlvIc="
          }, {
            "num_cand": "U2FsdGVkX19gmvnpuPHdnVQdOmT4mh1DMKTjspDbuHI=",
            "cpf": "U2FsdGVkX18dWApQp7Ci100BBycJMZ918zlw81I3vX8="
          }, {
            "num_cand": "U2FsdGVkX1/C+SiRIdkLKmLzB+AphS+vF39C7j86PNo=",
            "cpf": "U2FsdGVkX1/Ja+soPwJNmjQJjdDPlLwz3rSaYxFllqM="
          }, {
            "num_cand": "U2FsdGVkX1/xpbIuKNGx2UVpEF0v/j4/BMe+PqVKlVM=",
            "cpf": "U2FsdGVkX1/+Y8q8hD1UPAgiWbowAXmN/g67MVvK88g="
          }, {
            "num_cand": "U2FsdGVkX1/FBIvxvHvgtIFu4q+aujuzeYieh5bsDSI=",
            "cpf": "U2FsdGVkX1/GPyIj3Wiaxa/xwYfh27Q6ORWiOqtZ7Sg="
          }, {
            "num_cand": "U2FsdGVkX1/9PrMh/M7Gfulnd5Fjj4IvPBjnBzug1Rk=",
            "cpf": "U2FsdGVkX1/gMvD7WIoCIo/n3/t4PFUHJ+rFhQKWNO4="
          }, {
            "num_cand": "U2FsdGVkX1+kYOS5HnHh6wz6TStHw4kfPKSudNAL0Y8=",
            "cpf": "U2FsdGVkX1/UG0zmLnB7xj9PlIayWYZsLrzOV1QKukY="
          }, {
            "num_cand": "U2FsdGVkX19F3VUcMI6KsZrDrT0P25PeIRzGLUo340I=",
            "cpf": "U2FsdGVkX193dRiCaFSYoNpu9tZuBgQJSSYgMEkudgI="
          }, {
            "num_cand": "U2FsdGVkX18Xh1phEJgN3bOwcnXeRaOWdgpaG+TlU8Q=",
            "cpf": "U2FsdGVkX18Va1bws7U3hZOkpXH4sctiWec3P/DmRAs="
          }, {
            "num_cand": "U2FsdGVkX19T3wtRVgVt0gCHYzafj+SK4eMwcbINq+Y=",
            "cpf": "U2FsdGVkX187q4DQx5D7/IEkUpGi/RgXziFKrIekGOw="
          }, {
            "num_cand": "U2FsdGVkX1+uhk+uBJh6LS+R4PGDvN922ZeA4FvtMnk=",
            "cpf": "U2FsdGVkX18kofRf/9lVvRPndgoZgpjlJ1qGwD0uyG4="
          }, {
            "num_cand": "U2FsdGVkX18/IheD9ddHmcroAqhWNxekSD83eVKqdkQ=",
            "cpf": "U2FsdGVkX1/GdHVU+XIYooDKTV9j1ZKrT6cVj2nDVws="
          }, {
            "num_cand": "U2FsdGVkX1+D1NWBcS9pDokRBjRX02REyjcVg0TANO8=",
            "cpf": "U2FsdGVkX1/+t5LXKQhgp+Ry58nX1U/HF5bnH/ffeME="
          }, {
            "num_cand": "U2FsdGVkX1/6qt79yjv/EzhmW+4EcZnFSI8wqd/On4Q=",
            "cpf": "U2FsdGVkX1+Mrj0VnkpFkWx026DZ0dw9buJqt+2tauw="
          }, {
            "num_cand": "U2FsdGVkX1+La/nSgSX3Dopd1Lz+JQP0+PPKVyQU01w=",
            "cpf": "U2FsdGVkX1+31TaSvdnfkUcuhjcbTDdo4H7oGOyAo/4="
          }, {
            "num_cand": "U2FsdGVkX19LczauLTHEJHdQW3bPFpDgoxaz3+L9l6k=",
            "cpf": "U2FsdGVkX18VWhwhPUnvgdj8bTg8NHsVk4SB9jdrQ/E="
          }, {
            "num_cand": "U2FsdGVkX19yOVebIWVO+b13KPsCIMRU49jOkQ1TW+c=",
            "cpf": "U2FsdGVkX19yJo0eetq+bsQfK1v2T3CS1SIaXZwuefM="
          }, {
            "num_cand": "U2FsdGVkX1+hVLeXq91O1dCa6HI/Knlou0gw+pFHVDE=",
            "cpf": "U2FsdGVkX1/sw9lm/hrCyoTE8ZYogwgcI1qRkggXB2U="
          }, {
            "num_cand": "U2FsdGVkX1+sNyNT9Bpbwuij3u4U6KpC0eYwNhnDrAc=",
            "cpf": "U2FsdGVkX18Q3V8ZlGdI+7AwNK+yKSsEtDUM0JHNOAo="
          }, {
            "num_cand": "U2FsdGVkX19WWfi4FQ/3U0CohYIExBHojw27UTr68YY=",
            "cpf": "U2FsdGVkX1+fQrVhWScxjbWW2eD4svNUveCk6EHUmGs="
          }, {
            "num_cand": "U2FsdGVkX18UfqNYlMnrSXTc9WmCxmuAlqbOTLqY61E=",
            "cpf": "U2FsdGVkX189agj042zH3VcVcrblHtjiuzNMAPuq9zM="
          }, {
            "num_cand": "U2FsdGVkX1+fuFS3mzpWXpzbTk47eQdo1rXkeMZ/Z9E=",
            "cpf": "U2FsdGVkX18Xp38/LzGGR0B7hZ9Pd3LJH1o5xp7qtrM="
          }, {
            "num_cand": "U2FsdGVkX1/rc1pDByJOM68Hy2PZapS24Vnku27C+ZM=",
            "cpf": "U2FsdGVkX18kq01ONfQKUuP0BhRgw4XmnwGq3H8OwAI="
          }, {
            "num_cand": "U2FsdGVkX18yerKLFp9pGW/NXC3iSUci3Jzbtb7ROWo=",
            "cpf": "U2FsdGVkX19MrBcILnCbrA4ibkRocLFlsYghEgapBpw="
          }, {
            "num_cand": "U2FsdGVkX1/GvhBlNpkdTm/522IjzYbqsU9Mh0gmNmU=",
            "cpf": "U2FsdGVkX1+Bl4XReXCv4DlugGnMZmMGOFPMAUTUzNU="
          }, {
            "num_cand": "U2FsdGVkX19EC3CBGi/RQMSGrr5OVvQZl/2y+Oluo9w=",
            "cpf": "U2FsdGVkX1/OCRyk4D/ZTVxPXnocvUMVADII+l7AFjg="
          }, {
            "num_cand": "U2FsdGVkX19TsEAbvtA9lVDHVehTnmHzhJUak1gRXgA=",
            "cpf": "U2FsdGVkX1+GAML+0tok85Itb99j2vy66QrnY7P53n0="
          }, {
            "num_cand": "U2FsdGVkX1+Bf8dcpoXKTbgfcaadsXQGimHvq3ZaeAo=",
            "cpf": "U2FsdGVkX1+e4ZBDCi0iBWcin/VUvScFHL+nIYCOvfg="
          }, {
            "num_cand": "U2FsdGVkX19sgSSCwgzRPDIggqSfOF/BSJbAg7SEkeM=",
            "cpf": "U2FsdGVkX19DLJIhzMBsdPvhguko9wC5Hn8hFuHagYQ="
          }, {
            "num_cand": "U2FsdGVkX1+X4a/cgnZqNwgjK7pe3B3KAuXJUwFBwis=",
            "cpf": "U2FsdGVkX18fxzhgSdCEcizG0rPnC+79tiEZrI2qVLc="
          }, {
            "num_cand": "U2FsdGVkX19lm4uJ5VZd+DJLtPTl/WmVWhKM16F8ZDc=",
            "cpf": "U2FsdGVkX18mQz0uC6I96Hrkj6wi0KxQp1M6DsReJ2M="
          }, {
            "num_cand": "U2FsdGVkX1/KBK75VbKon5u+FTsbJWA34s+tlo3LrAY=",
            "cpf": "U2FsdGVkX19BCRWaCc2ojEiYkJwsjO3TQerWYfPeNd8="
          }, {
            "num_cand": "U2FsdGVkX19t/thaiZPkzkZEDGZ/piQsq5nkCxJdK7o=",
            "cpf": "U2FsdGVkX19rcOXdFBu6ZPoRfmrkFqJFbbg1lqK/Xao="
          }, {
            "num_cand": "U2FsdGVkX18qkgtB2JQn7XIoxJRXTGGBPDqBeVb07rA=",
            "cpf": "U2FsdGVkX1+HKLArrYJYpw+5GIej3a/QlEhxd5rNMD0="
          }, {
            "num_cand": "U2FsdGVkX1/3ijD8S0gQ/Wkcu7+kFLivk072smiTs8Q=",
            "cpf": "U2FsdGVkX19rtcymKEH2Nk4cW8jAWgQ2rjFSeK0197c="
          }, {
            "num_cand": "U2FsdGVkX186djbFAj8pvUb2bVSZObcnGtHgcKMZ6f0=",
            "cpf": "U2FsdGVkX1+jF0+tCSqY1xAxVmVm4YrFpMSNHN0HbL4="
          }, {
            "num_cand": "U2FsdGVkX19gXX2tFz1NOdK/MB6i8CocUIfbEqdbb8Y=",
            "cpf": "U2FsdGVkX1+0h3bWTWyQYoX5Oh+CEg0m8WjVHcfFXOg="
          }, {
            "num_cand": "U2FsdGVkX18HMi4BbO55O2bMbQs7Nq9YghJiHUqBGJA=",
            "cpf": "U2FsdGVkX1+6As10wtbxHKEkdOeBUSpEVPas3f8Y8HM="
          }, {
            "num_cand": "U2FsdGVkX19NZ7aTuLq+KM30fSHR4dqo2nHCzmVbRcI=",
            "cpf": "U2FsdGVkX19b9JXAh3Apf8o2Tu5yBUqsTOjMjyZeWdQ="
          }, {
            "num_cand": "U2FsdGVkX1+370Dcbt3xoUAg+7oxAyTqAMvkxl8YO18=",
            "cpf": "U2FsdGVkX19KNRVyCQA1e2wyMCCBgBErGpCweb6Da4U="
          }, {
            "num_cand": "U2FsdGVkX19itCCPqiytI+WewkamowF6Su4zyH+THqQ=",
            "cpf": "U2FsdGVkX1+iNls9UvU22YHHeX6U/t81G5qOLpUq4po="
          }, {
            "num_cand": "U2FsdGVkX19CZxhKtRPVdHRjYPUCIbnIXXr0Ri6iePs=",
            "cpf": "U2FsdGVkX18KrkWhkZptgp5maqZA3wfaQiubO17KNNQ="
          }, {
            "num_cand": "U2FsdGVkX1/9pDUGK9Zf3oKap3MTTmMZAOWlQc5m7mc=",
            "cpf": "U2FsdGVkX195Wmmpa7UCQL14z6ToUd9WQsVrmeKI7rU="
          }, {
            "num_cand": "U2FsdGVkX19Why1WP1gkhxcLecdYKkKyQWFHVXb/TFk=",
            "cpf": "U2FsdGVkX1/d9x0sBoypVRNTCJyEGwPzl8aLWoNSCJ8="
          }, {
            "num_cand": "U2FsdGVkX1+1HMYl218a/jfl3V47WwoMoeOzgIoc6t8=",
            "cpf": "U2FsdGVkX1+7BRaD19HPU/Te3eRJvavmuyWDSD14cXg="
          }, {
            "num_cand": "U2FsdGVkX19Wq54ZkOO4aUsy39xOwq2Y7Vhac4iAv3c=",
            "cpf": "U2FsdGVkX1+S4p7oQnnQrIj3Zh8IYi7RxCIitzLZD4k="
          }, {
            "num_cand": "U2FsdGVkX1+mPwdJmj3tkqLJI8ZJuV+qSQ6m8aIWBdM=",
            "cpf": "U2FsdGVkX1/ttjRIK0dcuSMeWedw34uiMBeqiMybm0Q="
          }, {
            "num_cand": "U2FsdGVkX19CajxQm83nW2wKLuMyqamjv9G0xb5EldA=",
            "cpf": "U2FsdGVkX1+UH1IqaH35DV4pAfHahrEm2vBq9DOleZE="
          }, {
            "num_cand": "U2FsdGVkX1+t+mwdsOsuv7ePm8uVwbCCIgqHRDg/bpY=",
            "cpf": "U2FsdGVkX1+RsVHPWu34sVQaHj8J36/piNg/v9kd9ng="
          }, {
            "num_cand": "U2FsdGVkX1+MD2bdMz9bZvENHayHN0Iak0ZDBqX1t/o=",
            "cpf": "U2FsdGVkX1/Vh+xwFnwEpKTevDVZiuu/1ECd0Fih/BI="
          }, {
            "num_cand": "U2FsdGVkX18+0KWuXVrLaM/1D9kfcH87dfTkALo2OwQ=",
            "cpf": "U2FsdGVkX1/SK6lPgCmacFLoj7je2xF5WsMsILlMnn0="
          }, {
            "num_cand": "U2FsdGVkX197RmfuGm82pSdjsGUTfkY7Q3T77JNMUO8=",
            "cpf": "U2FsdGVkX18cjv2lvFUN2BbiBbQ65if6NzU4IbrrXpg="
          }, {
            "num_cand": "U2FsdGVkX1+CDNaPIjRSFBMJNd4RErISB9wMAzFqa0I=",
            "cpf": "U2FsdGVkX1+INolLSJz5OlC4yW83Taml/xiYFTeOlwo="
          }, {
            "num_cand": "U2FsdGVkX1+g5Lk48GfdurMCdWA3s0ujzi5dEtbTiWM=",
            "cpf": "U2FsdGVkX18/aGqasRyyM8JhnAgiqV5A/ptQm7dvY8w="
          }, {
            "num_cand": "U2FsdGVkX1/wof1mVNjPhW67jZiPWOPrVpUcCSlGBV8=",
            "cpf": "U2FsdGVkX1/emx/ptHheCG3svI9K3UGTwDvMp4yyKmY="
          }, {
            "num_cand": "U2FsdGVkX1+cx+s4XsK8xOB0RuUvUUENp+moZ6QFIlo=",
            "cpf": "U2FsdGVkX1+QO1sE2DelecGz6RNahHbb78L/qaXI6QY="
          }, {
            "num_cand": "U2FsdGVkX19vBIvrRK5YRLjPHBJ/qoeWdKm/KWIaXyg=",
            "cpf": "U2FsdGVkX18AkWhIrWLrPKVYbDemoqkEJnCb3MurYhY="
          }, {
            "num_cand": "U2FsdGVkX1+hezclG4MqJ2uqWKSBG6NcAy7+sFJqj0I=",
            "cpf": "U2FsdGVkX1+81LMqftjzu5hH/PE2Bz9zrlXruDvMbIo="
          }, {
            "num_cand": "U2FsdGVkX1+/WfhRA76fzc3+9VDyC22YQzpXwf3LO/k=",
            "cpf": "U2FsdGVkX1/uMuOFwjGcJ8Zl7+a/marhaPZ2qJzHJrs="
          }, {
            "num_cand": "U2FsdGVkX1+71FkTTsuJb2lzNLocbOvSCM8yWQn5H8g=",
            "cpf": "U2FsdGVkX1+lDfkkz2zsC6xSs7FouLLhQ1gNoAtjC8w="
          }, {
            "num_cand": "U2FsdGVkX18vhAuc2qOQTeZSGLP4yMIWoI1Dia7ew1g=",
            "cpf": "U2FsdGVkX19Jkk3jiCZ4ScHYE+6gSHkf+i2hhmZAgXM="
          }, {
            "num_cand": "U2FsdGVkX1+9NvKqbs8rkHpP5jOmEHbDyFHzzW59xJY=",
            "cpf": "U2FsdGVkX1/FpVGLUkhhOMN/Vv9nLcNEiH6Ad7IwNdc="
          }, {
            "num_cand": "U2FsdGVkX18nLtZXY+jSwOJeQI2Rx9Q8QHVgc2q7sag=",
            "cpf": "U2FsdGVkX18nEqaAYOXYkyfLA1efKzNJUjERDSE7oyc="
          }, {
            "num_cand": "U2FsdGVkX1+jXq/TXc659DH4z3KFNJC9MDepTdr1qcw=",
            "cpf": "U2FsdGVkX19VdTcmwgsWBFXJEkmBwRJzoV2CnDNhxbo="
          }, {
            "num_cand": "U2FsdGVkX1+2V/PqUqMC9gRO2c0pCt9ZEiUkjGoMLrc=",
            "cpf": "U2FsdGVkX1+i2JvYgixeMp17sKED/Xd2GcQHDB6kZb0="
          }, {
            "num_cand": "U2FsdGVkX19XELEVcbcViTiklfyLQlTRSMimYNWO1vM=",
            "cpf": "U2FsdGVkX1/40joLS8i6WkgsBgAxEEeFdhkD+nRhqT0="
          }, {
            "num_cand": "U2FsdGVkX1804vF/1qfZAFXhGX7PkoXLG068pbRW9Vw=",
            "cpf": "U2FsdGVkX1+falUFqU2Gcxo1fkdPS9TFJ2RW4M7tIIk="
          }, {
            "num_cand": "U2FsdGVkX18IPMfIKNoPW662rwU6mTRndL8hz/qvIqA=",
            "cpf": "U2FsdGVkX18kVIncp3SvBGSHoJ36KfSWTsDhChqOcb4="
          }, {
            "num_cand": "U2FsdGVkX1/wl57KVKqBFBRamI0AuH1cTzLAu3IM2E8=",
            "cpf": "U2FsdGVkX1/unn3WRReVPTUQ84DcbFu0qIgG43ROl8g="
          }, {
            "num_cand": "U2FsdGVkX18G+t5WH6H8oGJZCHAQFtWk9R7ec47AeIw=",
            "cpf": "U2FsdGVkX1/K61FU+6tzvV6TRKhUDy+9AAEvvZfc1pk="
          }, {
            "num_cand": "U2FsdGVkX19yagzwHt1I96MeycPlbHmbWtS0mOQ4Tvw=",
            "cpf": "U2FsdGVkX1+wq0Zgf2j+tqE0dK5BN2I0PS88wi0ZTyo="
          }, {
            "num_cand": "U2FsdGVkX18zkm0Dajo/hsvU0YOdY3BOBv8Z2c2PUE0=",
            "cpf": "U2FsdGVkX18i+bUTtSnq9+N7dEf8m5+J9gEl5AGOIKI="
          }, {
            "num_cand": "U2FsdGVkX186DFlmpN2jtn6Kk3XACWRLMc9b1kG2i1w=",
            "cpf": "U2FsdGVkX19cctIhx7F2OCkQep7aOkoz9bus9QQ3dmg="
          }, {
            "num_cand": "U2FsdGVkX1+WXc98GbMC/3g4NuwFgvwOjp1lLgD9Ysc=",
            "cpf": "U2FsdGVkX1+lj7QS0gg4eR3TtdooIMdUDsAefUqpGgk="
          }, {
            "num_cand": "U2FsdGVkX19l9fY8tqhiAqg82e3NJpeD+0QJlg7d8U4=",
            "cpf": "U2FsdGVkX1+1emTpRTFi5X6bOPz06z5SUYdor1pkssc="
          }, {
            "num_cand": "U2FsdGVkX18tdAxwwNLG9gzY++oellnBsGF/35cgRvQ=",
            "cpf": "U2FsdGVkX19aqFdk2MuBVfqglaZO9tqvH51Zep3XhnI="
          }, {
            "num_cand": "U2FsdGVkX19xLmZijyNTr9GRSnvv/5KEMSEdtMzGUkc=",
            "cpf": "U2FsdGVkX19Wu1mzHtKRDeY98BA2WMFstSUgbPHfvys="
          }, {
            "num_cand": "U2FsdGVkX1+e8A6KNvn5Drx+LQos2BvVdYwpYe3m/eo=",
            "cpf": "U2FsdGVkX19+ser0xYMwhh6BMgpoaYv1hVUctCxlnPI="
          }, {
            "num_cand": "U2FsdGVkX19NwwBhErZmjmt66jubYNDoHLGiimJrglM=",
            "cpf": "U2FsdGVkX19cIzSLThgbR1Phf6rME2IdCg6BNTfSVo8="
          }, {
            "num_cand": "U2FsdGVkX19P4f+CcSkAq2ckGqI+UubywDvDShyF4+Q=",
            "cpf": "U2FsdGVkX1/B8A62mw5m0FsS1DbVIc0LFzF9UvLXo2A="
          }, {
            "num_cand": "U2FsdGVkX1+Z8NZs5FXO5ilkeJeNUlNxlGLPuveuBWw=",
            "cpf": "U2FsdGVkX1//yLXaEjNhOd8OvhmCAlrk5tIJ8uvmJyE="
          }, {
            "num_cand": "U2FsdGVkX1/k9Drau4LVm9H8VXkLeBGdnmK5GmjrZbA=",
            "cpf": "U2FsdGVkX1+zcvVYOM2xQHJX5qTqjgkJghuEPrK6ifY="
          }, {
            "num_cand": "U2FsdGVkX187AsJx7r/0LSSHh42jQrMJNwRQXYL1veI=",
            "cpf": "U2FsdGVkX19x3k49Fv8payjZ9Zvw0M1XJ0iNJrW4x3o="
          }, {
            "num_cand": "U2FsdGVkX19Its7t0m8G2GvJudPnbT0eyIqtaLhvtXk=",
            "cpf": "U2FsdGVkX19ozKK7fLJx/56itihUHzonBLWnxBwcIoY="
          }, {
            "num_cand": "U2FsdGVkX1+jSIQdci2/o055rVCBYJscPzOMlHfD+Wo=",
            "cpf": "U2FsdGVkX18wB8vL1dKIEwwhHlC4xYT/9xvTWz4nKvE="
          }, {
            "num_cand": "U2FsdGVkX1+DnfYIDVaVoVHw/Z0aILVLp4orpbWMs04=",
            "cpf": "U2FsdGVkX19+cpAdA2Kd8cA77LkHnQLVH2jpfrxUrjc="
          }, {
            "num_cand": "U2FsdGVkX18lNeXw4on5Wayyj0PUbUhqv2xAXcasdRg=",
            "cpf": "U2FsdGVkX1/eck4lStcWyRqs+tnNX59NOqazK3r+D/g="
          }, {
            "num_cand": "U2FsdGVkX18PavvlEjuUgXrRQFXR1MxaUbe3aC1qCYE=",
            "cpf": "U2FsdGVkX194cOGHp91vkzDB3qncQNLQDN5uQyOZLhQ="
          }, {
            "num_cand": "U2FsdGVkX18ZhS3DOzHmyBJYXLr+fF73h6WUfmMywX4=",
            "cpf": "U2FsdGVkX19vl+JDbEVb9VQ8FWPdAt7W+MtV7rDB3jE="
          }, {
            "num_cand": "U2FsdGVkX1+062FEWbp/VGVSfhOLnHBogwK2AJPzNUo=",
            "cpf": "U2FsdGVkX1/VEo6URht1PbM6hkgyJrSLMVExc2jL6lI="
          }, {
            "num_cand": "U2FsdGVkX1+agmYURu4n8mm49+7GIzJO2Vl31SB6lpo=",
            "cpf": "U2FsdGVkX1/OLFIU2pRiY4V37I+QtiwxGr5CG7noWj0="
          }, {
            "num_cand": "U2FsdGVkX18wrq4fzxz4F7bK2VWWs0IFzFsNoIFtg/4=",
            "cpf": "U2FsdGVkX19yt74k72Re/oveZHlspNMx64R9+t7fBJM="
          }, {
            "num_cand": "U2FsdGVkX19fvXxMXoYueonfuK77ehm3GUSIFHYIfrw=",
            "cpf": "U2FsdGVkX1+ZmDoexozm4BF8NEqm3LdpPLHKC4KqY9w="
          }, {
            "num_cand": "U2FsdGVkX1/zdYnQIez8J0JWWTsaaiLOx/pNKLwYbOE=",
            "cpf": "U2FsdGVkX1/YnLfOL9tpMmnETnHpqGFVOe86Cb8i3FE="
          }, {
            "num_cand": "U2FsdGVkX19jeNFOlih+hH+BW50eOD2vlKgV2lnQ+1k=",
            "cpf": "U2FsdGVkX1/G4Hbc88JpSHNxr/F+3vKQwvfehK6UMSo="
          }, {
            "num_cand": "U2FsdGVkX1+dxSq7yVILpNGN2jN/Ir+uegGaweFWUOY=",
            "cpf": "U2FsdGVkX18UfqJATwEmNAEV78GUJXqew9KGk4Y4dBc="
          }, {
            "num_cand": "U2FsdGVkX19XdHa0wD2SPeyw1qTwD/R9ZLGEuPkM45Y=",
            "cpf": "U2FsdGVkX1/7uQaphLcvmZKkwOvPypYHtrvVZ9oVZa0="
          }, {
            "num_cand": "U2FsdGVkX1+/w9fvd1ZYYk1B1FQz2l9j9ts6Z0yVbIA=",
            "cpf": "U2FsdGVkX1+vAVeKNAjXH+UzTFjgFXRXqDbSqTcO5/s="
          }, {
            "num_cand": "U2FsdGVkX19YD/+WvQhrqJHVpLFl1JbBpKn5hlP/ZIU=",
            "cpf": "U2FsdGVkX18HC5fTvw2fUMf1mJgwt3T1KB8/0oUOhEI="
          }, {
            "num_cand": "U2FsdGVkX19C6fBQTEvjy5RA1bwV4Tw6Rs/8y5awliI=",
            "cpf": "U2FsdGVkX19bqewW1WTpunkW653DoJiGx+zWfa9WFZg="
          }, {
            "num_cand": "U2FsdGVkX18cC7fzLatnpcnt4dT0+uBPpO2KaAV0Txk=",
            "cpf": "U2FsdGVkX18AQGnbJ3brF5mdp8P2fD4Jh+mBftVDkVU="
          }, {
            "num_cand": "U2FsdGVkX1/9CNPQjWC+xeW2a+unlHI2nxzVaimwOdg=",
            "cpf": "U2FsdGVkX18IyRd3eCOSl8qN8n2P3C7UGUCQEXRml9E="
          }, {
            "num_cand": "U2FsdGVkX1+Pw8z7gAHeeJeF+1VSNiScL0bK6k4O0SE=",
            "cpf": "U2FsdGVkX1/PRIwPi298YK1Z30OJUFGPFQHGyeUL998="
          }, {
            "num_cand": "U2FsdGVkX18aK11l3aiGNl1ELasmf1zgjN05JwWEpYU=",
            "cpf": "U2FsdGVkX19iBY4QtFLhPIEJHsRHD4eJ3+5uF4UTuso="
          }, {
            "num_cand": "U2FsdGVkX1+veOoF/aMIwD377d3xDwfhC67bbF3Ewb0=",
            "cpf": "U2FsdGVkX1+Pw/fYJlMySoGhpvBDXpeRs7VJ9CfrjjI="
          }, {
            "num_cand": "U2FsdGVkX1+Vlbq8mU55664dPFHgpGjSo4KJiFuSwO0=",
            "cpf": "U2FsdGVkX18S8iWavnHhKu+N9pEi4AOC2pws0i6hg48="
          }, {
            "num_cand": "U2FsdGVkX19CwE3fyLJnQsr0mLcrt1n+gInzIGHjFWE=",
            "cpf": "U2FsdGVkX19b3P2hG9NRT9Fsz5XAhnwBzdmud3O69JQ="
          }, {
            "num_cand": "U2FsdGVkX1/1jn/YueXizO8ayXTOl0P4NA+XF2zYiEM=",
            "cpf": "U2FsdGVkX1+qR0iKZzZfYIBPxJDm+R4YibtxO7qXql4="
          }, {
            "num_cand": "U2FsdGVkX1+dzSD/UnKIMhE5BPPS3H+h8fAMQC9D/fM=",
            "cpf": "U2FsdGVkX19si4wgSno8hRY0IarWSQscPvxsYdDBcBQ="
          }, {
            "num_cand": "U2FsdGVkX1+fsxd2P/OvMz80AcI8Nf+GEkhhLmGIffQ=",
            "cpf": "U2FsdGVkX19+mucuzej0IbyOMC9sGEFYm6ODaNX7MEA="
          }, {
            "num_cand": "U2FsdGVkX18SZbrVJBisVoM6G+8Ip5ShBYKk/uS9bZA=",
            "cpf": "U2FsdGVkX1/W+I9TeCwv1JDquQZWqsk8xHZiwko/dAo="
          }, {
            "num_cand": "U2FsdGVkX194Tlpv8pG0fq+sNugz3ohn39UdS2sV2MQ=",
            "cpf": "U2FsdGVkX1+r+DmvPuFCWbPfgh6AAEVtc//vInE06/Q="
          }, {
            "num_cand": "U2FsdGVkX1/ot870OU0dTXoGiEKnEjn5kLitcY6+Dok=",
            "cpf": "U2FsdGVkX18Xwx5Zd94mRFz5I3XNp5qShl2tq4Bwofs="
          }, {
            "num_cand": "U2FsdGVkX18DeZipIF2RDH0JL7MkbylDIBiJUOaskhU=",
            "cpf": "U2FsdGVkX1/JP+3knFHeSlR1IsOEaxbwjcsblwsNzk8="
          }, {
            "num_cand": "U2FsdGVkX1/yv9HiGu7HFQS+aH76STI5xxwbM8msftI=",
            "cpf": "U2FsdGVkX18KSInpZ+z2l+YJ4fUCBSw6lnme+9KrzWI="
          }, {
            "num_cand": "U2FsdGVkX19/7hdWKPAXC7xr8k5exLV8rXMEfj/Y+BU=",
            "cpf": "U2FsdGVkX1/KPKO5HTKeT80RzLlD/Ex1odtjjYjHcHA="
          }, {
            "num_cand": "U2FsdGVkX19L+7t0NIjo5WNkmkZYJnw8J4alRmDzdbM=",
            "cpf": "U2FsdGVkX1+J6yUZjVvjtzwV1ejiCp93qNn2fIvuub4="
          }, {
            "num_cand": "U2FsdGVkX18cNyBQ9n9JwEGWtoIXjVxUK22vbgW8RJM=",
            "cpf": "U2FsdGVkX1/0M/0moL2mynqLKNdUSwX8SEwFkG51IqM="
          }, {
            "num_cand": "U2FsdGVkX18e6SuVkB7kkV2PwT/wEiARjcK4vvbJITc=",
            "cpf": "U2FsdGVkX1+uCCOA5I9b4h409kvUhkVOvlN7TzKXyxg="
          }, {
            "num_cand": "U2FsdGVkX1/HDDKANIrWnLgKQ3xLkwYc1okXxpwYIhQ=",
            "cpf": "U2FsdGVkX1/5UslNA2wnT2cpth8Jj3DrUrkB6wdgcik="
          }, {
            "num_cand": "U2FsdGVkX1+th3bc3oRq/w+GsxCSGNEEOlEiUvagkCg=",
            "cpf": "U2FsdGVkX19/8RrCR3LzBXFzFexJomxgjFPygm8VO48="
          }, {
            "num_cand": "U2FsdGVkX19FSyz2IP4m+Dazbupe1yGnKf/L4T1U/4U=",
            "cpf": "U2FsdGVkX1+YqsqAAMwDOlgN1p3dOwyPndSoPcKn8FI="
          }, {
            "num_cand": "U2FsdGVkX18HpfT0W0e8UWQqEq7bwGxFpsWwnFps3HI=",
            "cpf": "U2FsdGVkX1+rd0UqwpOaGHVrQYhrx3DOuN1QDNiAFyo="
          }, {
            "num_cand": "U2FsdGVkX1/FB1rVByCE4PqTG1gYZWbDBYzJYsVpZlw=",
            "cpf": "U2FsdGVkX1/MQZuMsIkeE1xHdrscZhr2hHvYs2kRj2I="
          }, {
            "num_cand": "U2FsdGVkX18a9q+LAvi7Ny5ZVyTaFLHEQjvZFIaNQFA=",
            "cpf": "U2FsdGVkX18YbfddKpYKA38MxFGuUC4ub3B0yLFwVls="
          }, {
            "num_cand": "U2FsdGVkX1+4sLDAT+PlPh+RfvCGVn/riez6hMs+of8=",
            "cpf": "U2FsdGVkX196a/8bbA9SzQ28d4p/hLtLrGwfjpRIOgY="
          }, {
            "num_cand": "U2FsdGVkX18FUJd/tt0jBfJVrgXME425R4MXOI1MLko=",
            "cpf": "U2FsdGVkX1+D35N2UBPY1skguZkrZQ32NtrGG4lVlOY="
          }, {
            "num_cand": "U2FsdGVkX18vAF6IiwAFVBk2N/RLZeirI7fXyo8ivrk=",
            "cpf": "U2FsdGVkX1/pdeDAIVnNO4LnhqkrSAgG2Epg4NrM0AM="
          }, {
            "num_cand": "U2FsdGVkX1+b7t5pOzaU/sj1lIPcjmTI3lv1xA1c6ng=",
            "cpf": "U2FsdGVkX1/LW/o4L35RPmrSkxqtCQBajgQQGGqTm0w="
          }, {
            "num_cand": "U2FsdGVkX19vYLG2ePJTXucJ663P1QQupOsD+70m24Q=",
            "cpf": "U2FsdGVkX18QUl8LyHLTkBt5j5S8LecxSb/jvMKGxss="
          }, {
            "num_cand": "U2FsdGVkX18lXoAxzYCkLB3soUxDRwZyhBS6IJMgB0k=",
            "cpf": "U2FsdGVkX1/2mWVu1yAszfnKwQXUWENWIG0WEx6bf5o="
          }, {
            "num_cand": "U2FsdGVkX19GJHCQX+rMTBPyuMlZY/+vhJKwuOTU7i0=",
            "cpf": "U2FsdGVkX18ZQpYxLRRfvaQ3Q40UWInsrGTwncuSw5E="
          }, {
            "num_cand": "U2FsdGVkX1/jlju9vV9qCJi66vAS5+tn4Szg3iM7060=",
            "cpf": "U2FsdGVkX1+yk5YUBhxhaYXWRm5Zt3ax7GXVV3FN0EM="
          }, {
            "num_cand": "U2FsdGVkX1+AN0dsi+FfZYugW9uvHNQbXJmIclgQPvY=",
            "cpf": "U2FsdGVkX189SNJcG/Kslk5c7utPGgmc1musJha1Xk8="
          }, {
            "num_cand": "U2FsdGVkX19nAT6kYDLYWYM3pQR0aoZ/NUFJHiuoYcs=",
            "cpf": "U2FsdGVkX18ZR1O79NNS9479mEnuifddhKAMIYEFDDk="
          }, {
            "num_cand": "U2FsdGVkX1/Q+AEQMnTYLYMAN023Xr2jKfDDu/TJiNc=",
            "cpf": "U2FsdGVkX18uYD5WK6SQ8vRNfD3boUou7J/IYxO7A0I="
          }, {
            "num_cand": "U2FsdGVkX1+Aytl8cqtWLpK5b+oaASoygDxFHdt6Aa0=",
            "cpf": "U2FsdGVkX1/SqPS5SLfnSaHcOJ8sgZjYpYrOpSY+M90="
          }, {
            "num_cand": "U2FsdGVkX1/QyhAEyh/zgfinZSficrvfWOhCkrHXH60=",
            "cpf": "U2FsdGVkX18dCQTKb5JDiaRS78AIHcR7Y3iKjieSBAY="
          }, {
            "num_cand": "U2FsdGVkX1+Saby5Bc8oHCXdsefidz44jx975dLgJYc=",
            "cpf": "U2FsdGVkX18NP/1eEJcPpEHkHF+ZRgpeqELG00SrcAY="
          }, {
            "num_cand": "U2FsdGVkX18qj9a/HhRzYki9XzC93ME58tWEIuPCjQY=",
            "cpf": "U2FsdGVkX19Kd0uA1w1NAphktcXzM7ul8gToicPiwjA="
          }, {
            "num_cand": "U2FsdGVkX18vhmA127OIa8prYXAtMMqPAxd2CrybFbE=",
            "cpf": "U2FsdGVkX1/onybSAiQ8IF+fgG9+7gIdfNiGG3O5HCw="
          }, {
            "num_cand": "U2FsdGVkX1+LSdA9YMONKVIGDOIb2MsdS6b5li7vvS8=",
            "cpf": "U2FsdGVkX1/xUymqCM0Tgl9gUsc5F/iVVc3OtmGm2eE="
          }, {
            "num_cand": "U2FsdGVkX19I6uWvHr3D7YaHxavOYAr84NR+ZA77YSY=",
            "cpf": "U2FsdGVkX19LcQIaqx15xGK+sWsyc+E9nFTTuW5AaUw="
          }, {
            "num_cand": "U2FsdGVkX18drlUj8X6tVs0+C5Lkj6xD0MY7RY2Lmn0=",
            "cpf": "U2FsdGVkX1/hD7MfqHejpCkrV+IucT+5guf5+Ma7HYk="
          }, {
            "num_cand": "U2FsdGVkX19vRVqAOmnYXBWEFADf1YsU3m/elZlDvg4=",
            "cpf": "U2FsdGVkX180cNg37EAupsGh2dJVAlYNfX+ORSn20dA="
          }, {
            "num_cand": "U2FsdGVkX1/xWAva0CAzRFWs4b+hwqws2wE2PR31zLU=",
            "cpf": "U2FsdGVkX18Wze4lUTi+xijl8epuNsmYL6RVdVN7/HY="
          }, {
            "num_cand": "U2FsdGVkX1/QUAwYNpy4YYdeyINPn8zgMziIOOxJyCY=",
            "cpf": "U2FsdGVkX19jmYtZatGCbEEJd40MsdbaUiPlOB6VAZ4="
          }, {
            "num_cand": "U2FsdGVkX1+0n3MyEWT7uk5Ohgkkz+Ts9Y3nrEloDys=",
            "cpf": "U2FsdGVkX19v7T/cSqc71uOzw8xvJxSh6uJXBgQGtSY="
          }, {
            "num_cand": "U2FsdGVkX1+qZ4c1pmB1Iuvt1RHoHbl7ZX3vWn2Rtsg=",
            "cpf": "U2FsdGVkX18QJULAMgNNqh0eHhip3QeeQRB6Bdk6JH8="
          }, {
            "num_cand": "U2FsdGVkX19BfH2wKOQ+y6VnEUQ1lyhV07H9NOePBxk=",
            "cpf": "U2FsdGVkX19LEMTwyLwpcsQHAUJzOlAohXGTaUT3X8w="
          }, {
            "num_cand": "U2FsdGVkX1/ZSwsWNEt2yK2yO54FlF7yvYKwbtszAhM=",
            "cpf": "U2FsdGVkX189KLdTO4s6atvISQlHNaAV74ANt15ziUo="
          }, {
            "num_cand": "U2FsdGVkX1+tEpejWUOI9cJHca/2Yr7OL6eRUHtQOHc=",
            "cpf": "U2FsdGVkX1+er0dRfmo5vKNt8zU8s9rbg340YpEXLVs="
          }, {
            "num_cand": "U2FsdGVkX19dpfgQO39j/Kc4TClRs0Q40aL07T04+w0=",
            "cpf": "U2FsdGVkX1/ygM4ih4CwtWwkVqHqIij9bHabunNW1cY="
          }, {
            "num_cand": "U2FsdGVkX18lKeG6eU45FKM1qDvPcL+68qL6cNrfUAw=",
            "cpf": "U2FsdGVkX1/6CfM1uybvf9WFJ6plMW/3YLfewJQAD3Y="
          }, {
            "num_cand": "U2FsdGVkX18fgHr8ZxJesy1ImLom9/WWADYNHoONvjQ=",
            "cpf": "U2FsdGVkX19+LS6z6bCevS4QlJrF3tUZ8eljOYAATto="
          }, {
            "num_cand": "U2FsdGVkX1/QGiHoFESybbIZ82AfU59AIWRayY76WDg=",
            "cpf": "U2FsdGVkX1+hwMLWlCXpgJdtEoSqzUYStH0HOWbbg6Q="
          }, {
            "num_cand": "U2FsdGVkX18ddjk7mrzGslDklHg3DEz898BBYhGDtas=",
            "cpf": "U2FsdGVkX19dMrQoEPPzCgTZQuhxtkYx3t9z2ZicIw8="
          }, {
            "num_cand": "U2FsdGVkX18vdj+FPSgckLFmCfvCqCv8rbhDZv2uVtg=",
            "cpf": "U2FsdGVkX1/CH/5oWL/S05jCLxRQq4UwLV96uU5Qa4Q="
          }, {
            "num_cand": "U2FsdGVkX1+z0ZReLF4TwGUf8FHzVv/TxMtugR1T8cA=",
            "cpf": "U2FsdGVkX18/zAZYPg1Ps8RSzmgHCGfvPKScqJWQQGw="
          }, {
            "num_cand": "U2FsdGVkX1+995+3S1xJmZZNA96xpvus1l4UDSBeNMQ=",
            "cpf": "U2FsdGVkX1/6GOe3NDfI9tOZYCW5YZpKHikFz5CmAGA="
          }, {
            "num_cand": "U2FsdGVkX19i0ov0iKiqlub8vWzJg0wxivfSEkBHYkg=",
            "cpf": "U2FsdGVkX19N7ugCv9qnrbN/1McLjSbRK5BDi99bAvs="
          }, {
            "num_cand": "U2FsdGVkX19w07ijtII67eDjZy6fkiTHrBMMOABAbrk=",
            "cpf": "U2FsdGVkX1+o8v+rC119pF674Og1Um8F/lrfLKsPL2s="
          }, {
            "num_cand": "U2FsdGVkX1/50lZUbMAftRrAVNOTV7kbujtPvTr0WVY=",
            "cpf": "U2FsdGVkX1/c5jEv3hBGdDnQlCux5zmX2b59kSsWsKs="
          }, {
            "num_cand": "U2FsdGVkX1+EVhDmgaJ5i+3wzMWWnHWT0MSFttGl1Tk=",
            "cpf": "U2FsdGVkX1+SErbRMSXFWMn9/k5B0NjDztQoL+iPPi4="
          }, {
            "num_cand": "U2FsdGVkX1/TpMnu+Jsf6rdSyMYg7Fd6cZpBsWaBTf4=",
            "cpf": "U2FsdGVkX1+h5Lg1NPWIYYhFTv11g4GvcUYhbIeW+bg="
          }, {
            "num_cand": "U2FsdGVkX1+P6l0yjUEmHNyVZFSL5XRWP0QbyoVOrQ0=",
            "cpf": "U2FsdGVkX1/nyICHhAek4oIQu3gO56dtRooO0stbgwA="
          }, {
            "num_cand": "U2FsdGVkX1+f34tM7kVkREsjf9tThKi2eZ8d1FSZt7Q=",
            "cpf": "U2FsdGVkX1/4FSQAXdBJLw2Ht6BwHczv37/DEeQ02lY="
          }, {
            "num_cand": "U2FsdGVkX1/LYIxGaUq5zjYLBuh8mVI5t9K1ZRVY9p4=",
            "cpf": "U2FsdGVkX1/tV5tQ6xmxBvgUR0OWyHjkC4UpT9qxE4c="
          }, {
            "num_cand": "U2FsdGVkX19WbdpTsUL0qlKonFtxRuDpY9INeU5Jj2g=",
            "cpf": "U2FsdGVkX18cbhBiqeCTd+FQ8BrYD9GSqihPnvEpNS4="
          }, {
            "num_cand": "U2FsdGVkX1/PPf9QSCx/YoiUKaHIfAn1R6pkDBd9FkQ=",
            "cpf": "U2FsdGVkX184cW6Eq6Z8mAubmY7NOCA8BdUMcF4VtQQ="
          }, {
            "num_cand": "U2FsdGVkX1+m8CTFeoq6m9jQk7z+hMzryZOeuOE6VeQ=",
            "cpf": "U2FsdGVkX18TfoffoGZlVb2IoCSBK07QS/dnyNU74qM="
          }, {
            "num_cand": "U2FsdGVkX1+UFYRGDLe1f14T8BFYuKs67LAHnGBLMTc=",
            "cpf": "U2FsdGVkX1+fj2W6XIXdCy8GtVDocgMAoeGHQ6RdCwo="
          }, {
            "num_cand": "U2FsdGVkX1+xup9VEJU4xSzdlBFEysuyqU5EMeig+6A=",
            "cpf": "U2FsdGVkX1+wr01igHYPnjqgeKKjgeo1WWPdzJmb0FE="
          }, {
            "num_cand": "U2FsdGVkX1+1qvDNKnaMHFLJBbpBn/6Aw+LSDzeDVW8=",
            "cpf": "U2FsdGVkX19XlOI0+rVebRYznURdHpC8DeXAQ9hfYAA="
          }, {
            "num_cand": "U2FsdGVkX1/Uq+HM/KlTpg6VxQ8HpjoY1oudhCORiGU=",
            "cpf": "U2FsdGVkX1+86Iosvwpb5nNsCqXNzuX6JWkO2S/vIEg="
          }, {
            "num_cand": "U2FsdGVkX19YcVbuEZgYhMhEVHEIkXG/0P7vc5g08Mg=",
            "cpf": "U2FsdGVkX19b3CAGhVOeudDanfcEzbJUO/QXBQSH3no="
          }, {
            "num_cand": "U2FsdGVkX19iKr0N4sAZKZGWjFVAJgaZAnpc9tqefsE=",
            "cpf": "U2FsdGVkX1/Einqr2hdunXc58V+KQ3l6Uq0TvW4olpw="
          }, {
            "num_cand": "U2FsdGVkX1+3t9DK3Elw6d4pv/FnYTuXJuAU4podcCQ=",
            "cpf": "U2FsdGVkX19JC5sWUvq/zr6nqDmQrPrDIGs59Us6maY="
          }, {
            "num_cand": "U2FsdGVkX1/q9J0sDqZPORr9ekoxkAVeo7VRfZF65sU=",
            "cpf": "U2FsdGVkX1+DfKw1IzT7vgz7iFmzSA1flkA6zoy4kj4="
          }, {
            "num_cand": "U2FsdGVkX19DZaN5AZkUMkA26YVzJXfP24WyGWVySZA=",
            "cpf": "U2FsdGVkX19vrnIO+DGVtgqjNFuOxUH+zUYVKDPY3HU="
          }, {
            "num_cand": "U2FsdGVkX18o4rC+K61BlnGL47LJ+jgQZZiCocECxX8=",
            "cpf": "U2FsdGVkX1/cCxb0GtsrlTVeSrHgE6Gab6K85A5yQO8="
          }, {
            "num_cand": "U2FsdGVkX1+597KOrfGPhT+IPP4sukD9Thk6xicYhDA=",
            "cpf": "U2FsdGVkX1/rCJgk1cCRy/nvY7SD5x9NnNib0mnuGQw="
          }, {
            "num_cand": "U2FsdGVkX18qS2iS3rMEFUfQDkfMEyqQx1uPI6at2no=",
            "cpf": "U2FsdGVkX191/AvkXrWOYvX7KdOx62SsMFjYVBQ13BA="
          }, {
            "num_cand": "U2FsdGVkX1+QS/qnMEB+00lFfa70FVUJYol7dDiWApo=",
            "cpf": "U2FsdGVkX18vJcWlXWsZKNUz2GW3TiwTsW7Ucn74aGo="
          }, {
            "num_cand": "U2FsdGVkX1/0OCjG3ryh28F/ch/QkHxvTF1pk4bnll8=",
            "cpf": "U2FsdGVkX18vs61BzKMOLe0/Joro0NuwbSTq3ItCT98="
          }, {
            "num_cand": "U2FsdGVkX19FQXZWeFOJoa/zYxPa0SH3l/d90pmN1Gg=",
            "cpf": "U2FsdGVkX19/hHwCpDnUewTA3GSr5aEP4PnP5VsOwnM="
          }, {
            "num_cand": "U2FsdGVkX19oC4PgUn2ACYhgqXzj/+SWkXxS3vToViM=",
            "cpf": "U2FsdGVkX1/qPOkTXjkN1W2wpyt0c6sv7Qph1uu1jwI="
          }, {
            "num_cand": "U2FsdGVkX1/XL6ieQvBU9rbIF5AJHE+FRAZwiVGbmRg=",
            "cpf": "U2FsdGVkX1+i8Zii2qZ44Ij24E2VefS739zjHlfHq+0="
          }, {
            "num_cand": "U2FsdGVkX1+TkNht4NcNpmpk5vPPjn+uCWLv4G6AwMY=",
            "cpf": "U2FsdGVkX19sAhRCzgx7t5YeS6KjiNlx97wwwRITKrM="
          }, {
            "num_cand": "U2FsdGVkX1+4jJ40CIankqR3nSyd9kBYfNQ5ehCzJSg=",
            "cpf": "U2FsdGVkX1+WRFq7hhYmIDAVMNJqKvdx+kJ6gNYtGk4="
          }, {
            "num_cand": "U2FsdGVkX18CkdvUhTPWurQiKkBQ0dT77FnjKcYbgn8=",
            "cpf": "U2FsdGVkX18ZjZmZMrJRvcE6FalgJym+G6AH6W+AKAI="
          }, {
            "num_cand": "U2FsdGVkX19XiJbjmfQ7BxEmXYfTH8RPO8e7iQePSNk=",
            "cpf": "U2FsdGVkX1+Y5rkqeZKRDvslWy6gDpcjGA7+oDFR1vc="
          }, {
            "num_cand": "U2FsdGVkX180to/qhNJQH6APDX4yvM7Y3zsq+TzkdG0=",
            "cpf": "U2FsdGVkX18g1wNYa2JaB71z8bl+W3YVD/rWRCmLtSI="
          }, {
            "num_cand": "U2FsdGVkX1/kb0MUzD2wLwAYVm4E8JjL0P3WXiVwFKY=",
            "cpf": "U2FsdGVkX19Iko0q8b+FPbyMMiV+zF7yOJJqefqKmTo="
          }, {
            "num_cand": "U2FsdGVkX19cDyWVGGLgEM//NmAZsdm4vTHfVbO2BLw=",
            "cpf": "U2FsdGVkX19qbJb788vpQIzcKKRS+hHh9HryIhomjy8="
          }, {
            "num_cand": "U2FsdGVkX1/5liN4J+nC0iBofxyy7PRZiBUsi8RdP9s=",
            "cpf": "U2FsdGVkX1/0jLB5lOg9W+6dpFFwhHVaADnnumAfXtk="
          }, {
            "num_cand": "U2FsdGVkX18cWPNHlaY/BYnxc69yuDbQxQfKcHEyP7s=",
            "cpf": "U2FsdGVkX19zBQJjWAxKV+O7+5OEOs8B243cb+CuB3E="
          }, {
            "num_cand": "U2FsdGVkX1+RNh1jeXJUJ3WiaYBeL5F/Gf1G6n9q/Ik=",
            "cpf": "U2FsdGVkX18RNmD3shci5iCm7282Y/b3/Me9znPLwzw="
          }, {
            "num_cand": "U2FsdGVkX1/Zj2CshkU9vSIhZBy7qgHbWIpkL4ulWew=",
            "cpf": "U2FsdGVkX188ZslDtW05zBZ/yM8JG3beCUw6vdVZqLo="
          }, {
            "num_cand": "U2FsdGVkX18HZVaCS2zU0BZVmLGEkw3XhzlGIFplCf8=",
            "cpf": "U2FsdGVkX1+uWtCp8syH02loxIKzywxlf5B5M7Ifb9c="
          }, {
            "num_cand": "U2FsdGVkX1/Pd1mK6pnmvlHfXI9Vu4jHK1JkZr4X/qk=",
            "cpf": "U2FsdGVkX19U405pWzPPmTeqCZDoYfFj5Xmw2LktzVc="
          }, {
            "num_cand": "U2FsdGVkX19GufZfmxxOMc6HRXBDiQguIwaA7gyZYf0=",
            "cpf": "U2FsdGVkX1/o/OIN0hzpr9aE31U1FbRsa0wpLUncFds="
          }, {
            "num_cand": "U2FsdGVkX18lu9gER1rkJtDKKdcW1h3D9nyI4ncxOZo=",
            "cpf": "U2FsdGVkX19QwunRXckoXTnrUlUoP4axJ8+V9LWxSp4="
          }, {
            "num_cand": "U2FsdGVkX1+aaXuqKYVuYaHQL2MI+LpyZaRz9mQZP2w=",
            "cpf": "U2FsdGVkX1/0juUIv3OO8DY5Uwh9eL/nxt+ZLfCBjgM="
          }, {
            "num_cand": "U2FsdGVkX1+iPpwQ5giP/MUFJ3mFhlBHqRsawuaUjHY=",
            "cpf": "U2FsdGVkX1/7nCtHBmlxkOhR+rHrt7AuZUMBYcvtZfU="
          }, {
            "num_cand": "U2FsdGVkX1/dbpMEqLIJhqobDutKz7x7Leahv0gV8w8=",
            "cpf": "U2FsdGVkX18VH3A0mFMCBdTMdT47CviY2kvzWa87hxE="
          }, {
            "num_cand": "U2FsdGVkX18oLxhOcc08kBw8qgbT5znuehdYKw9yzm8=",
            "cpf": "U2FsdGVkX19moRSFyA0naqtEanSErCguBE3Uub0bszo="
          }, {
            "num_cand": "U2FsdGVkX1/xjlSP+nde5u6YBEBZqHvPtawC2dIV29E=",
            "cpf": "U2FsdGVkX19kZ9ncEdxujxwUYfezeHbGi5hGfBcTcIw="
          }, {
            "num_cand": "U2FsdGVkX18ZTtngtJSkrWt/9tZF4Im+eTgKl74TALE=",
            "cpf": "U2FsdGVkX1/HF7eZUdH8WChvmKH5lRaz8S0efbmFr4s="
          }, {
            "num_cand": "U2FsdGVkX1+N1GXW5+Q0W7NvA7ICYnAPBYDM5F8BTd0=",
            "cpf": "U2FsdGVkX19075K79XNZGN1HJPxLJe1ykTJilHrQSlM="
          }, {
            "num_cand": "U2FsdGVkX18ngZa5jWcRpj6s/QfxKYn0ERdAPA6Kl14=",
            "cpf": "U2FsdGVkX18iiDg0UF4plAnHFlysMQC5pEVAloEJcKU="
          }, {
            "num_cand": "U2FsdGVkX18wzn8hTaioyp3emqixo8sceM80W4Cxyr8=",
            "cpf": "U2FsdGVkX1/ygQE2FKWwXHF44xiLSlHzkeEdmOd1TQQ="
          }, {
            "num_cand": "U2FsdGVkX1+gqGfCY3RdUpJhU2iFheu87SA5lr12vFQ=",
            "cpf": "U2FsdGVkX19NXFnPMooaXOWZ+Gk4fxwf9lGoMKN/WQk="
          }, {
            "num_cand": "U2FsdGVkX1/VXm+xDSf9MojbGZrcG/0XbDD+F5LwZ6U=",
            "cpf": "U2FsdGVkX1/3pZAZkYC7rstQ5Lo5q3rviYnbWFuqH/c="
          }, {
            "num_cand": "U2FsdGVkX1/AtDPa3uQZ06AsMdHMvwEv717U0w8uOFE=",
            "cpf": "U2FsdGVkX1/zCTTRlq2ehnpNaVQQll+vab5tuWrh8mM="
          }, {
            "num_cand": "U2FsdGVkX18egO8UI+4TUjR7IoADNzKSGeCSpOFGDVM=",
            "cpf": "U2FsdGVkX19bA1sRDqfU8Nz64gMnqybx1lz8LQvdEcg="
          }, {
            "num_cand": "U2FsdGVkX18GpALndGfG0vRuInWE7uRJndwFRhOog5M=",
            "cpf": "U2FsdGVkX18b4WFDe2kIwV5ntjivCdRRm3M1N1dgOV8="
          }, {
            "num_cand": "U2FsdGVkX19FGg8W+U+L2FIgkN+IuZ1CFwDX8d+xkjg=",
            "cpf": "U2FsdGVkX1/ab1MWZm//2CEB2xwgbbizIkek/iM7pjM="
          }, {
            "num_cand": "U2FsdGVkX1/uO9OOKGW+YkTib6u0L9nWxclQ4oUHawA=",
            "cpf": "U2FsdGVkX18F5RnFlYRMS/vq43ksbYmkvT1apSjT/0o="
          }, {
            "num_cand": "U2FsdGVkX18ptOMRoTKGH53PnYS4TPvbwAD34klwbA4=",
            "cpf": "U2FsdGVkX19kD2YNQdvi6Lf5IQU+0t+ztiFHv6Gg0Nk="
          }, {
            "num_cand": "U2FsdGVkX1/AnSfdinbAhRVFIjQiC/xOPaeTHkJpXoM=",
            "cpf": "U2FsdGVkX193ZbODI3IP/RGMwfoz6ScUpBR/uhoRmiE="
          }, {
            "num_cand": "U2FsdGVkX1+aDvIgikBMYlDnEl194s7/9Zzu5UHVol0=",
            "cpf": "U2FsdGVkX1+7SiNzxzvdilFgpY8lZ87kF+xjXgviJWE="
          }, {
            "num_cand": "U2FsdGVkX19XcEf/4B/TtLY7eu+a660digipbgHwm3I=",
            "cpf": "U2FsdGVkX18CS8WmBuBQVOrcpcZOyj3rDtqoKNHiuBI="
          }, {
            "num_cand": "U2FsdGVkX18ZFqy6ZgQUB+hXh6eW+V5PtiBv4vO9jGs=",
            "cpf": "U2FsdGVkX18ETGmnu5xI2VZzeObaTYRWdx9FBRG6uc0="
          }, {
            "num_cand": "U2FsdGVkX19Hxbx0uA57MhhFQVwhWNR74u3FLoRDe8I=",
            "cpf": "U2FsdGVkX19yt1ZVtiKyObkdojkWWdR+u0dca8QU/XE="
          }, {
            "num_cand": "U2FsdGVkX1+qaHVhQx0rOfbaNDYmcs+vns7STRaZJL8=",
            "cpf": "U2FsdGVkX1+fxAAoy9JSX0AM+l1Bm9yqozhDqqBmrV4="
          }, {
            "num_cand": "U2FsdGVkX1/VjQ6Xuc6egwfQmep64Ct7aAmMpa5cj/0=",
            "cpf": "U2FsdGVkX1+eGEwgORjbHKwwQNtgrsR+4/qL6zWzV4U="
          }, {
            "num_cand": "U2FsdGVkX1/DguZC7rifx29GSPs/sTsFCcPiocTHZZ0=",
            "cpf": "U2FsdGVkX19zxbiJZXyojYMAfLCgsRTr1TfBCmvdcYs="
          }, {
            "num_cand": "U2FsdGVkX18zXl2YJf5K0/IX97/ANnxiYB+9zDheUHw=",
            "cpf": "U2FsdGVkX1+5ISNF7x9c+cbNJIFHdgf5FNzgDDftKzw="
          }, {
            "num_cand": "U2FsdGVkX192gUmblgqFgzhSxVSdRBm7AiJPhBsgLmc=",
            "cpf": "U2FsdGVkX18vVPFHkJU1bPu/oS8IzFmSCYbhA80bTu8="
          }, {
            "num_cand": "U2FsdGVkX19EFHy7sjCXMFXp6OMSytRpd2XBFVSl8Pw=",
            "cpf": "U2FsdGVkX1/zV04nUpdg3LgSo+l5zunT5peyOXQvsZw="
          }, {
            "num_cand": "U2FsdGVkX18BJGP6QrJqVOUgr95h7PFJFvgdzfZxAYs=",
            "cpf": "U2FsdGVkX1+vRQikrGWTGrpGlplEDtixQ9spjwbdtpw="
          }, {
            "num_cand": "U2FsdGVkX1/ChpVc4Bqbk7SWSnd/M0tDVp3RgIObpec=",
            "cpf": "U2FsdGVkX18UJcPcv07iLki84eXMoVIyKgqK+ocIKdc="
          }, {
            "num_cand": "U2FsdGVkX1+Wq5SX5WVEupAwO69pNyX/+R20cA2/2Eg=",
            "cpf": "U2FsdGVkX1/WNSL2LLj8ztMvdTqB9nJjGV6bEh41JIw="
          }, {
            "num_cand": "U2FsdGVkX1/cPry4TjHHtwYNNlAKWVcnXnjRjJ2HGuQ=",
            "cpf": "U2FsdGVkX1+H4ndceCQ+IG0WHH8auVwku3ANyonMRyU="
          }, {
            "num_cand": "U2FsdGVkX18zlSvPSN8N5cC8/R13uHxoBErj9Wf1D28=",
            "cpf": "U2FsdGVkX1/9igXekumXO08qhVVW9QZYIEujB5ByLiE="
          }, {
            "num_cand": "U2FsdGVkX18zglfob0V/JDzict02LnODvuVlibdXAJM=",
            "cpf": "U2FsdGVkX1+zcNPbP537v7c8WFfClbnADnywUiIg38I="
          }, {
            "num_cand": "U2FsdGVkX19BJatH+ceZZZ+WrgBF5I7i0eiHGxxdyrE=",
            "cpf": "U2FsdGVkX1/W6RsXtFFM5IG7k4YFaeGMlN+3nu4pS1Q="
          }, {
            "num_cand": "U2FsdGVkX1+e9XEkN+q629x1oN0MbohqDmS8LYb6yh0=",
            "cpf": "U2FsdGVkX19qY+QJQDPv6knlb5u6ghYGduQgftVicgA="
          }, {
            "num_cand": "U2FsdGVkX1+mjtQQheVAXvuDNvDmYNTsgbtnWZnv0SY=",
            "cpf": "U2FsdGVkX1+OlVb8cTpv4+zsB3KELRswZGdMRQcKt7Y="
          }, {
            "num_cand": "U2FsdGVkX19F7tjC3b0cTtmHFJC7IU7SNxMg2Fdt+C0=",
            "cpf": "U2FsdGVkX19lcu+XfFfnPs3oK07e56UobueYBSgDiV8="
          }, {
            "num_cand": "U2FsdGVkX190TrI4M+uM36Xoqd7RYcmCB8NceA+QD6w=",
            "cpf": "U2FsdGVkX18xYVS8ifOok3IeLMeiRHvU9j+fAfq4KpY="
          }, {
            "num_cand": "U2FsdGVkX1+PvJ2ze2haG0W7g0FaIHWvQD2qZLwaXCY=",
            "cpf": "U2FsdGVkX1/eZuFXZipjmj6gvah/6hQlX6DNyC0spkY="
          }, {
            "num_cand": "U2FsdGVkX19mUivfwQrWM/me6FMeEtbCREWqDsi+Yhg=",
            "cpf": "U2FsdGVkX19zZwpz1MxNg/3A6btFi1esyUE2CpR0bJc="
          }, {
            "num_cand": "U2FsdGVkX1+QeOzSFqLHTjSmkjV6WZBtzfaFouYH06s=",
            "cpf": "U2FsdGVkX194GUtFL3DvO0fvnyyeVaRHgaaT4EddSKI="
          }, {
            "num_cand": "U2FsdGVkX1/uij3EFELRBmqqjwfHewYGv1CRTsOi4iI=",
            "cpf": "U2FsdGVkX1/Z+EfwKVH4zDTYctPro5rfb+ukgn2ZamY="
          }, {
            "num_cand": "U2FsdGVkX1+JpUselQO1R3R4uUrCe5RsRHR5NbZ7OaY=",
            "cpf": "U2FsdGVkX19M4sUkbuvI9Syu1kWG+JpyWTDnHX/odao="
          }, {
            "num_cand": "U2FsdGVkX1/zkO2VJFRe2hP4NHBJZu34wZe2Szlhsas=",
            "cpf": "U2FsdGVkX19xa65p+OEX05m3Gj5bOBbtz8/KZesb/ks="
          }, {
            "num_cand": "U2FsdGVkX18h2Z0Q7c2ftqcW+5EFt9U2bhwTQLVI3EQ=",
            "cpf": "U2FsdGVkX188oCMku1v3Dt10II7KFv4E6PU7CqFtOzE="
          }, {
            "num_cand": "U2FsdGVkX19L6d1d/C+LRNz/cIL5QP77Wed+EGmI2Ic=",
            "cpf": "U2FsdGVkX1+mJub6ZJsDSVBzcTzvSG3JxYD/7Fs+zhQ="
          }, {
            "num_cand": "U2FsdGVkX1+f4QIEYg3uUZm9RKdD+oiJXl3DBrr2L2o=",
            "cpf": "U2FsdGVkX1/koPrxNgE+MiyTPNz9AaNMPOigP8EDxZI="
          }, {
            "num_cand": "U2FsdGVkX196h6Uex8TDEPRqtQS68q31JvF3EJxI/SU=",
            "cpf": "U2FsdGVkX18pSDfepT0sLhSC8/FnKtLtkqSTs1j1Vxk="
          }, {
            "num_cand": "U2FsdGVkX1+KSb0EjSb09NxxHe4uA/kqrvxm/6tQ4Ps=",
            "cpf": "U2FsdGVkX182fjAN1PGnHYo1WW/3tCCMQdQlqWlqNxA="
          }, {
            "num_cand": "U2FsdGVkX18KBKZvsmDRv+WhoG1z7lCZce6e4WX8i1c=",
            "cpf": "U2FsdGVkX199i5CzaaIoGjP1tS0ttG/QKdXEUrTMrXk="
          }, {
            "num_cand": "U2FsdGVkX1+cG9NNb7ggnO2syrj+ipwapj8lsH6Xzxc=",
            "cpf": "U2FsdGVkX19Nv2LWcUTkraQHTMH25z9Z0hRs+RQeQuc="
          }, {
            "num_cand": "U2FsdGVkX19LWZXZGRn5h18k8limIBtpXYMvVbQzRbM=",
            "cpf": "U2FsdGVkX19xBL8awHAK0wzjgrW/oNxr7UU3m5BLciY="
          }, {
            "num_cand": "U2FsdGVkX1+VInH6umQJvE40VL6vdJiyNXQ5UCK/+OA=",
            "cpf": "U2FsdGVkX18mZTyIrA/jvfKY3nsoA/7NA+yzCj1BLM0="
          }, {
            "num_cand": "U2FsdGVkX18Wdu67LZssD8p8gbmcgIXFMoDoYGkEfLo=",
            "cpf": "U2FsdGVkX1/UCRf4tTTwb01nybaD6mKRfdChaiTxRLg="
          }, {
            "num_cand": "U2FsdGVkX19ASZa82BUYd4xnEVrIh3TTY7Sw29B0m+M=",
            "cpf": "U2FsdGVkX1/kSN5/ytoyiC/NK3wOl19xiTxMCSH4MAU="
          }, {
            "num_cand": "U2FsdGVkX18LpDuRk76RXF4cfSvR+kFAkSwz/6oDdbM=",
            "cpf": "U2FsdGVkX18qK+Ee/m/PfEKjpl9Mk46wlrG8OsdN6OM="
          }, {
            "num_cand": "U2FsdGVkX19ThPA5voTUQbkfCo3YIsjNS8MRGMKYATo=",
            "cpf": "U2FsdGVkX1/f9IThompIWLZLGCn6T8mWapmV4bSmWv0="
          }, {
            "num_cand": "U2FsdGVkX1+pcj7uL6LJ1PySkmH22elCU+hCGMKGsCQ=",
            "cpf": "U2FsdGVkX19H8dUcXuTN3tFSmFdNUfNuZ9nt1TGZCvI="
          }, {
            "num_cand": "U2FsdGVkX18j8oWTfAHO9ixz0tjZt3ct2ytyhADAg2s=",
            "cpf": "U2FsdGVkX19BOWov8MsWEQ6iOaD54Vm2VXExGutjjYE="
          }, {
            "num_cand": "U2FsdGVkX1/OWvqpWzsbqjB9rsx2nlE4xpjZLzy7lR0=",
            "cpf": "U2FsdGVkX1+ZFyg/DQPKLYiNZkgM7UI/XUk27s1+pYY="
          }, {
            "num_cand": "U2FsdGVkX193M7z2AAmWcBhu/VETKAJTflAQKuLLipw=",
            "cpf": "U2FsdGVkX1+l02Gbe5OAZdtyNs8IcfsAp6E3k8Ea/34="
          }, {
            "num_cand": "U2FsdGVkX18GmlNBIbI2VuwHNFDuQdsBTvtp4MpGTq4=",
            "cpf": "U2FsdGVkX19Pt5UT/TsNNz1Nrs3Tud+ySiCXtsE+a9s="
          }, {
            "num_cand": "U2FsdGVkX19MZqin9Yct8PT4Oldv35VHSZ0CjxnLyfs=",
            "cpf": "U2FsdGVkX1/1gxMm4ea3nPZy4dI6BdawtXI1WOhvuYU="
          }, {
            "num_cand": "U2FsdGVkX188KjU1joHF35p+G3aOXV30T3OJvi5CNt0=",
            "cpf": "U2FsdGVkX1+S3btET2EyTLdptBK6hFCDIEHUj28WHtE="
          }, {
            "num_cand": "U2FsdGVkX1/Eito1/Tg3xpYH19CKYDLsfx1X/rVfgYc=",
            "cpf": "U2FsdGVkX18AnJUbTT3GXhfNA6Gyvek7aABTDWwS21U="
          }, {
            "num_cand": "U2FsdGVkX1+e+636PxBDs6r+vAwVfu4Huf7yfLuCgYg=",
            "cpf": "U2FsdGVkX18nRtSPjdaWXVf4UjbPOpkf+Gc6vbRrGnQ="
          }, {
            "num_cand": "U2FsdGVkX188OaoSskuvVnB+E/+LyKmYRD4rUVadkYQ=",
            "cpf": "U2FsdGVkX1+caOS2iUetq+rAD7plCvJDiZHl/QDo4rM="
          }, {
            "num_cand": "U2FsdGVkX1+7vJ+ujQ9lyjOrvWXpgovmUFE5wLUKDNU=",
            "cpf": "U2FsdGVkX19rg3+7YWSTSq+KKRAXfNvxzzLgmVAVt4c="
          }, {
            "num_cand": "U2FsdGVkX1+OUewfMqo4J+F+bIgDWYv4Ub3ywVRlwBc=",
            "cpf": "U2FsdGVkX19YSTFOApPVHBC+q8eKEhgS6EMWLzQT9mg="
          }, {
            "num_cand": "U2FsdGVkX1/gIXYsViCMHK0S2wdf+CGyoTQNtCZeMiU=",
            "cpf": "U2FsdGVkX19OLUtTBX6dNIJ+GJOowQuyR54nwbzTU9c="
          }, {
            "num_cand": "U2FsdGVkX1+94HHF9hpSFXozgIHkGhRLGFAdxFNKUe4=",
            "cpf": "U2FsdGVkX19MJcL8sR3kgca1QDeGuR1bXRT7YxdfTYg="
          }, {
            "num_cand": "U2FsdGVkX1+pG04wRiMpXiBzkMp5vCwgZ+Q241BdBxA=",
            "cpf": "U2FsdGVkX18AZc3h+rCANk7T2txVhX28ZUED2oevPqA="
          }, {
            "num_cand": "U2FsdGVkX1+nvLMhWpQFogiIfAC0v9KKRaGhY3SF9TU=",
            "cpf": "U2FsdGVkX1/OOsongtDCpgopEQHjW415zOxfvnD2o+k="
          }, {
            "num_cand": "U2FsdGVkX19jyDxmKCmayyD9DuqdftWn+PG2ptqPOcU=",
            "cpf": "U2FsdGVkX19M6iGlpMlWYUlTKl/kG24IgKJw4DdpDr4="
          }, {
            "num_cand": "U2FsdGVkX1+Mqejv0MBUBvtyCs9nWxvn0IpYI6ioChc=",
            "cpf": "U2FsdGVkX1+UHr2jNo5qwMR57sVUO5si4v1knmrxFTU="
          }, {
            "num_cand": "U2FsdGVkX1/wHTTDheN7Ex43qsWqyOyvkjLtVZak5us=",
            "cpf": "U2FsdGVkX1+qqq4ZIUU9oA09TgFDxUPke0XjbK0vcqw="
          }, {
            "num_cand": "U2FsdGVkX19rgyVULKOnFWgP9jAJTOpHynnld2Dgyfo=",
            "cpf": "U2FsdGVkX19FJCJTUPvHV9SkRQqZruPKZcj3gUy705g="
          }, {
            "num_cand": "U2FsdGVkX18v/WO6XS76gOSqv4XULA1x3PLSN2O/0uw=",
            "cpf": "U2FsdGVkX1+TBBEIClWL7r1D3s++WI7u+4D7uKAD+GU="
          }, {
            "num_cand": "U2FsdGVkX1+3V6rU2D9BY+KrAURLYPvikofwfBYbYxQ=",
            "cpf": "U2FsdGVkX1+ei77e9sQuYXxW+xDUKhHnwIrbGJlHXeg="
          }, {
            "num_cand": "U2FsdGVkX19wmJ5F0g+nWhlHMBzWb1v6P3HQMnPfsXk=",
            "cpf": "U2FsdGVkX1/ZVjtCHOA8mhuypbQz+ekEuwmcM8nzrkY="
          }, {
            "num_cand": "U2FsdGVkX19GOOrXAQ4bcS8oXYW4I5jpJlybTMCm4uY=",
            "cpf": "U2FsdGVkX18CcgoFCpNrNRDqtuHPf4aDcgfpNJ8tGfQ="
          }, {
            "num_cand": "U2FsdGVkX1+VguTe1EtTWltzK1M9tlnePV6v0z+CrIM=",
            "cpf": "U2FsdGVkX18xfTsSa45IhliT20Cco8Pin8UZ3Qrd53I="
          }, {
            "num_cand": "U2FsdGVkX18qkQcf4BT3/3g/deZk1RaL0PDKQ9zttWA=",
            "cpf": "U2FsdGVkX1++KC564pgWEANRfpGujf9u4E5b3KqSD9I="
          }, {
            "num_cand": "U2FsdGVkX1+3P8uYBQCC/6EdanESXr/t5dahvW8eiUQ=",
            "cpf": "U2FsdGVkX18c7fmzLpNvuJ9tBI/vSIRl8Ponm2GzcXY="
          }, {
            "num_cand": "U2FsdGVkX19Ve10vZa+M2FEoo6v5eNvzlkYOvLmsB/Y=",
            "cpf": "U2FsdGVkX18rTAKkboCt1yhNAzepgHe8K7S/5Ntxxdo="
          }, {
            "num_cand": "U2FsdGVkX1+JI5EC9kZt6IleHHeFnaGcJR+aA8Z6GZQ=",
            "cpf": "U2FsdGVkX18uWNHzUmQyM4tR4g5spbkPjrUZNEWLqfg="
          }, {
            "num_cand": "U2FsdGVkX19hfk4qY+nQh+jANlmrj/g4EG4CdpCvbbI=",
            "cpf": "U2FsdGVkX19jHZSOZM1sD1JF5Z90rgDIuomXnGcPF9Q="
          }, {
            "num_cand": "U2FsdGVkX1/m1yW2F3XpiosbihCSg2oaWpOZ4BJHM44=",
            "cpf": "U2FsdGVkX1+09jenO+SsP10BBZAYAR/w7/jCnkitRaE="
          }, {
            "num_cand": "U2FsdGVkX18gMsqIl1DGptaZLQJKubYgCdxtlnVtOIo=",
            "cpf": "U2FsdGVkX19bRl7RvzAcKP+uYv/Gxvi/OkvGd5wG8IQ="
          }, {
            "num_cand": "U2FsdGVkX19oTSP7V1dOf75LPxwQZ8DaEJUG2EE8Hyk=",
            "cpf": "U2FsdGVkX1+00lFKNxLq3mdOUXl4DyHMBUQfEuMws6U="
          }, {
            "num_cand": "U2FsdGVkX1+9Abwy55TUn6+mBhHva/gVKQ5Z26SU3z4=",
            "cpf": "U2FsdGVkX19t4zzj8LDfafDCGQWxNYYb+dkjNN4FVWM="
          }, {
            "num_cand": "U2FsdGVkX1+6NLP+P44sWMVA6bu5wAxiqQOEVbcoiXE=",
            "cpf": "U2FsdGVkX19FbwFvFAL1iV/7BBNeZvIkfrqTxva19lA="
          }, {
            "num_cand": "U2FsdGVkX19gkSmgaNJxtYoY5rKERuov/CUJAqQFRXY=",
            "cpf": "U2FsdGVkX1+yqhxps9X4d0SoCj1kc0wVw44rcpJrAuw="
          }, {
            "num_cand": "U2FsdGVkX18zgIIUJWMLRrS6cVRRyeAD/S8rl+iVfoQ=",
            "cpf": "U2FsdGVkX1/DJaoIYKjM0Zm15Vzn1Q4ESyqSfmkWDOE="
          }, {
            "num_cand": "U2FsdGVkX1+UpO/UelqTjGA41a2X+L4o5yyrmpn4esY=",
            "cpf": "U2FsdGVkX1+0IZX6HCF89IGcenRgFMOXPPDZ8YAUj/8="
          }, {
            "num_cand": "U2FsdGVkX1+WkMfEp3PZN2LbT91uO9mDDp5RUKl5/kk=",
            "cpf": "U2FsdGVkX1+QhppQy9a5uxJlrxtah+l9xWEsW2i+oKw="
          }, {
            "num_cand": "U2FsdGVkX1/iFeIBJ4MzkWWcSFeK6L79QCEVntQJhHw=",
            "cpf": "U2FsdGVkX18QeDPI2QHKmgJpHYpTXFCLk3PYsaqehgo="
          }, {
            "num_cand": "U2FsdGVkX1+3alKA3BvOi9Z0wtleuUh96wY9aMysve8=",
            "cpf": "U2FsdGVkX19YGOyQdEVtblH4UH7XPvqsKKJqG99tvxk="
          }, {
            "num_cand": "U2FsdGVkX1+/mmfSqoY00ZZu3AKLc5KNjvffcCJPa0o=",
            "cpf": "U2FsdGVkX1/xO3dnSlVyeFwvfxylj0iZTETjyDB4pT8="
          }, {
            "num_cand": "U2FsdGVkX1/6x4BqN7p+T7C38OYPQf70KEstiJppw48=",
            "cpf": "U2FsdGVkX1+ZYvqWavqLDT3c2lP/GuuPgOKd0j45jDU="
          }, {
            "num_cand": "U2FsdGVkX193Ke4kmijQZGD2rsDk2twQ3AXyezi984w=",
            "cpf": "U2FsdGVkX1/Tkj6LFjOmIYgJxGjOP+1POkgri1vvz3w="
          }, {
            "num_cand": "U2FsdGVkX1/JC1LTTkuA++46uoDv54tRoiROlqiIvXc=",
            "cpf": "U2FsdGVkX1+FicuAzr9xftbCPH39WqIBBlvg/GwhRHY="
          }, {
            "num_cand": "U2FsdGVkX183Rcg7w/4YjiYdIwmeLUfGAyXviciW0tk=",
            "cpf": "U2FsdGVkX19sKSe0KJ3oetkI/fw5YjCl+NTf1BtinqI="
          }, {
            "num_cand": "U2FsdGVkX1/5AIO4A2obOAmUC5s6xvjzVDgomShVgTw=",
            "cpf": "U2FsdGVkX192rl1ovK77JM1b1J7Wt6qHEYayBdDurBM="
          }, {
            "num_cand": "U2FsdGVkX19V6SVn2zRmsfUS3V7fdCs9pdP/3d2jF90=",
            "cpf": "U2FsdGVkX18lcFYZmGu3R3lFXV4NBVHPxSMNRXJFrTU="
          }, {
            "num_cand": "U2FsdGVkX1875ykxjq7ACd+WSljiVKmr/1RgYhzH9HY=",
            "cpf": "U2FsdGVkX1+Kmi4bi0bzaHUjXMfMcPTthERmRyc1OgY="
          }, {
            "num_cand": "U2FsdGVkX19cf56T0ZPp7BwvrjrWpWx5lfgEmPVLbz4=",
            "cpf": "U2FsdGVkX18rOOEK1pDAQI5zHZzDIhjawr6ImB4doko="
          }, {
            "num_cand": "U2FsdGVkX19/Vcq8r4gEXjVXH7ceA34KgkXGvzPkAjw=",
            "cpf": "U2FsdGVkX18W67euHvHProeJ6tvcR9dS5by6hLsUUgA="
          }, {
            "num_cand": "U2FsdGVkX18y67YT3K/b6AtsEstYowddPbhjMVxrgEQ=",
            "cpf": "U2FsdGVkX182WKGJWEQN7ERYDmYn043YV+OfYri9E30="
          }, {
            "num_cand": "U2FsdGVkX19wWT6EPgrucI4bC3OESqd7P9CHxjE+SJk=",
            "cpf": "U2FsdGVkX1/PyC3IadBac0ylWGZQOr1PsIhSxG1f4JU="
          }, {
            "num_cand": "U2FsdGVkX18fKStXJSmuSFgqk0Yc7MCpDNGfsMA3ryE=",
            "cpf": "U2FsdGVkX1+LWtBS5V6B2bVar5biSPo/EKcR61nMzlk="
          }, {
            "num_cand": "U2FsdGVkX18hLUWnHs1M2eE5qbnhFF+m7Ico3Ig13uI=",
            "cpf": "U2FsdGVkX1/pyDk9TvJTLZ/+1UMOY/vHYbgYUltEt4s="
          }, {
            "num_cand": "U2FsdGVkX1+F8/o1tS8hK3NibDcnlPpFhqgrZWS5nUI=",
            "cpf": "U2FsdGVkX1/g3yEklRNhFfVYwWzY4bT1nf0bV7OZH9A="
          }, {
            "num_cand": "U2FsdGVkX18BCHVCQCsheyljmmVRVKXVZSgKM8nrvQQ=",
            "cpf": "U2FsdGVkX194D9ojFJtSSuCuf9B3h76SnuUohMe/CXI="
          }, {
            "num_cand": "U2FsdGVkX1/VWvmjja0FDxy8cZ01FcIqT7+K8owZ1qs=",
            "cpf": "U2FsdGVkX19mHraR3NgfiuC797Y2gf5VPT+0QYSPiqA="
          }, {
            "num_cand": "U2FsdGVkX1/DGATDxlycEes2sCclLsKApQiIhWgr+CY=",
            "cpf": "U2FsdGVkX18oJYwvwQvUr6ZrpSdBQ45YG2o0igWCeqw="
          }, {
            "num_cand": "U2FsdGVkX1/OPgAtOAZH2tGep4TPkJamyZ+j/6YcHjE=",
            "cpf": "U2FsdGVkX18WelM1G3Hjv7J/7oGsc+pdrDOJbkVeDzI="
          }, {
            "num_cand": "U2FsdGVkX1+KsMx92EWuzEvWnt9YvzAy2MAG4gks2kw=",
            "cpf": "U2FsdGVkX1//lq2zW+YsD9exfHIzjgUSppraCeUk2aM="
          }, {
            "num_cand": "U2FsdGVkX1/9po944z8Jo37qbxNb1msYAvp8ASRzfKs=",
            "cpf": "U2FsdGVkX1/Vas0H1Kjm1P6wOdYDU2JVrK3QQ+0ACjo="
          }, {
            "num_cand": "U2FsdGVkX18eIG40hot2qXyTwtETYzCz6/nrQ5PiZB8=",
            "cpf": "U2FsdGVkX1/LBFlXGJeatdTXAAf2ZhAq6uMOiOXi588="
          }, {
            "num_cand": "U2FsdGVkX1+/OyLHF7bWSLDbNKWRbZ1Fuw8uQDJQSus=",
            "cpf": "U2FsdGVkX1/oPUi6ZYuR+NVxV3ZL1T/kl9QfrR4RWh4="
          }, {
            "num_cand": "U2FsdGVkX1+aWJqNz9y38jI2rzvycDYnQ/3DJ89wBrM=",
            "cpf": "U2FsdGVkX1+prRCnLHm9/Ua50Jlv9VbDihnst7XIqNQ="
          }, {
            "num_cand": "U2FsdGVkX1/uPFEHfDjrIF+nUP5JPdd8v8UIttjNzGI=",
            "cpf": "U2FsdGVkX1+aGW6AbvHEByfg2uklF/f+t+yI5qbDlmY="
          }, {
            "num_cand": "U2FsdGVkX197m5S7a4dOWkDwzuxttjTUJ74mXANePQ4=",
            "cpf": "U2FsdGVkX1/LW/O6ZeAUEA1jIPxcNMzaocR3OLUFuZY="
          }, {
            "num_cand": "U2FsdGVkX1/GA37WLdcVpzWu5DfvsHbIV6EkCQk/m+s=",
            "cpf": "U2FsdGVkX1+T9BvJpwXqk3OiOqVmFUU7JRxA4Z2m3oE="
          }, {
            "num_cand": "U2FsdGVkX1/c1gjtlDq+IlcYtgLI2n+K4UkGHgZGvTk=",
            "cpf": "U2FsdGVkX1+9oYBMie0ykgPi5bFuWghx0Xc518rIJp8="
          }, {
            "num_cand": "U2FsdGVkX1/PjRXjXIUNAY03rLDtRZDG8BBO2Y13DIE=",
            "cpf": "U2FsdGVkX1/sfcEx9uBFBD40LGG/Ci0aqIOESNSJZRk="
          }, {
            "num_cand": "U2FsdGVkX1/O2LHwr3gnL3zdU2fRjqcIRw7XClq/Urs=",
            "cpf": "U2FsdGVkX1/5xG93/Y5UPkOnFVycPxQFMfO9kfrWLPU="
          }, {
            "num_cand": "U2FsdGVkX1/mHv8JdWupaQE6PUPyJIiXuXyT07zp6wo=",
            "cpf": "U2FsdGVkX19mVKXxSKmFjZtdpnunt8g8GGd9KP5SoQk="
          }, {
            "num_cand": "U2FsdGVkX1/eGeBB/R4dhZtl9eLBdvzzpU7bGMCIm+w=",
            "cpf": "U2FsdGVkX19LOib8BeWcaC/VVTDuuQs+j22+SMUgUtw="
          }, {
            "num_cand": "U2FsdGVkX1/c/orgIsc3f/QWpmJAUtyQa1Ch+5TIRIY=",
            "cpf": "U2FsdGVkX19v7ajjNFgA8hz1rqHXeWJs8lhlVYz3dCQ="
          }, {
            "num_cand": "U2FsdGVkX190Iy+oBE9qzs3xOxSXG1Fs2fuMXkq0PrI=",
            "cpf": "U2FsdGVkX19avarUoaEbthrgXw3xjEIii4Uu1KHxu8c="
          }, {
            "num_cand": "U2FsdGVkX1/e8WeYxskSavI4Da7F3k+pOnrlKyiGrvk=",
            "cpf": "U2FsdGVkX1952PsPaUi64xQXX6+Wbh6ewaPn8nFjp7I="
          }, {
            "num_cand": "U2FsdGVkX19H8+WAWnFY3RFj75uBLlLa06PbQNOCpo4=",
            "cpf": "U2FsdGVkX18TuK8AnuI/GzunuEh7bViPuWCk1nkHLgo="
          }, {
            "num_cand": "U2FsdGVkX1/p2LCoAjIRTy7U/TSMXzXhJtDqiZ926sY=",
            "cpf": "U2FsdGVkX19CsxTcJUSo9BJ1z9ViijeKS4qeB31Q66M="
          }, {
            "num_cand": "U2FsdGVkX1/+oJ18XXjhuiSMetlvl+z1+9henyKS9sc=",
            "cpf": "U2FsdGVkX18RciMJtPiCms+tIzrsJ/TefsoGyDrtge8="
          }, {
            "num_cand": "U2FsdGVkX190psALiwppqqsVeaqkb0uzIaDoV+mObMA=",
            "cpf": "U2FsdGVkX19XKrOSoRIMYcbNYVD8WoqdfM6lcov/U/8="
          }, {
            "num_cand": "U2FsdGVkX1/NkdNoTOnWOP6YeLDmZy39oKtYw0kXEOo=",
            "cpf": "U2FsdGVkX1+SGzgQmmBP6pMeI2oxmv9vNIChlPvCbe8="
          }, {
            "num_cand": "U2FsdGVkX1/fWULhpIDr20JSntj9ZnYwlm/IvlALnY8=",
            "cpf": "U2FsdGVkX1+pzhM9AtkBcmLYdyu7NbjkGjpkuoLiwog="
          }, {
            "num_cand": "U2FsdGVkX18RWPPC9RkHRWbudy6HDjM/fZzPMABoZkA=",
            "cpf": "U2FsdGVkX18Iv+YmxHxFYX/avOY3TvAyBr/HnDbB79s="
          }, {
            "num_cand": "U2FsdGVkX1/nxOb7Gl9IW5bZ3MKz0vH1Cb1gJG1Ii3k=",
            "cpf": "U2FsdGVkX1+Xxftqnn/C6Jmm0Fsil6n3lhR2C1BOfW4="
          }, {
            "num_cand": "U2FsdGVkX1+I6fSbUXSFjuXyhSQVDNf4pLc+7PLb33A=",
            "cpf": "U2FsdGVkX19naVZ3SdrL/n8hSdpqtT3DiYW/Kr9ODVE="
          }, {
            "num_cand": "U2FsdGVkX18/49aIINJ0fFNoqm9wNR9peD9wstYoVjs=",
            "cpf": "U2FsdGVkX18ifKN+lzccd6hNh6l1SJahwuiDEMAahi4="
          }, {
            "num_cand": "U2FsdGVkX19n5msfswaHZDQ/285ppDjvQ5uVGCRMmVY=",
            "cpf": "U2FsdGVkX18OriQShdsVtfUxiQctrYupmmILBGS/MCc="
          }, {
            "num_cand": "U2FsdGVkX1/LF0+6ZJMYhR2Zna5J4L9tQ6DtPQVR6xA=",
            "cpf": "U2FsdGVkX19gam9xWnG9VZJQn74+dbiBOWDUj+ACqM4="
          }, {
            "num_cand": "U2FsdGVkX19vhHN+2Y88l6zCX2b/Eei60BoPx+SYCIo=",
            "cpf": "U2FsdGVkX1/YkpJ8cfpWHO/91Tke7iVxQzyjvHlr/dA="
          }, {
            "num_cand": "U2FsdGVkX19HrMt1BI4c6GGmHqF/4BBvW7Y99yCbGXQ=",
            "cpf": "U2FsdGVkX1+vrv4ZilHUwsAISKN15f9KLLQANKAbYsY="
          }, {
            "num_cand": "U2FsdGVkX1+jr+vCk/IIMzYxArqPlV94sI3AKedazP8=",
            "cpf": "U2FsdGVkX1/hnEikqbI0NWhDEHKUZdJSNWXJpmAvA8k="
          }, {
            "num_cand": "U2FsdGVkX1+nbVt2BfUBaGzajSVpphLNoXEAzAK6BSA=",
            "cpf": "U2FsdGVkX19eky6T7dEzMOylmDVQvPiKDPvsd2ic0Cg="
          }, {
            "num_cand": "U2FsdGVkX1/ZpSVuDlyGPW1C7D2lWO7I1Ccl3dhfttA=",
            "cpf": "U2FsdGVkX1/o4xwHit/fUNkzFnW78m3IQ6js62wMW6c="
          }, {
            "num_cand": "U2FsdGVkX191cDyX0DGkED6btCTFAf+xJuaNOpKqg3U=",
            "cpf": "U2FsdGVkX184JMDZgX8u+Jyv67lFKgqs4wjdyzfsGSU="
          }, {
            "num_cand": "U2FsdGVkX186YKd1o4Dx7PjbzjsQReLVgxdIA2/gGc4=",
            "cpf": "U2FsdGVkX19Th6fAu8IyxFnuczTMwbXWAW33r0buquU="
          }, {
            "num_cand": "U2FsdGVkX1+MFs21H+k4QzTXD0ocE1/9NegD2+ebUc4=",
            "cpf": "U2FsdGVkX18Yxvg7/UHYCTCHkjC7moGBjOnzwdmbJY4="
          }, {
            "num_cand": "U2FsdGVkX19qiW1xwLaFxiJUzQrH4Zt6QVh2Ffsjqtg=",
            "cpf": "U2FsdGVkX1/oIrz5q9MRg5zzss96uPTKnW4YOhuyiLk="
          }, {
            "num_cand": "U2FsdGVkX1+PQBS41o91yFWe/YWyyP/gHYYTl7geoIM=",
            "cpf": "U2FsdGVkX18H/PtwULwVWVaqOBO7jMGrJTXKYR7Lma8="
          }, {
            "num_cand": "U2FsdGVkX1/Eg8nzR8LjrZwh58CNszcq9MyZ7fPvPiM=",
            "cpf": "U2FsdGVkX1/2MF8q8Q1wF/ZWH6S5m1jj+9QWCjhs9lY="
          }, {
            "num_cand": "U2FsdGVkX1+Zo5L3Dv+/BrUTz69USVb1rgmnRMyZyM4=",
            "cpf": "U2FsdGVkX1/42zwaCCx4NdIcm75LtlYvylh72qeyaAk="
          }, {
            "num_cand": "U2FsdGVkX1+GzAN5jkaDzobSxk7K1/V0nergzVEtB/M=",
            "cpf": "U2FsdGVkX18pLtVHHcBEbhrSb/OjUiPU0qdL7eRLdmI="
          }, {
            "num_cand": "U2FsdGVkX1+RSopkh/3jhwgomMxERmbQOXxmyouBA98=",
            "cpf": "U2FsdGVkX1+2NKQgMT+K1GKuN+5MgOxK6oZnPbrYuxw="
          }, {
            "num_cand": "U2FsdGVkX1/d+Gc+t9iYbqJEKLlUFtoyGxx5GnMqxF0=",
            "cpf": "U2FsdGVkX1+VFU16TSN641C6gfmVUiJg7sOKTJEZNtA="
          }, {
            "num_cand": "U2FsdGVkX1+KjeiGwG8CmPxuDGpthXhUEF3xnCPvZzY=",
            "cpf": "U2FsdGVkX1/m6S/WM1m9fjVuvY3UTWb5Kft31FkvZWg="
          }, {
            "num_cand": "U2FsdGVkX18yqRJyRQLiHV+gh4X6m/Cus72r0PLJe7A=",
            "cpf": "U2FsdGVkX1+US6yWQyhiSmG+q1GvojEz4+qkeg+eV0k="
          }, {
            "num_cand": "U2FsdGVkX1+1IS8to2dKL63JmzfAwaSHDYo2U5kEl78=",
            "cpf": "U2FsdGVkX1/QisjkUIQolBHOoAe2aVUKG2meYL3EJGc="
          }, {
            "num_cand": "U2FsdGVkX18as3v884Dz6gCZGNXlnwQoY223cTG+EOE=",
            "cpf": "U2FsdGVkX1/eyVjWOzCqgVqTPbPYShpdohpvCGzjnNI="
          }, {
            "num_cand": "U2FsdGVkX188D+JiLIgx4yoVWNbnPo9RJF/3lm60crA=",
            "cpf": "U2FsdGVkX1/+k5Qd8/v0A3k4xiMk57H+FFfQX5I2blI="
          }, {
            "num_cand": "U2FsdGVkX1+Hl7Iykhn5jjSUxT4Gip/MW2WldrGQmk8=",
            "cpf": "U2FsdGVkX18fL5ue14+oDt9sesY71DaZWuxc+arJZtY="
          }, {
            "num_cand": "U2FsdGVkX191JF0sV5nDFeOEKnEcooNkyETMRjjSOKA=",
            "cpf": "U2FsdGVkX19dsiFQjswhUH2hMjJAhH1dGYMvzgoIUiU="
          }, {
            "num_cand": "U2FsdGVkX1/yB5eOoN+cJ4cxs2Sz3XuVgPEbRZVgGeI=",
            "cpf": "U2FsdGVkX18SP5FPWWc/lui/tGpXWxvQ90ctWhBsGhM="
          }, {
            "num_cand": "U2FsdGVkX1/yF9sF1S9YRkwrj8BL5ctZK6La3P/B/IE=",
            "cpf": "U2FsdGVkX19xgX5fjQUdK1PnHuAtWQRksRyGOJpGk3g="
          }, {
            "num_cand": "U2FsdGVkX19H9jkbMrC+uFHc1HTCTwZ5DicWhInj4QI=",
            "cpf": "U2FsdGVkX18fDfvJwaKIADKiFqpXMe2sNiSjfE76KLw="
          }, {
            "num_cand": "U2FsdGVkX1/YfrlihuRVsKLT8kgCmzlv5hk2QcZjjh4=",
            "cpf": "U2FsdGVkX1969pt26jXotN5Peoh1KiYJ0S6rAFGkOQg="
          }, {
            "num_cand": "U2FsdGVkX18v9IxqmsC6AbTPaOhE8pKIhZGVWe1hfMw=",
            "cpf": "U2FsdGVkX19skXF4uwFohrkPgVMOSPz5p69nwggG65M="
          }, {
            "num_cand": "U2FsdGVkX1/lxmaZ0hsU1ItIcKgpc7RbJu0KGppcawk=",
            "cpf": "U2FsdGVkX1/fFwcFqLnMpHZf2fDhDG4uxmvQ3L73W5o="
          }, {
            "num_cand": "U2FsdGVkX1/GnjZcsf19sPBTkgFRjA6EKoaRz/g/nDU=",
            "cpf": "U2FsdGVkX18XaijKWIhHit0BSRiP6Tzfvab+e10hbfc="
          }, {
            "num_cand": "U2FsdGVkX19JIQr85/dA4gMrE/Mi8O0/6BtBjbJtU7Y=",
            "cpf": "U2FsdGVkX18D6+caqJZ5+XU6LFed7lNk/HrphupWyRE="
          }, {
            "num_cand": "U2FsdGVkX1850aPno+949ip1cLWzifZ+RR3xsn0Geog=",
            "cpf": "U2FsdGVkX18NPncCf2lPss3hNKOyIStPZbD5rxVkisg="
          }, {
            "num_cand": "U2FsdGVkX195FFWn/GFeEW5sAD4Y8MRz4y3nyQMBHpE=",
            "cpf": "U2FsdGVkX1/hvgyqSqTNSGFxv31/jnp12ESo4zr5ydw="
          }, {
            "num_cand": "U2FsdGVkX19pTQZcourOhzVk7dJykoUOpkUzI3X8De0=",
            "cpf": "U2FsdGVkX1+XTUKYln00m0STj5wG54LGqQUaMXbpEYU="
          }, {
            "num_cand": "U2FsdGVkX18+p+z4nLRCT6J8qOYOLCuP4I1JFWXco+k=",
            "cpf": "U2FsdGVkX18Q/wFNiVmbXp+VFGd/BpoNqrHL48iqM90="
          }, {
            "num_cand": "U2FsdGVkX1+XsjHtotH/WjqZaB11sRzF9bprzSKI1zk=",
            "cpf": "U2FsdGVkX1+CQQ/uvt25MmbO+gKFBayodiYPIQD+e0Q="
          }, {
            "num_cand": "U2FsdGVkX1+o6lY0o1W0s2dVcjUmq73ps1blhgwtbNk=",
            "cpf": "U2FsdGVkX1+D0xiu+ZND9bZcwewbnvgMrAVDf8a480A="
          }, {
            "num_cand": "U2FsdGVkX18C7xKHboLo540vKTExkOl+CVqwI2B+E5A=",
            "cpf": "U2FsdGVkX1/7Mp/c/nrjJ55oHw/ITGzRcs2WcviVcWI="
          }, {
            "num_cand": "U2FsdGVkX1/WRaPtzGyctp5W8tckz/TeM/IFrAZ0gj8=",
            "cpf": "U2FsdGVkX19lxOsfTHJXHkMcr0RXGMQq6/XT452NIbI="
          }, {
            "num_cand": "U2FsdGVkX18snlrtj57yhVbuLZxHq5YnBV9DFImJkW8=",
            "cpf": "U2FsdGVkX1/dj6+GtoSFAhinwHMnl2VRThpDee41ClM="
          }, {
            "num_cand": "U2FsdGVkX1+P/9JSVJ3KQnNUQHZtf7E7EFeMpYCa354=",
            "cpf": "U2FsdGVkX1//+oy6fK99UDAICcuyHbAI9Eng4BHzwX0="
          }, {
            "num_cand": "U2FsdGVkX1/+Rhvo4fVLRCzpMlkVvoPdSvsQ5z9vgvM=",
            "cpf": "U2FsdGVkX1+HGtJei0JvPW/8m/ls5UjBlYW5ldmqhdo="
          }, {
            "num_cand": "U2FsdGVkX18fwQyslWJ7hxFihqfuk+TtCss/49qM/t4=",
            "cpf": "U2FsdGVkX1/H+GFoKZW5yavTRAuUukYuXy6XLR3qeUc="
          }, {
            "num_cand": "U2FsdGVkX19dt2RzugG3Z50d/ENVC5MqzRk834M8dSo=",
            "cpf": "U2FsdGVkX1/ycBRADv8gfviZYcMjAOGceISrAVwso/c="
          }, {
            "num_cand": "U2FsdGVkX1+MALbPVipEujrX4RNmTSUfDJNtdp+0OZQ=",
            "cpf": "U2FsdGVkX1+QiMWMeCZm3JvPRZ2ayBM34Ly3CyRvzao="
          }, {
            "num_cand": "U2FsdGVkX19IcAtI+3bGDuI04JMFfepH1VW+emkZKjg=",
            "cpf": "U2FsdGVkX1/x04SjTehG7bXz1gZpRCC2qmto2gzdGeM="
          }, {
            "num_cand": "U2FsdGVkX1/ny8lpjXH/Tt3P5Z8Wsou20aWVGO+FOuI=",
            "cpf": "U2FsdGVkX18LtsRUe+5Ve/8jE5kno8ERdaNUaZE4JXY="
          }, {
            "num_cand": "U2FsdGVkX18v6UjCOec/UgQki6RncNEoEdqDZNNdZn8=",
            "cpf": "U2FsdGVkX1/Iishr5XmR+Eu7iuxqiX+Ew6KhIQIgRuY="
          }, {
            "num_cand": "U2FsdGVkX19pGq22n9Z+pnczo+x2vzrq5H6d9cOZXaw=",
            "cpf": "U2FsdGVkX18DsE0dZuBc8XEowOC3gA8CfByDaqiEExs="
          }, {
            "num_cand": "U2FsdGVkX1+R4vFs06r18WWxbLUVh5+nWljCJqH5ST4=",
            "cpf": "U2FsdGVkX1/pOZBtgepUViX7QeEAyUKEq7ki6Pbtpzg="
          }, {
            "num_cand": "U2FsdGVkX1+zgFDriFct3/aOn7PF+hKrwybhL46Vc10=",
            "cpf": "U2FsdGVkX1/UPix5BzSxfKxABGqwK/3bAjFiexl2REM="
          }, {
            "num_cand": "U2FsdGVkX1/pIf7FBpAlDCXZs9nsjpLpYq7tSTUEYoc=",
            "cpf": "U2FsdGVkX19HXljLNs+Wx3KDSuhgDg/jLweqcS/ZnKs="
          }, {
            "num_cand": "U2FsdGVkX19QmpRGrKUdT/WycgYQqeKYzKe7U7rk8w4=",
            "cpf": "U2FsdGVkX1+2PrQUcsjWUnbGWKrKbYohP/2nOKOx4l4="
          }, {
            "num_cand": "U2FsdGVkX1+kzQgzNrlyMfy/L4U1AU9Le6kVKzBhiYI=",
            "cpf": "U2FsdGVkX18F+0jnG3ONDRvHXVp39yMedffMi10xmZA="
          }, {
            "num_cand": "U2FsdGVkX1/FU3SORO1lPV/SFrZXziZZYTVvekmoUPk=",
            "cpf": "U2FsdGVkX1+1qOwt1v463zWWBL2LLDlghXB3PusWQDU="
          }, {
            "num_cand": "U2FsdGVkX1+vGDIQt0/hnDIW62zSPDgufu/pfwcMC8A=",
            "cpf": "U2FsdGVkX19tHwUJVRGOfLIE+y9E1qTIg8H28dq0qrw="
          }, {
            "num_cand": "U2FsdGVkX1/cxAV0zUHKv7JAX6UX9pzi2YzUE/0ZNYw=",
            "cpf": "U2FsdGVkX18r/u364zbMn79VTppj/MlgrYvsCgjKvmc="
          }, {
            "num_cand": "U2FsdGVkX19VfOzjV0ETv+C8wmht8haGoLRkGxcxj70=",
            "cpf": "U2FsdGVkX1/x0ekZ6QDsassmS/+1m5UPikFyFbuBPqs="
          }, {
            "num_cand": "U2FsdGVkX18/pTlyQb5ZJx8xsF37C+ytsmc+jWQi0yQ=",
            "cpf": "U2FsdGVkX196b2r7IyPkM/0ZHrxQh2wWvUAA76nXMMs="
          }, {
            "num_cand": "U2FsdGVkX18fmguHa2vE01iEOuJOm2LJgT3s2hcXyns=",
            "cpf": "U2FsdGVkX19qXk63xw4KGgQQsy7J5DoalgkjFceaCWU="
          }, {
            "num_cand": "U2FsdGVkX19/ffpUEreyQXhlnGP0VyUYRd62CgolnMo=",
            "cpf": "U2FsdGVkX19Qc+fhtClhQArYuGScFzMATLs+4eSo1J4="
          }, {
            "num_cand": "U2FsdGVkX180iAErVqyqoUh5U2qmLxgVbICd8mt4EH0=",
            "cpf": "U2FsdGVkX1+Aanp1tmgzHcW0CHKmS94UNerLs+S1Qcw="
          }, {
            "num_cand": "U2FsdGVkX18rwr9fGVuR9mLD+avoN6afgQqj2CjoDyo=",
            "cpf": "U2FsdGVkX1+sf/kzg4Chj6DgzEuX0LrUjlwlsw5AKro="
          }, {
            "num_cand": "U2FsdGVkX1/DGFfwxPEFkkdj0bk/WFqFaz53YcwJC4A=",
            "cpf": "U2FsdGVkX1+bX8qDW5dLiDSjRPUqGhA0O1mPgqdkqZ8="
          }, {
            "num_cand": "U2FsdGVkX18346kcjVmj6XRQfBalegG5Wnk6QGtulUk=",
            "cpf": "U2FsdGVkX1+aA00I/s0u19Dl2Co//GezzgbGuU95FlA="
          }, {
            "num_cand": "U2FsdGVkX1+9XVIlg8yI8kY1zR9h6NJMp+9hR7yWa3Q=",
            "cpf": "U2FsdGVkX18glu3zitprYXoLt0IxCdjCgHo2v9j81+4="
          }, {
            "num_cand": "U2FsdGVkX1/UcSzQFrZfNRUv7aC1MvbhUtuunFTc5Co=",
            "cpf": "U2FsdGVkX18XAiJUbDyO6COHhSXOSCQn2hYCPYfisvI="
          }, {
            "num_cand": "U2FsdGVkX18IA7RxoAbiYsoimuf1Qrk05cHB3VHYROE=",
            "cpf": "U2FsdGVkX1/WZxPWZHLzUuaaQ92b0cAacE3v/M8EF/g="
          }, {
            "num_cand": "U2FsdGVkX19JJAXm7frC/Q9jXfO6zTYBEvN5rFPUSFo=",
            "cpf": "U2FsdGVkX1/I8d/Q1xfeJwzx4Do5t0oi3G6gQUBt8Y8="
          }, {
            "num_cand": "U2FsdGVkX19F73PjrUaDbqFy1SUn5LVG1re1+Cxk+SI=",
            "cpf": "U2FsdGVkX186Qlxqcb6GI3rZrmbg56rw+UV+GTkNfLA="
          }, {
            "num_cand": "U2FsdGVkX1+5cZpfsV2nYsYrtPQ42FhZaEQQycZyx9k=",
            "cpf": "U2FsdGVkX19ROvrCwAjvu0APyZFMx97it0pMX5Opjus="
          }, {
            "num_cand": "U2FsdGVkX19vo8NxFEmy9dPb4TOtXQc/ZMaHCJVwNHk=",
            "cpf": "U2FsdGVkX1++VPhnlpP+PjZiomTHO8yWQzqz0C+ZBOo="
          }, {
            "num_cand": "U2FsdGVkX1+/xJNstIc9QFx+YdpvJWvNuFsoKT08P3E=",
            "cpf": "U2FsdGVkX1/TM+K6bA8QWTB8rov23MLoGP/BDwTgQ0Y="
          }, {
            "num_cand": "U2FsdGVkX1/lgRSB+My5MCYSzVRYuPA1LzVLVpnkD0w=",
            "cpf": "U2FsdGVkX1902tT1WRs7hFVmk5DDV/AYJuQ8TtCovJ8="
          }, {
            "num_cand": "U2FsdGVkX18Al2kKRWeM2X366qkXnbeSeSSUmlUZGdI=",
            "cpf": "U2FsdGVkX19cqQ9m8EJ+0XgCDr28OJqM7DLltJGMDLg="
          }, {
            "num_cand": "U2FsdGVkX186e7fR6DlfFMcHdRKflMTEu82e563tcmk=",
            "cpf": "U2FsdGVkX19brlDFBmm/x40Z3/Yl9sZ++Dbs1hWyMIo="
          }, {
            "num_cand": "U2FsdGVkX1+BIiE/srVrGOM1XNWxaM9FaaG5RFURBC0=",
            "cpf": "U2FsdGVkX1//7XSoMQ/rpJ/iZM65VpHRqZ617tKzRp0="
          }, {
            "num_cand": "U2FsdGVkX18zbiTq/yHNLJ3Q4L6MhMNFl10YeVi7zvc=",
            "cpf": "U2FsdGVkX18OcgExTTr3g0QeDCTwymG4qgGzCB3LZ7M="
          }, {
            "num_cand": "U2FsdGVkX19Li6WrTA5hOvmMGX052uRWY0jB31PflDs=",
            "cpf": "U2FsdGVkX183HBjE76KanM0T5MgOs5I0RQfa3FJLsog="
          }, {
            "num_cand": "U2FsdGVkX19oLdSP/Z0VoWHbzk4ZlS3D3SIcpKMn+ug=",
            "cpf": "U2FsdGVkX183uH/NNMxKPEfdWCiSXxVzxPvRnRJFEH4="
          }, {
            "num_cand": "U2FsdGVkX19xfqLWhTYFZkLDbmdHWTSjo1aiAeemBdE=",
            "cpf": "U2FsdGVkX19LpB77vmSsukAkb64ReWPH5V6bS1O3ayI="
          }, {
            "num_cand": "U2FsdGVkX1+QoB0OiBRBzRciS9pe8VMr1THYH1mJbbA=",
            "cpf": "U2FsdGVkX19FGuEVHyscvN2jXkWDilG8dk+OUkAiZog="
          }, {
            "num_cand": "U2FsdGVkX18oaC1apHWNU0F0kmGSiIP/VmioVc+eogo=",
            "cpf": "U2FsdGVkX18rsKqmklQoaGvJfOr5EmIOFJ2cD/gCauo="
          }, {
            "num_cand": "U2FsdGVkX19aD6wwPzR4WcWx1r42WOEKVWlD/KLHMIo=",
            "cpf": "U2FsdGVkX1/2rzLJP2ZfunvJ2Qw8PmvbR6NBFSUz6tQ="
          }, {
            "num_cand": "U2FsdGVkX1+tYxOxbbbu1VlDqMOkt3jcj3hmDFI+VbE=",
            "cpf": "U2FsdGVkX19Um3yMIQs+P+1XebtxRWYWwzxZAR2rQTk="
          }, {
            "num_cand": "U2FsdGVkX1/cfGgj3sMef5FlmytR3SoTO/fI37zZn+c=",
            "cpf": "U2FsdGVkX1/hZQcIg5v3V9toeYbcipFde1btugjqSJ4="
          }, {
            "num_cand": "U2FsdGVkX18ctsXMiPdFRORydoKhT+uAo30QTSZ3V24=",
            "cpf": "U2FsdGVkX1+bIL/pLqYTwB9uvbqiBz70XyH72XPNpH4="
          }, {
            "num_cand": "U2FsdGVkX1+fm1Z3Etd8vDsZGJBBEXqLeGzkd97UplM=",
            "cpf": "U2FsdGVkX19hNsJr6pC3+BGOQsPbzNfYG49HCAmjqxA="
          }, {
            "num_cand": "U2FsdGVkX18GI4iM42k69BHdDWyDybC+vExWgv1/Ohw=",
            "cpf": "U2FsdGVkX19PI1bIxWXY3VIg2XS9ZRL/bVOzVt4/fZo="
          }, {
            "num_cand": "U2FsdGVkX1/DuzGpCmrsjjH/7QdTvFlk/K40RQW8IcQ=",
            "cpf": "U2FsdGVkX18YGZBg+k/+O5B0i+9RtjofBSCxGKeZmIc="
          }, {
            "num_cand": "U2FsdGVkX18eGqCCcrpNRHzly66G3GYYejl80Rdg61Q=",
            "cpf": "U2FsdGVkX1+JCU3+NuTq3xCFsAlW7WeCl+BoalITFFQ="
          }, {
            "num_cand": "U2FsdGVkX1+feSbOUFZ16QYUHzEhaMDDjIhNZtF+uQA=",
            "cpf": "U2FsdGVkX1+8T369Ara2AJF981HKYTJytWW5gN6zq5E="
          }, {
            "num_cand": "U2FsdGVkX1/eI+Jbt9GFBza+9f5utrr7TnmHfDsDH0Y=",
            "cpf": "U2FsdGVkX1+D4gwrBVQG3gJJJPjqRNFp/p1zj5BgHBk="
          }, {
            "num_cand": "U2FsdGVkX18ibSbPs0KxNydTQo8BdDlkR83xxqxL/mY=",
            "cpf": "U2FsdGVkX19Jq56Xf9iDlkAer6m+abKV3meY1JCrh6M="
          }, {
            "num_cand": "U2FsdGVkX1+HNGWaDt8c5Rh3l8OyGiSogrJVbT0s1bE=",
            "cpf": "U2FsdGVkX18wPl8mSbJ/jI6FaKR2Lbcer34ZpS1SMyk="
          }, {
            "num_cand": "U2FsdGVkX1+7AhdnDxp6QH/m/WYVkrf535tdMOPjea4=",
            "cpf": "U2FsdGVkX1/5ngUAn24FPhX5ykT2GTbYqr9xmYmPhNs="
          }, {
            "num_cand": "U2FsdGVkX1/8vM0guFloRHyb55B8i6w0SPv8aWzC+/Y=",
            "cpf": "U2FsdGVkX1+StL0b8Qe555LTAONenO5PEd6rjKax3eE="
          }, {
            "num_cand": "U2FsdGVkX1/B7SLL1Kaxdg95A7820nxOrKc8Od8+p/c=",
            "cpf": "U2FsdGVkX1+8HWtugJ2dqXm9qDxvLTF58ihgFl1G4+Y="
          }, {
            "num_cand": "U2FsdGVkX1/Z0XAHCvpkqoXH/zMKvbPI44l4K1mdXPg=",
            "cpf": "U2FsdGVkX18GU8KrkeL3Ro0bxoY61aNizgi9gWzwesk="
          }, {
            "num_cand": "U2FsdGVkX19pHHYJojJvV/8t609KMUuixiSEJJaS0tw=",
            "cpf": "U2FsdGVkX1/f8LPCOn5MQqgKSFZRgOj4KOD0ibHApKo="
          }, {
            "num_cand": "U2FsdGVkX1+Ldk+FU28LqsgnEaUftjypxkc/TqUHfoQ=",
            "cpf": "U2FsdGVkX1+lu3AsOJgO4VI+aTjSa3U+tvQfaj+eVwg="
          }, {
            "num_cand": "U2FsdGVkX1+DssD9Ycaye/fByXezOsZ209Fh8zMZ8i8=",
            "cpf": "U2FsdGVkX1+d6inPTK+im8pw7pDzPTuPyYh7CEE9/aU="
          }, {
            "num_cand": "U2FsdGVkX1/MFoHKIWnZFdkIww8Hs7lx9c60QEiaIyw=",
            "cpf": "U2FsdGVkX1+eYiQSDwr8wMuSDK0wb4ACxgf912bAO1c="
          }, {
            "num_cand": "U2FsdGVkX19zLDU+ANVBwIl+BcMMyBOk5GliA8p7Kug=",
            "cpf": "U2FsdGVkX1/ks7/fXQCTP9uuFRV6bRtAl4KAcWAyOl0="
          }, {
            "num_cand": "U2FsdGVkX19OIsLZYPRpbuqyqdfRqTBllDcEBurjon8=",
            "cpf": "U2FsdGVkX1//0soWlKb94Gb0Y7YkJ4w/RnDCLNJfdc8="
          }, {
            "num_cand": "U2FsdGVkX194ZdwiGDoAD0EgdyaVf5lzRRB1v+k3CLg=",
            "cpf": "U2FsdGVkX18DJ+/EJuljskm2f78UKWMpKVI6y6a16DY="
          }, {
            "num_cand": "U2FsdGVkX1/qIJeXHctS+07/GGRIRtRsl/KfVKoIfPY=",
            "cpf": "U2FsdGVkX1+sed4nnq2lO14hB6kJV/DgvHO+PRqC3ug="
          }, {
            "num_cand": "U2FsdGVkX19K+lUXA5dw4xIHJXkIXgzX/BSFvBpp9jk=",
            "cpf": "U2FsdGVkX1+Z0F9yr/t2DHicQXK31lNxAvXF4fSh5oc="
          }, {
            "num_cand": "U2FsdGVkX19OdWVPWIbSIvnyE2M1zPAAhkwVXG9Hcl0=",
            "cpf": "U2FsdGVkX1+TOomesvtMvEIHe3lIE9NwaeWWBr3Qrxs="
          }, {
            "num_cand": "U2FsdGVkX1+8WXP5pyJvD3dnJsc0QN+Fxm7JlRqTSoQ=",
            "cpf": "U2FsdGVkX18Dm5QWye9r+kNAZO9OVJy58CfNv8hBaNI="
          }, {
            "num_cand": "U2FsdGVkX19yh6+grnzBsHBHjaRiw02WgQGpDJm3RVs=",
            "cpf": "U2FsdGVkX1/udcV9ahDwIDwKj+QdT5WUlMvF2YThZ/Q="
          }, {
            "num_cand": "U2FsdGVkX18LHTjCtCx5SvKDbdJqCcL3ISM/ToIwM6c=",
            "cpf": "U2FsdGVkX18BGV0k9ESUrqgaYZhMI3sxawyQJPQnSWc="
          }, {
            "num_cand": "U2FsdGVkX18HDJqTVnkGu/wsJ/p2WUOnu4a8TFMQ6Ck=",
            "cpf": "U2FsdGVkX1/2wRifFDiJnYrtxOoaBinPrkVskHOe78Y="
          }, {
            "num_cand": "U2FsdGVkX19NaMRmgEovuIk/uVNhZJh0M88eqb3U6CE=",
            "cpf": "U2FsdGVkX1+hOIjX6iNpmu/FJwD4U8EW0+l9c4GiTcM="
          }, {
            "num_cand": "U2FsdGVkX18z2JXjaoTOl4I4VpM6ktAOaY3rLppeRuY=",
            "cpf": "U2FsdGVkX19GFWVd++UhCKKCgryBIs+GZ+JKmpasKqI="
          }, {
            "num_cand": "U2FsdGVkX18PCt+8aU75026LKhXoNKlBuzkdJnbI5XM=",
            "cpf": "U2FsdGVkX18i76GgCjRl9Z24wDq3vCzcFLOauDkcFTE="
          }, {
            "num_cand": "U2FsdGVkX19bKKYJRkEg7EMVM/r+mJMtEO2VwliUvcA=",
            "cpf": "U2FsdGVkX19OeSmXhzbc7E40JtztABhXaGsDNwy4xr4="
          }, {
            "num_cand": "U2FsdGVkX199lgrduSUmcciAsfY2Q7ahXgS3v0dseZc=",
            "cpf": "U2FsdGVkX1+Sarvu3jL08rjJjoGEgnDt9zynlxLGgb0="
          }, {
            "num_cand": "U2FsdGVkX19YTJbmQ+ZKlNdKuBgx0SQyfANuI4XfN5A=",
            "cpf": "U2FsdGVkX18bPI7aqC4x0YAtFu1jNnENBtN8hSstEO4="
          }, {
            "num_cand": "U2FsdGVkX19FXfyFvIOjwKjNHsMbUAsxJ11gFK6yJg4=",
            "cpf": "U2FsdGVkX19IzDBrFg0JlVReSyPQLgx3tyfmsrJ2yIk="
          }, {
            "num_cand": "U2FsdGVkX18NfzXctR1EK8DkjAIPpomH8p3nf0NsYLc=",
            "cpf": "U2FsdGVkX1+J3eaz8ZAyBz1bE6c2IqlXy+aRzfqsNf8="
          }, {
            "num_cand": "U2FsdGVkX1/AEiCTcr2JSuyAD2qtdinUR8QLAqKtqeA=",
            "cpf": "U2FsdGVkX18IHRH27EKxeliR9Y2doHIhEO6shYuDq5c="
          }, {
            "num_cand": "U2FsdGVkX1+MZRbt16wpqkrbGgtYLogszCy4UF2qXrw=",
            "cpf": "U2FsdGVkX1+cWCJfIdYkwJBw3ZwenJ/j6WzGRVcrm5o="
          }, {
            "num_cand": "U2FsdGVkX19Z9WFBXyv8+hP64TByTpFDhdeasr25yCA=",
            "cpf": "U2FsdGVkX1+ysfG4wVBVo6M/xD/edmxxRzsVDTLXA78="
          }, {
            "num_cand": "U2FsdGVkX1+24vc/dSFhHOv4j90dVUQff0ax7V+Ckrg=",
            "cpf": "U2FsdGVkX18tApRRMXGA2HDUg7OsysSB93EoEFt8jjs="
          }, {
            "num_cand": "U2FsdGVkX1/vDg7ADyMAogx6ozUMxHSeqyYmsXtGrSc=",
            "cpf": "U2FsdGVkX18BZeLKsACXABUcmRKK7X08z0N8uq/mbhc="
          }, {
            "num_cand": "U2FsdGVkX19lMf6lMKQUDUdN9EaiE9kM71T3kCWN8BY=",
            "cpf": "U2FsdGVkX18hDMZ1qBWgF7jMYsECZ561UUufwjo76y8="
          }, {
            "num_cand": "U2FsdGVkX18huXFAl62JGgFKITmYdz+zGqQgQtDm8EE=",
            "cpf": "U2FsdGVkX19d0aem1OrTqVLg+31ARQXYzJgr3dldXZE="
          }, {
            "num_cand": "U2FsdGVkX18mDl93D6PsdycFMeXFieupeLx6Ga6FjoI=",
            "cpf": "U2FsdGVkX18ofkNqXeGRfShavdc3ICi2ytO6IuFOemc="
          }, {
            "num_cand": "U2FsdGVkX18S0evOmJHV6O2QsE08aaW0ldcwZGxkUJI=",
            "cpf": "U2FsdGVkX1/cypQF5BemW6uUGR1zzPED1yCpEzsVCS8="
          }, {
            "num_cand": "U2FsdGVkX1/GIZvL2/hP9BPnrawBdp/U86bp03TXt6c=",
            "cpf": "U2FsdGVkX19OR8z5ZSoMsJ+balhlm9tfpV4j5z+5Iak="
          }, {
            "num_cand": "U2FsdGVkX1+dgPx9jZLbBfD+JIkj0e7+MqlvR0lWzSQ=",
            "cpf": "U2FsdGVkX18J4SUzpUD42bkgkr5sObybPfIVTpBIRfo="
          }, {
            "num_cand": "U2FsdGVkX18WcZEZM3aeaYLldMVU/ep6uagREyXV87U=",
            "cpf": "U2FsdGVkX1/4OLR9L1jk9RUqLqDbQG7jFdYCE+/XjYk="
          }, {
            "num_cand": "U2FsdGVkX1/59qbuRZgN5eBNLdyFAT+8Oxy4AJGouEQ=",
            "cpf": "U2FsdGVkX19MBpnWMDcjrfop6rAJy4N3+4Tf4k1pGzU="
          }, {
            "num_cand": "U2FsdGVkX1/iBSxx5f3gKUDkkz+CcJf8MDtDXDjnCMk=",
            "cpf": "U2FsdGVkX1+eq2n4mZ540GAar+xmW9JdBoKjfXMCMSQ="
          }, {
            "num_cand": "U2FsdGVkX18iq/Y0giHmdDv6Xrm4DBLMFnvbUpBC9a0=",
            "cpf": "U2FsdGVkX19Mwc+YrNsW3HGy1JZTr/1Nfr+Ula2PYV4="
          }, {
            "num_cand": "U2FsdGVkX1+KEU78tnz3mQAaDPDVyZL6YCu7idvnpWQ=",
            "cpf": "U2FsdGVkX18lBU9nKCohAF3L9jcYdjx9SK0Itf0z7NY="
          }, {
            "num_cand": "U2FsdGVkX19zOi0XwJfJRnCBqE4tIZpoNpFq+P1rKNk=",
            "cpf": "U2FsdGVkX1+FFawyr/rEJBVQJYbXOFD9nnhP1x7Ym+w="
          }, {
            "num_cand": "U2FsdGVkX19LLu/cCCswJ43cjZy6+bW+Sev0tzeibqk=",
            "cpf": "U2FsdGVkX1+GRbIwSOg8CFgw2AFyfwfjtCQ4npNtwok="
          }, {
            "num_cand": "U2FsdGVkX1+UuGhRjnVhtQvZOa5tWifRUGgXQqe8azY=",
            "cpf": "U2FsdGVkX19E6XNVs+yUZBFsfJBmpK3dMQXPJUJRS8A="
          }, {
            "num_cand": "U2FsdGVkX19gMzWeHjP5z1aRZnTsEt47ReuDNbBxDRw=",
            "cpf": "U2FsdGVkX1+if0VDnzudqg5UpK1tl/hfzWrxHzcYdkw="
          }, {
            "num_cand": "U2FsdGVkX19rpLi7cUHRBEdPj5GWYHAwaO5RAesb3Yg=",
            "cpf": "U2FsdGVkX19347DlBp0EzmcMuN9VA+0CMwcqr2mvjEM="
          }, {
            "num_cand": "U2FsdGVkX1/RHxj5kqR+lS1BCqN+A9XnDNoHqxygpEE=",
            "cpf": "U2FsdGVkX1+nMv/ZJV4KJxRgSib76mEkFdILsaHTx1o="
          }, {
            "num_cand": "U2FsdGVkX1++HnJyau98CH+uLcZ1Os7jVZrJwfltjjw=",
            "cpf": "U2FsdGVkX1++AgjiOeVy/0Cgs4j52oDk198wSfdHSqA="
          }, {
            "num_cand": "U2FsdGVkX18Z8FCVBOmAzbWeC3vxx2tIJMbGPz1cVmQ=",
            "cpf": "U2FsdGVkX1/ZUKQKtCpRurRFOlE4GEGphthMV4JBN3o="
          }, {
            "num_cand": "U2FsdGVkX18UwVyiqzqfpbDFPXLOdJggnGQDuDnQILQ=",
            "cpf": "U2FsdGVkX1/v5ZhUK1B/4YmYxs8UUhY04LUKmCOLwdY="
          }, {
            "num_cand": "U2FsdGVkX19wdf9kwZFwSCvpzj25Horwl2azAC7d2a0=",
            "cpf": "U2FsdGVkX1+ZXN6I4skQimk5PBjZCS3jqdoHhoB4PqE="
          }, {
            "num_cand": "U2FsdGVkX1+kwF8yd7YLW84vP2OTrOSnLeQCtRvaSQg=",
            "cpf": "U2FsdGVkX19TQZqpS2vCZReXMNEP3BqTLx2Ky2WARS8="
          }, {
            "num_cand": "U2FsdGVkX18mw4RH5CyhmkLmrgWIyR6eB643OmwLiqI=",
            "cpf": "U2FsdGVkX18I0/ANwb7/oRpSUS4Bybo0lRrFtHxRf78="
          }, {
            "num_cand": "U2FsdGVkX1+s22w06wgyGEPgcZeklS5rNLwKyALoRpg=",
            "cpf": "U2FsdGVkX182ZEyjJn+f7EjZTPe3LorURMqjgnDEL08="
          }, {
            "num_cand": "U2FsdGVkX191iNN+N+482aWjyBO+OjoMhA7E0D+Ic98=",
            "cpf": "U2FsdGVkX190sws07rgqjkIQpuo03t3/Wc3ppI90Afo="
          }, {
            "num_cand": "U2FsdGVkX18fHhFGwoE2Xpb8GJlYfijZ1plj/Ki8NRs=",
            "cpf": "U2FsdGVkX1+Lv8HIJ+pYwvPbhbm/m2D0BnWC3icA5DE="
          }, {
            "num_cand": "U2FsdGVkX19SEQ7f+gec8d4c4GAHb9wYGpCLvQQQVNo=",
            "cpf": "U2FsdGVkX1+MO1I1FSjo+d79h+eYQA9FIs4PfNYivnE="
          }, {
            "num_cand": "U2FsdGVkX18L8obCNnmYdNc7Sxixd9VHZl6rxNlplyk=",
            "cpf": "U2FsdGVkX1+n02nB8cDH/007wEmLic4kGyRiEi4vMGc="
          }, {
            "num_cand": "U2FsdGVkX19YvaY6vjJI6wwdEJGLuuU497Ko/uwVe1k=",
            "cpf": "U2FsdGVkX19sfOkamWTbR7N7g/mTPqF48dPZqL/DBSE="
          }, {
            "num_cand": "U2FsdGVkX1+7K9aXSsxun+44+FNx/p/WsFy8cBho+gE=",
            "cpf": "U2FsdGVkX19iNPX4i6Cm9msLhLQiw0GsKQOpu8P4GWU="
          }, {
            "num_cand": "U2FsdGVkX1+yFZkGgas692IKFuwWueYt136BP/AUilY=",
            "cpf": "U2FsdGVkX1/8INAH0QJh1W8IvYKM4zZDEhk+Cm7DJPU="
          }, {
            "num_cand": "U2FsdGVkX186TJzhvJNaSd5+E85L8fLaIrWMYNfsf+I=",
            "cpf": "U2FsdGVkX1+GAg6kf2APfn/L3sET0Pwbc68gjHSaAcg="
          }]

      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2211/rec_gab/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
